const resources = {
  en: {
    translation: {
      ingredientCategories: {
        protein: "Protein",
        carb: "Carbohydrate",
        oil: "Oil & Fat",
        prebiotic: "Prebiotic",
        probiotic: "Probiotic",
        superfood: "Superfood",
        mineral: "Mineral",
        amino: "Amino Acid",
        botanical: "Botanical",
        premix: "Vitamin & Mineral Premix",
        other: "Other",
        showLess: "− Less",
        more: "more",
      },
      ingredients: {
        // Primary proteins
        beef: "Beef",
        rabbit: "Rabbit",
        duck: "Duck",
        lamb: "Lamb",
        turkey: "Turkey",
        whitefish: "Whitefish",
        // Freshly prepared / meal / dehydrated
        freshly_prepared_beef: "Freshly Prepared Beef",
        beef_meal: "Beef Meal",
        dehydrated_beef_protein: "Dehydrated Beef Protein",
        freshly_prepared_rabbit: "Freshly Prepared Rabbit",
        rabbit_meal: "Rabbit Meal",
        dehydrated_rabbit_protein: "Dehydrated Rabbit Protein",
        freshly_prepared_turkey: "Freshly Prepared Turkey",
        turkey_meal: "Turkey Meal",
        dehydrated_turkey_protein: "Dehydrated Turkey Protein",
        freshly_prepared_duck: "Freshly Prepared Duck",
        duck_meal: "Duck Meal",
        dehydrated_duck_protein: "Dehydrated Duck Protein",
        freshly_prepared_whitefish: "Freshly Prepared Whitefish",
        whitefish_meal: "Whitefish Meal",
        dehydrated_whitefish_protein: "Dehydrated Whitefish Protein",
        freshly_prepared_lamb: "Freshly Prepared Lamb",
        lamb_meal: "Lamb Meal",
        dehydrated_lamb_protein: "Dehydrated Lamb Protein",
        // Carbs & fibres
        beef_broth: "Beef Broth",
        lamb_broth: "Lamb Broth",
        rabbit_broth: "Rabbit Broth",
        turkey_broth: "Turkey Broth",
        whitefish_broth: "Whitefish Broth",
        potato_flour: "Potato Flour",
        tapioca: "Tapioca",
        pumpkin: "Pumpkin",
        dried_cellulose_fibre: "Dried Cellulose Fibre",
        // Oils & fats
        salmon_oil: "Salmon Oil",
        flaxseed: "Flaxseed",
        // Yeasts & probiotics
        dried_brewers_yeast: "Dried Brewer's Yeast",
        probiotics: "Probiotics",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        // Superfoods
        spinach: "Spinach",
        blueberry: "Blueberry",
        kelp_powder: "Kelp Powder",
        // Prebiotics
        chicory_root: "Chicory Root",
        inulin: "Inulin",
        fos: "FOS (Fructooligosaccharides)",
        mos: "MOS (Mannanoligosaccharides)",
        yeast_β_glucans: "Yeast β-Glucans",
        // Minerals
        dicalcium_phosphate: "Dicalcium Phosphate",
        potassium_chloride: "Potassium Chloride",
        sodium_phosphate: "Sodium Phosphate",
        // Amino acids
        dl_methionine: "DL-Methionine",
        taurine: "Taurine",
        l_carnitine: "L-Carnitine",
        // Botanicals
        cranberry_extract: "Cranberry Extract",
        yucca_schidigera_extract: "Yucca Schidigera Extract",
        "turmeric_&_ginger_extracts": "Turmeric & Ginger Extracts",
        "rosemary_&_green_tea_extracts": "Rosemary & Green Tea Extracts",
        // Premix
        "vitamin_&_mineral_premix": "Vitamin & Mineral Premix",
      },
      home: {
        heroTitle1: "Science-Formulated.",
        heroTitle2: "Pure Protein.",
        heroTitle3: "Functional Health.",
        heroSubtext:
          "Premium single-protein pet nutrition engineered through structured formulation systems to support digestive clarity, metabolic balance, and long-term vitality.",
        viewProducts: "Explore Our Formulas",
        becomeDistibutor: "Become a Distributor",
        noChickenTitle: "Strictly No Chicken. No Chicken By-Products.",
        noChickenSubtitle: "Always Single-Protein – Our Core Promise",
        noChickenText:
          "Every GENOYA formula uses one pure, named animal protein source only. No mixed proteins. No chicken. No chicken by-products. This single-protein philosophy delivers precision nutrition, better digestibility, and clearer allergy management for pets worldwide.",
        // Introduction Section
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ is a science-formulated premium pet nutrition brand built on a strict single-protein philosophy.",
        introPoint1: "Nutritional precision",
        introPoint2: "Digestive clarity",
        introPoint3: "Reduced dietary complexity",
        introPoint4: "Functional health optimization",
        introFooter:
          "We design structured nutrition systems — not trend-based products.",

        // Core Differentiators
        diffTitle: "Core Differentiators",
        diff1Title: "Single-Animal Protein Architecture",
        diff1Desc:
          "Every formula is built around one clearly defined primary animal protein source.",
        diff2Title: "Grain-Free Formulation",
        diff2Desc:
          "Balanced macronutrient structure without unnecessary fillers.",
        diff3Title: "No Chicken Policy",
        diff3Desc:
          "Strict protein purity standard across all SKUs. No chicken or chicken-by-products.",
        diff4Title: "Functional Integration",
        diff4Desc:
          "Prebiotics, probiotics, joint-support compounds, and optimized omega balance.",

        // Science Section
        scienceTitle: "Built on Research. Structured for Performance.",
        scienceLead: "GENOYA™ formulations are engineered using:",
        sciencePoint1: "Controlled protein-to-fat ratios",
        sciencePoint2: "Balanced Omega 3 & 6 profiles",
        sciencePoint3: "FOS & MOS prebiotic systems",
        sciencePoint4: "β-Glucans for immune support",
        sciencePoint5: "Glucosamine & Chondroitin for joint integrity",
        sciencePoint6: "Taurine and L-Carnitine where functionally required",
        scienceFooter:
          "Every ingredient serves a defined purpose. Every percentage follows formulation logic.",

        // Product Preview
        previewTitle: "Formula Overview",
        previewCats: "Cats",
        previewDogs: "Dogs",
        previewKitten: "Kitten",
        previewAdult: "Adult",
        previewSterilised: "Adult Sterilised",
        previewPuppy: "Puppy",
        previewSmallBreed: "Adult Small Breed",
        previewAllBreeds: "Adult (All Breeds)",

        // Distributor Section
        distributorHeading: "Global Distribution Opportunities",
        distributorSubtext:
          "GENOYA™ is expanding through structured international partnerships. We support 20DC, 40HC, and 45ft containers with export-ready documentation.",
        getStarted: "Partner With GENOYA™",
      },
      about: {
        heroTitle1: "Precision Nutrition",
        heroTitle2: "Global Vision",
        heroSubtext:
          "GENOYA™ is a science-focused brand engineering premium pet nutrition using systems built on single-protein clarity and functional health performance.",
        viewProducts: "View All Formulas",
        missionTitle: "Our Mission",
        missionText:
          "To engineer premium pet nutrition using science-backed formulation systems built on single-protein clarity and functional health performance.",
        valuesTitle: "Our Principles",
        value1: "Protein Purity",
        value1subtext: "Single-animal protein architecture across all SKUs.",
        value2: "Nutritional Integrity",
        value2subtext:
          "Structured formulas aligned with recognized nutritional frameworks.",
        value3: "Functional Health Focus",
        value3subtext:
          "Digestive support, joint integrity, immune balance, and metabolic optimization.",
        value4: "No Chicken. No Chicken By-Products.",
        value4subtext: "A non-negotiable GENOYA™ brand standard.",
        viewOurProducts: "Explore Products",
        leadershipTitle: "Expertise & Positioning",
        leadershipHeadText: " is built by professionals with experience in:",
        leadershipValue1: "International pet food trade",
        leadershipValue2: "OEM production oversight",
        leadershipValue3: "Brand architecture development",
        leadershipValue4: "Distribution scaling",
        leadershipValue5: "Regulatory-aligned labeling systems",
        leadershipTextBelow:
          "operates through structured production facilities in China under controlled formulation and quality oversight systems designed for international distribution.",
        leadershipTextFinal:
          "We build structured brands designed for long-term global growth.",
        noChickenTitle: "Strictly No Chicken. No Chicken By-Products.",
        noChickenSubtitle:
          "Always Single-Protein – Our Foundational Commitment",
        noChickenText:
          "GENOYA® never uses chicken or chicken by-products in any formula. We are built on a strict single-protein philosophy: one pure, named animal source per product. This ensures better digestibility, clearer allergy management, and unmatched transparency for pet parents worldwide.",
        complianceTitle: "Nutritional Compliance Statement",
        complianceText:
          "Formulated to meet the nutritional levels established by recognized international pet food standards, including AAFCO (Association of American Feed Control Officials) nutrient profiles and FEDIAF (European Pet Food Industry Federation) guidelines for the respective life stage.",
        complianceBold:
          "Our products are complete and balanced for All life stages.",
      },
      products: {
        // Hero / page title
        heroTitle: "Advanced Single-Protein Formulas",
        heroSubtext:
          "Precision nutrition with single-animal protein sources, tailored by species, life stage, and functional health goals.",
        //Selector Verbage
        selectSpecies: "Select Your Pet's Species",
        backToSpecies: "Back to Species Selection",
        noProductsAvailable: "No products found for this category.",
        // Filter UI
        filter: "Filter",
        clearFilters: "Clear Filters",
        resetFilters: "Reset All",
        format: "Product Format",
        allFormats: "All Formats",
        formats: {
          dry: "Dry Food",
          wet: "Wet Food",
        },
        dryKibble: "Dry Kibble",
        wetFood: "Wet Food",
        ingredient: "Primary Protein",
        allIngredients: "All Proteins",

        lifeStage: "Life Stage",
        allStages: "All Stages",

        healthGoal: "Functional Goal",
        allGoals: "All Goals",
        healthBenefits: "Health Benefits",

        noResults: "No formulas found matching your criteria.",

        // Card / modal UI
        details: "Formula Details",
        showLess: "Show Less",
        collapseAll: "Collapse All",

        // Product attributes / labels
        size: "Net Content",
        ingredients: "Ingredients",
        fullIngredients: "Full Composition",
        standard: "Manufacturing Standard",
        packaging: "Packaging Type",
        aboutProduct: "CHARACTERISTICS",
        ingredientsLabel: "INGREDIENTS (COMPOSITION)",
        analysisLabel: "GUARANTEED ANALYSIS (when available)",

        // Categories
        categories: {
          cat: "Cat Nutrition",
          cats: "Cat Nutrition",
          dog: "Dog Nutrition",
          dogs: "Dog Nutrition",
        },

        // Life stages (exact match to your data)
        stages: {
          adult: "Adult",
          adult_small_breed: "Small Breed Adult",
          sterilised: "Sterilised",
          dog: {
            junior: "Puppy",
          },
          cat: {
            junior: "Kitten",
          },
        },
        sizeCategory: "Size / Breed",
        allSizes: "All Sizes",
        sizes: {
          allBreeds: "All Breeds",
          smallBreed: "Small Breed",
          "all-breeds": "All Breeds",
          "small-breed": "Small Breed",
          mediumBreed: "Medium Breed",
          largeBreed: "Large Breed",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        // Health goals – exact match to healthGoals array in JSON
        healthGoals: {
          digestion: "Digestive Health",
          skin: "Skin & Coat Nutrition",
          immune: "Immune System Support",
          antioxidant: "Antioxidant Defense",
          muscle: "Muscle Maintenance",
          joint: "Joint Support",
          weight: "Weight Management",
          urinary: "Urinary Tract Health",
          brain: "Brain & Cognitive Health",
          bone: "Bone & Joint Development",
        },
        goals: {
          digestion: "Digestive Health",
          skin: "Skin & Coat Nutrition",
          weight: "Weight Management",
          urinary: "Urinary Tract Health",
          immune: "Immune Support",
          antioxidant: "Antioxidant Protection",
          muscle: "Muscle Maintenance",
          joint: "Joint Support",
        },
        // Flavors / primary proteins (current products only)
        flavors: {
          beef: "Beef",
          duck: "Duck",
          lamb: "Lamb",
          rabbit: "Rabbit",
          turkey: "Turkey",
          whitefish: "Whitefish",
        },

        // Textures (matches textureKey values)
        textures: {
          kibble: "Dry Kibble",
          "chunks in jelly": "Chunks in Jelly",
        },

        // Product lines (exact match to lineKey)
        linekey: {
          dailyCare: "Daily Care",
          superfoodPlus: "Superfood+",
        },

        animals: {
          dog: "Dog",
          cat: "Cat",
        },

        // Dynamic short description template
        description:
          "A premium {{flavor}} single-protein recipe in {{texture}} format, designed for {{animal}} at the {{stage}} life stage.",

        // Fallback texts used in ProductCard
        types: {
          dry: "Dry",
          wet: "Wet",
        },

        singleProtein: "single-protein",
        grainFree: "grain-free",
        premiumCompleteFood: "Premium complete & balanced food",

        frontView: "Front view",
        backView: "Back view",

        feedingGuideNotAvailable:
          "Feeding guide not available for this product.",

        // UI buttons & sections
        technicalSpecs: "Technical Specifications",
        keyBenefits: "Key Functional Benefits",
        analyticalConstituents: "Analytical Constituents",
        feedingGuide: "Feeding Guide",
        functionalIngredients: "Functional Ingredients & Additives",
        petWeight: "Pet Weight",
        gramsPerDay: "Grams per Day",
        viewBack: "View Back Label",
        viewFront: "View Front Label",
        clickToZoom: "Click image to zoom",

        // Analysis keys (expand when you add guaranteed analysis data)
        analysis: {
          protein: "Crude Protein",
          fat: "Crude Fat",
          fiber: "Crude Fiber",
          ash: "Crude Ash",
          omega3: "Omega-3",
          omega6: "Omega-6",
          // moisture, calcium, phosphorus, etc. can be added later
        },

        // Extra labels for expanded view
        netContentLabel: "Net Content",
        packagingTypeLabel: "Packaging",
        standardLabel: "Standard",
        pillarNoChicken:
          "Strictly No Chicken. No Chicken By-Products. Always Single-Protein.",
        noChickenTitle: "Our Core Promise",
        noChickenText:
          "GENOYA® never uses chicken or chicken by-products. Every formula is built on one pure animal protein source – complete & balanced for the life stage.",
        filterReinforce:
          "All formulas are Complete & Balanced – Strictly No Chicken / Always Single-Protein",
        complianceTitle: "Nutritional Compliance",
        complianceText:
          "Formulated to meet the nutritional levels established by recognized international pet food standards, including AAFCO nutrient profiles and FEDIAF guidelines for the respective life stage.",
        completeBalanced: "Complete & Balanced",
        nutritionalAdequacyTitle: "Nutritional Adequacy Statement",
        nutritionalAdequacyText:
          "Formulated in alignment with recognized AAFCO and FEDIAF nutrient profile guidelines for the intended life stage. Nutritional adequacy is based on formulation analysis.",
        regulatoryDisclaimer:
          "AAFCO and FEDIAF are regulatory guideline organizations. GENOYA™️ products are not approved or certified by these organizations.",
        tabs: {
          ingredients: "Ingredients",
          feeding: "Feeding Guide",
          nutrition: "Nutrition",
          aminoAcids: "Amino Acids",
        },
        analytical: {
          guaranteedAnalysis: "Guaranteed Analysis",
          analyticalValues: "Analytical Values",
          metabolisable_energy: "Metabolisable Energy",
          digestibility: "Digestibility",
          estimated: "Estimated",
          crude_protein_min: "Crude Protein (min)",
          crude_fat_min: "Crude Fat (min)",
          crude_fibre_max: "Crude Fibre (max)",
          crude_ash_max: "Crude Ash (max)",
          moisture_max: "Moisture (max)",
          taurine: "Taurine",
          omega3: "Omega-3",
          omega6: "Omega-6",
          calcium_min: "Calcium (min)",
          calcium_max: "Calcium (max)",
          phosphorus_min: "Phosphorus (min)",
          phosphorus_max: "Phosphorus (max)",
          l_carnitine: "L-Carnitine",
          metabolisable_energy_kcal: "Metabolisable Energy (kcal/kg)",
          metabolisable_energy_mj: "Metabolisable Energy (MJ/kg)",
          omega3_fatty_acids: "Omega-3",
          omega6_fatty_acids: "Omega-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Glucosamine",
          chondroitin_sulphate: "Chondroitin Sulphate",
          dl_methionine_ga: "DL-Methionine",
          sodium: "Sodium",
          magnesium: "Magnesium",
          potassium: "Potassium",
          ca_p_ratio: "Calcium : Phosphorus Ratio",
        },
        fullIngredientList: "Full ingredient list",
        functionalHighlights: "Functional Highlights",
        storageShelfLife: "Storage & Shelf Life",
        storageText:
          "SHELF LIFE: 18 months from date of manufacture.\nSTORAGE & SAFETY\nStore in a cool, dry place.\nReseal after opening.\nDo not freeze.",
        storageTextWet:
          "SHELF LIFE: 3 years (unopened from date of manufacture).\nSTORAGE & SAFETY\nStore in a cool, dry place away from direct sunlight.\nRefrigerate after opening and consume within 5 days.\nDo not freeze.",
        functionalIngredientsText:
          "FUNCTIONAL INGREDIENTS\n- Inulin (FOS): Supports microbiome balance\n- MOS: Helps block harmful gut bacteria\n- β-Glucans: Supports immune function\nSalmon Oil: EPA & DHA support brain & vision development\nDL-Methionine: Supports urinary health\nTaurine: Essential for cardiac function, vision, and neurological support",
        complianceTemplates: {
          kitten_cat:
            "{{name}} is formulated to meet the nutritional levels established by the AAFCO Cat Food Nutrient Profiles for Growth and Reproduction, and complies with FEDIAF nutritional guidelines for complete and balanced pet food for kittens.",
          adult_cat:
            "{{name}} is formulated to meet the nutritional levels established by the AAFCO Cat Food Nutrient Profiles for Adult Maintenance and complies with FEDIAF nutritional guidelines for complete and balanced adult cat food.",
          sterilised_cat:
            "{{name}} is formulated to meet the nutritional levels established by the AAFCO Cat Food Nutrient Profiles for Adult Maintenance and complies with FEDIAF nutritional guidelines for complete and balanced adult sterilised cat food.",
          smallbreed_puppy:
            "{{name}} is formulated to meet the nutritional levels established by the AAFCO Dog Food Nutrient Profiles for Growth and complies with FEDIAF nutritional guidelines for complete and balanced small breed puppy food.",
          medlarge_puppy:
            "{{name}} is formulated to meet the nutritional levels established by the AAFCO Dog Food Nutrient Profiles for Growth and complies with FEDIAF nutritional guidelines for complete and balanced Medium & Large Breed Puppy Dog Food.",
          adult_small_dog:
            "{{name}} is a single-animal protein, grain-free functional diet formulated to meet the nutritional needs of adult small breed dogs. Made exclusively with {{protein}} as the only animal protein source, this highly digestible recipe supports lean muscle maintenance, healthy skin and coat, digestive health, immune system function, and overall vitality in small breed dogs. Free from poultry, grains, soy, and artificial preservatives. Complete and balanced pet food for adult small breed dogs.",
          adult_allbreed_dog:
            "{{name}} is a single-animal protein, grain-free functional diet formulated to meet the nutritional needs of adult dogs of all breeds. Made exclusively with {{protein}} as the only animal protein source, this highly digestible recipe supports lean muscle maintenance, healthy skin and coat, digestive health, immune system function, and overall vitality. Free from poultry, grains, soy, and artificial preservatives. Complete and balanced pet food for adult dogs.",
        },
        complianceStatement: "Compliance Statement",
        nutritionalAdditivesPerKg: "Nutritional Additives (per kg)",
        vitamins: "Vitamins",
        traceElements: "Trace Elements",
        functionalAdditives: "Functional Additives",
        prebioticProbioticComplex: "Pre- & Probiotic Complex",
        botanicalExtracts: "Botanical Extracts",
        nutritionalAdditives: {
          sectionHeader: "Nutritional Additives (per kg)",
          vitamins: "Vitamins",
          traceElements: "Trace Elements",
          functionalAdditives: "Functional Additives",
          prebioticProbioticComplex: "Pre- & Probiotic Complex",
          botanicalExtracts: "Botanical Extracts",

          // Vitamins
          vitaminA: "Vitamin A",
          vitaminD3: "Vitamin D₃",
          vitaminE: "Vitamin E",
          vitaminC: "Vitamin C",
          vitaminB1: "Vitamin B₁",
          vitaminB2: "Vitamin B₂",
          vitaminB6: "Vitamin B₆",
          vitaminB12: "Vitamin B₁₂",
          niacin: "Niacin",
          pantothenicAcid: "Pantothenic Acid",
          folicAcid: "Folic Acid",
          biotin: "Biotin",
          cholineChloride: "Choline Chloride",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Methionine",

          // Trace Elements
          iron: "Iron",
          ferrousSulphate: "Ferrous Sulphate",
          zinc: "Zinc",
          zincSulphate: "Zinc Sulphate",
          manganese: "Manganese",
          manganeseSulphate: "Manganese Sulphate",
          copper: "Copper",
          copperSulphate: "Copper Sulphate",
          iodine: "Iodine",
          calciumIodate: "Calcium Iodate",
          selenium: "Selenium",
          sodiumSelenite: "Sodium Selenite",

          // Functional Additives
          glucosamine: "Glucosamine",
          chondroitinSulphate: "Chondroitin Sulphate",
          yuccaSchidigeraExtract: "Yucca Schidigera Extract",
          cranberryExtract: "Cranberry Extract",

          // Pre- & Probiotic Complex
          inulinFOS: "Inulin (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucans",
          probiotics: "Probiotics",
          cfu: "CFU",

          // Botanical Extracts
          rosemary: "Rosemary",
          greenTea: "Green Tea",
          turmeric: "Turmeric",
          ginger: "Ginger",
          kelp: "Kelp",
          blueberry: "Blueberry",

          // Units / labels
          iu: "IU",
          mg: "mg",
          perKg: "per kg",
          asLabel: "as",
        },
        aminoAcids: {
          lysine: "Lysine",
          methionine: "Methionine",
          threonine: "Threonine",
          tryptophan: "Tryptophan",
          leucine: "Leucine",
          isoleucine: "Isoleucine",
          valine: "Valine",
          histidine: "Histidine",
          phenylalanine: "Phenylalanine",
          arginine: "Arginine",
        },
        aminoAcidProfile: "Essential Amino Acid Profile",
        aminoNote:
          "† Approximate values. Taurine is added as a nutritional additive at the declared minimum level.",
        feeding: {
          day: "day",
          can: "can",
          cans: "cans",
          dryNote:
            "Amounts are daily guidelines. Divide into 2–3 meals. Always provide fresh water.",
          kitten__2_4months: "Kitten (2–4 months)",
          kitten__4_6months: "Kitten (4–6 months)",
          junior_7_12months: "Junior (7–12 months)",
          puppy___2_4_months: "Puppy (2–4 months)",
          puppy___4_9_months: "Puppy (4–9 months)",
          junior__7_9_months: "Junior (7–9 months)",
          junior__9_12_months: "Junior (9–12 months)",
          junior___9_12_months: "Junior (9–12 months)",
          junior___12_15_months: "Junior (12–15 months)",
          junior__15_20_months: "Junior (15–20 months)",
          adult_cat__1_3_yrs: "Adult Cat (1–3 yrs)",
          adult_cat__3_7_yrs: "Adult Cat (3–7 yrs)",
          adult_cat__7__yrs: "Adult Cat (7+ yrs)",
          adult_dog__1_3_yrs: "Adult Dog (1–3 yrs)",
          adult_dog___3_7_yrs: "Adult Dog (3–7 yrs)",
          adult_dog__7__yrs: "Adult Dog (7+ yrs)",
          "1_3_yrs": "1–3 yrs",
          "3_7_yrs": "3–7 yrs",
          "7__yrs": "7+ yrs",
          stage_label: "Life Stage",
        },
      },
      distributors: {
        emailLabel: "Email",
        websiteLabel: "Website",
        heroTitle: "International Distribution Partnerships",
        heroSubtext:
          "GENOYA® is a premium, structured global brand focused exclusively on long-term distribution and OEM partnerships.",
        contactUs: "Contact Export Team",
        exportTitle: "Global Export & Container Loading Capability",
        fcl: "Full Container Load (FCL) Available",
        fclDesc:
          "20DC / 40HC / 45FT containers supported with worldwide shipping coordination.",
        mixedSku: "Mixed SKU Loading",
        mixedSkuDesc:
          "Flexible pallet configurations for multiple product variants.",
        compliance: "Regulatory & Quality Assurance",
        complianceDesc:
          "Full oversight to ensure compliance in target markets.",
        palletStandards: "Supported Pallet Standards",
        eurPallets: "EUR / EPAL Pallets (1200 × 800 mm)",
        ukPallets: "UK Standard Pallets (1200 × 1000 mm)",
        usPallets: "US GMA Pallets (48” × 40”)",
        whyPartnerTitle: "Why Partner with GENOYA®",
        benefitScience: "Science-Driven Formulations",
        benefitScienceDesc:
          "Complete & balanced single-protein nutrition aligned with AAFCO/FEDIAF.",
        benefitSingleProtein: "Strict Single-Protein Philosophy",
        benefitSingleProteinDesc:
          "No chicken, no by-products – pure, traceable animal proteins.",
        benefitProduction: "Scalable, Export-Ready Production",
        benefitProductionDesc:
          "Full container loads with mixed SKU flexibility.",
        benefitLongTerm: "Long-Term Strategic Partnership",
        benefitLongTermDesc:
          "Brand integrity and dedicated distributor support.",
        officialOversight: "Official Export & Production Oversight",
        oversightText:
          "GENOYA® international trade operations and OEM production oversight are managed through our designated export entity to ensure:",
        oversight1: "Regulatory compliance across international markets",
        oversight2:
          "Full Container Load (FCL) export coordination (20DC / 40HC / 45FT)",
        oversight3: "Production supervision and quality assurance",
        oversight4: "Brand integrity and formulation compliance",
        oversight5: "Global distributor partnership management",
        exportContact: "Export & International Trade Department",
        exportEntity: "Official Export Entity",
        founder: "Founder & Global Managing Director",
        registeredAddress: "Registered Address",
        inquiryTitle: "Submit Your Partnership Inquiry",
        inquiryDesc:
          "We welcome serious inquiries from national importers, regional distributors, and strategic partners.",
        finalCtaTitle: "Ready to Partner with GENOYA®?",
        finalCtaDesc:
          "Join our global network of premium distribution partners.",
        contactExport: "Contact Export Team",
        becomePartner: "Inquire Now",
        form: {
          companyName: "Company / Legal Entity Name",
          country: "Primary Market / Country",
          businessType: "Business Type",
          select: "Select type",
          nationalImporter: "National Importer",
          regionalDistributor: "Regional Distributor",
          premiumRetail: "Premium Retail Chain",
          vetChannel: "Veterinary / Professional Channel",
          oem: "OEM / Private Label Partner",
          volume: "Estimated Annual Volume",
          volumePlaceholder: "e.g. 10–50 containers / year",
          containerInterest: "Preferred Container Size (if known)",
          email: "Corporate Email",
          phone: "Phone (with country code)",
          submit: "Submit Partnership Inquiry",
        },
      },
      contact: {
        phone: "Phone",
  country: "Country",
  optional: "optional",
  selectCountry: "Select your country",
  messagePlaceholder: "How can we help you?",
  sending: "Sending...",
  sendAnother: "Send another message",
  operatedBy: "Operated by",
  searchCountries: "Search countries...",
  noResults: "No results",
        title: "Connect With GENOYA™",
        generalTitle: "General Inquiries",
        generalDesc: "For product information and brand-related questions:",
        partnershipTitle: "Distributor Inquiries",
        partnershipDesc:
          "For commercial partnerships and distribution opportunities:",
        formName: "Full Name",
        formEmail: "e-mail address",
        formMessage: "Message",
        sendButton: "Send Message",
        name: "Name",
        email: "Email",
        message: "Message",
        send: "Send",
        successTitle: "Message Sent Successfully",
        successDesc:
          "Thank you for reaching out. Our team will get back to you shortly.",
      },
      nav: {
        home: "Home",
        about: "About",
        products: "Formulas",
        distributors: "Distributors",
        contact: "Contact",
        toggleMenu: "Toggle navigation",
      },
      footer: {
        brandName: "Genoya",
        tagline: "Science-Formulated. Pure Protein.",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. All rights reserved.",
        quickLinks: "Navigation",
        global: "Global Operations",
        languages: "Language Selection",
        distributorInfo: "Export Specs",
        email: "Contact Email",
        legal: "Compliance",
        privacy: "Privacy Policy",
        terms: "Terms of Service",
      },
      privacy: {
        label: "Legal",
        title: "Privacy Policy",
        lastUpdated: "Last updated: March 2026",
        intro:
          "GENOYA™ is committed to protecting your personal information. This Privacy Policy explains what data we collect when you visit genoyapetfood.com, how we use it, and your rights regarding that data.",
        informationCollectedTitle: "Information We Collect",
        info1: "Contact form submissions: name, email address, company name, country, and message content.",
        info2: "Usage data: pages visited, time spent on site, browser type, and device information collected via analytics tools.",
        info3: "Cookies and similar technologies used for site performance and analytics.",
        howWeUseTitle: "How We Use Your Information",
        use1: "To respond to distributor inquiries and contact form submissions.",
        use2: "To analyze website performance and improve user experience.",
        use3: "To comply with legal obligations.",
        use4: "We do not sell, rent, or trade your personal information to third parties.",
        dataRetentionTitle: "Data Retention",
        dataRetentionText:
          "We retain contact form data for as long as necessary to respond to your inquiry and for a reasonable period thereafter for record-keeping purposes. Analytics data is retained according to the policies of the respective analytics provider.",
        thirdPartyTitle: "Third-Party Services",
        thirdPartyText:
          "Our website may use third-party services such as analytics providers. These services may collect data subject to their own privacy policies. We do not control how these third parties collect or use your information.",
        cookiesTitle: "Cookies",
        cookie1: "We use essential cookies required for the site to function correctly.",
        cookie2: "Analytics cookies may be used to understand how visitors interact with the site. You may disable cookies through your browser settings.",
        yourRightsTitle: "Your Rights",
        right1: "You have the right to request access to the personal data we hold about you.",
        right2: "You may request correction or deletion of your data at any time.",
        right3: "To exercise these rights, contact us at the email address below.",
        changesTitle: "Changes to This Policy",
        changesText:
          "We may update this Privacy Policy from time to time. The most current version will always be available on this page with the updated date noted above.",
        contactText: "For privacy-related questions or requests, contact us at",
      },
      terms: {
        label: "Legal",
        title: "Terms of Service",
        lastUpdated: "Last updated: March 2026",
        intro:
          "By accessing and using the GENOYA™ website (genoyapetfood.com), you agree to be bound by these Terms of Service. Please read them carefully before using the site.",
        acceptanceTitle: "Acceptance of Terms",
        acceptanceText:
          "Your use of this website constitutes acceptance of these Terms of Service. If you do not agree with any part of these terms, please do not use the website.",
        useOfSiteTitle: "Use of the Website",
        use1: "You may use this site for lawful purposes only and in accordance with these terms.",
        use2: "You must not use the site in any way that could damage, disable, or impair the site or interfere with other users.",
        use3: "You must not attempt to gain unauthorized access to any part of the site or its related systems.",
        use4: "Commercial use of site content without prior written permission from GENOYA™ is prohibited.",
        intellectualPropertyTitle: "Intellectual Property",
        intellectualPropertyText:
          "All content on this website — including text, images, logos, product names, formulas, and design — is the property of GENOYA™ and is protected by applicable intellectual property laws. Unauthorized reproduction or distribution is strictly prohibited.",
        disclaimerTitle: "Disclaimer of Warranties",
        disclaimerText:
          "This website and its content are provided on an \"as is\" basis without warranties of any kind, either express or implied. GENOYA™ does not warrant that the site will be uninterrupted, error-free, or free of viruses or other harmful components.",
        limitationTitle: "Limitation of Liability",
        limitationText:
          "To the fullest extent permitted by law, GENOYA™ shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of, or inability to use, this website or its content.",
        thirdPartyLinksTitle: "Third-Party Links",
        thirdPartyLinksText:
          "This website may contain links to third-party websites. These links are provided for convenience only. GENOYA™ has no control over and assumes no responsibility for the content or practices of any third-party sites.",
        governingLawTitle: "Governing Law",
        governingLawText:
          "These Terms of Service shall be governed by and construed in accordance with applicable international commercial law. Any disputes shall be resolved through good-faith negotiation between the parties.",
        changesTitle: "Changes to These Terms",
        changesText:
          "GENOYA™ reserves the right to modify these Terms of Service at any time. Continued use of the website after changes are posted constitutes acceptance of the updated terms.",
        contactText: "For questions regarding these Terms of Service, contact us at",
      },
    },
  },
  es: {
    translation: {
      ingredientCategories: {
        protein: "Proteína",
        carb: "Carbohidrato",
        oil: "Aceite y Grasa",
        prebiotic: "Prebiótico",
        probiotic: "Probiótico",
        superfood: "Superalimento",
        mineral: "Mineral",
        amino: "Aminoácido",
        botanical: "Botánico",
        premix: "Premezcla de Vitaminas y Minerales",
        other: "Otro",
        showLess: "− Menos",
        more: "más",
      },
      ingredients: {
        beef: "Ternera",
        rabbit: "Conejo",
        duck: "Pato",
        lamb: "Cordero",
        turkey: "Pavo",
        whitefish: "Pescado Blanco",
        freshly_prepared_beef: "Ternera Fresca",
        beef_meal: "Harina de Ternera",
        dehydrated_beef_protein: "Proteína de Ternera Deshidratada",
        freshly_prepared_rabbit: "Conejo Fresco",
        rabbit_meal: "Harina de Conejo",
        dehydrated_rabbit_protein: "Proteína de Conejo Deshidratada",
        freshly_prepared_turkey: "Pavo Fresco",
        turkey_meal: "Harina de Pavo",
        dehydrated_turkey_protein: "Proteína de Pavo Deshidratada",
        freshly_prepared_duck: "Pato Fresco",
        duck_meal: "Harina de Pato",
        dehydrated_duck_protein: "Proteína de Pato Deshidratada",
        freshly_prepared_whitefish: "Pescado Blanco Fresco",
        whitefish_meal: "Harina de Pescado Blanco",
        dehydrated_whitefish_protein: "Proteína de Pescado Blanco Deshidratada",
        freshly_prepared_lamb: "Cordero Fresco",
        lamb_meal: "Harina de Cordero",
        dehydrated_lamb_protein: "Proteína de Cordero Deshidratada",
        beef_broth: "Caldo de Ternera",
        lamb_broth: "Caldo de Cordero",
        rabbit_broth: "Caldo de Conejo",
        turkey_broth: "Caldo de Pavo",
        whitefish_broth: "Caldo de Pescado Blanco",
        potato_flour: "Harina de Patata",
        tapioca: "Tapioca",
        pumpkin: "Calabaza",
        dried_cellulose_fibre: "Fibra de Celulosa Seca",
        salmon_oil: "Aceite de Salmón",
        flaxseed: "Linaza",
        dried_brewers_yeast: "Levadura de Cerveza Seca",
        probiotics: "Probióticos",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Espinaca",
        blueberry: "Arándano",
        kelp_powder: "Polvo de Alga Kelp",
        chicory_root: "Raíz de Achicoria",
        inulin: "Inulina",
        fos: "FOS (Fructooligosacáridos)",
        mos: "MOS (Mananoligosacáridos)",
        yeast_β_glucans: "β-Glucanos de Levadura",
        dicalcium_phosphate: "Fosfato Dicálcico",
        potassium_chloride: "Cloruro de Potasio",
        sodium_phosphate: "Fosfato de Sodio",
        dl_methionine: "DL-Metionina",
        taurine: "Taurina",
        l_carnitine: "L-Carnitina",
        yucca_schidigera_extract: "Extracto de Yuca Schidigera",
        cranberry_extract: "Extracto de Arándano Rojo",
        "turmeric_&_ginger_extracts": "Extractos de Cúrcuma y Jengibre",
        "rosemary_&_green_tea_extracts": "Extractos de Romero y Té Verde",
        "vitamin_&_mineral_premix": "Premezcla de Vitaminas y Minerales",
      },
      home: {
        heroTitle1: "Formulado por la Ciencia.",
        heroTitle2: "Proteína Pura.",
        heroTitle3: "Salud Funcional.",
        heroSubtext:
          "Nutrición premium para mascotas basada en una sola proteína, diseñada mediante sistemas de formulación estructurados para favorecer la claridad digestiva, el equilibrio metabólico y la vitalidad a largo plazo.",
        viewProducts: "Explorar Nuestras Fórmulas",
        becomeDistibutor: "Convertirse en Distribuidor",
        noChickenTitle: "Estrictamente sin Pollo. Sin Subproductos de Pollo.",
        noChickenSubtitle: "Siempre Monoproteico – Nuestra Promesa Central",
        noChickenText:
          "Cada fórmula de GENOYA utiliza únicamente una fuente pura de proteína animal identificada. Sin proteínas mixtas. Sin pollo. Sin subproductos de pollo. Esta filosofía de proteína única ofrece nutrición de precisión, mejor digestibilidad y una gestión de alergias más clara para mascotas en todo el mundo.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ es una marca de nutrición premium para mascotas formulada científicamente bajo una estricta filosofía de proteína única.",
        introPoint1: "Precisión nutricional",
        introPoint2: "Claridad digestiva",
        introPoint3: "Complejidad dietética reducida",
        introPoint4: "Optimización de la salud funcional",
        introFooter:
          "Diseñamos sistemas de nutrición estructurados — no productos basados en tendencias.",
        diffTitle: "Diferenciadores Clave",
        diff1Title: "Arquitectura de Proteína Animal Única",
        diff1Desc:
          "Cada fórmula se construye en torno a una fuente de proteína animal primaria claramente definida.",
        diff2Title: "Formulación Sin Cereales",
        diff2Desc:
          "Estructura equilibrada de macronutrientes sin rellenos innecesarios.",
        diff3Title: "Política Sin Pollo",
        diff3Desc:
          "Estricto estándar de pureza de proteínas en todos los productos. Sin pollo ni subproductos de pollo.",
        diff4Title: "Integración Funcional",
        diff4Desc:
          "Prebióticos, probióticos, compuestos de soporte articular y equilibrio optimizado de omega.",
        scienceTitle:
          "Basado en la Investigación. Estructurado para el Rendimiento.",
        scienceLead: "Las formulaciones de GENOYA™ están diseñadas utilizando:",
        sciencePoint1: "Ratios controlados de proteína y grasa",
        sciencePoint2: "Perfiles equilibrados de Omega 3 y 6",
        sciencePoint3: "Sistemas prebióticos FOS y MOS",
        sciencePoint4: "β-glucanos para soporte inmunológico",
        sciencePoint5: "Glucosamina y condroitina para la integridad articular",
        sciencePoint6: "Taurine y L-Carnitine según requerimiento funcional",
        scienceFooter:
          "Cada ingrediente cumple un propósito definido. Cada porcentaje sigue una lógica de formulación.",
        previewTitle: "Resumen de Fórmulas",
        previewCats: "Gatos",
        previewDogs: "Perros",
        previewKitten: "Gatito",
        previewAdult: "Adulto",
        previewSterilised: "Adulto Esterilizado",
        previewPuppy: "Cachorro",
        previewSmallBreed: "Adulto Raza Pequeña",
        previewAllBreeds: "Adulto (Todas las Razas)",
        distributorHeading: "Oportunidades de Distribución Global",
        distributorSubtext:
          "GENOYA™ se está expandiendo a través de asociaciones internacionales estructuradas. Soportamos contenedores 20DC, 40HC y 45ft con documentación lista para exportación.",
        getStarted: "Asóciese con GENOYA™",
      },
      about: {
        heroTitle1: "Nutrición de Precisión",
        heroTitle2: "Visión Global",
        heroSubtext:
          "GENOYA™ es una marca centrada en la ciencia que diseña nutrición premium para mascotas utilizando sistemas basados en la claridad de la proteína única y el rendimiento de la salud funcional.",
        viewProducts: "Ver Todas las Fórmulas",
        missionTitle: "Nuestra Misión",
        missionText:
          "Diseñar nutrición premium para mascotas mediante sistemas de formulación respaldados por la ciencia, basados en la claridad de la proteína única y el rendimiento de la salud funcional.",
        valuesTitle: "Nuestros Principios",
        value1: "Pureza de Proteína",
        value1subtext:
          "Arquitectura de proteína animal única en todos los productos.",
        value2: "Integridad Nutricional",
        value2subtext:
          "Fórmulas estructuradas alineadas con marcos nutricionales reconocidos.",
        value3: "Enfoque en Salud Funcional",
        value3subtext:
          "Soporte digestivo, integridad articular, equilibrio inmunológico y optimización metabólica.",
        value4: "Sin Pollo. Sin Subproductos de Pollo.",
        value4subtext: "Un estándar de marca no negociable de GENOYA™.",
        viewOurProducts: "Explorar Productos",
        leadershipTitle: "Expertise & Positioning",
        leadershipHeadText:
          " ha sido creada por profesionales con experiencia en:",
        leadershipValue1: "Comercio internacional de alimentos para mascotas",
        leadershipValue2: "Supervisión de producción OEM",
        leadershipValue3: "Desarrollo de arquitectura de marca",
        leadershipValue4: "Escalamiento de distribución",
        leadershipValue5: "Sistemas de etiquetado alineados con la normativa",
        leadershipTextBelow:
          "opera a través de instalaciones de producción estructuradas en China bajo sistemas controlados de formulación y supervisión de calidad diseñados para la distribución internacional.",
        leadershipTextFinal:
          "Construimos marcas estructuradas diseñadas para un crecimiento global a largo plazo.",
        noChickenTitle: "Estrictamente sin Pollo. Sin Subproductos de Pollo.",
        noChickenSubtitle:
          "Siempre Proteína Única – Nuestro Compromiso Fundamental",
        noChickenText:
          "GENOYA® nunca utiliza pollo ni subproductos de pollo en ninguna fórmula. Nos basamos en una estricta filosofía de proteína única: una fuente animal pura e identificada por producto. Esto garantiza una mejor digestibilidad, una gestión de alergias más clara y una transparencia inigualable para los dueños de mascotas en todo el mundo.",
        complianceTitle: "Declaración de Cumplimiento Nutricional",
        complianceText:
          "Formulado para cumplir con los niveles nutricionales establecidos por los estándares internacionales reconocidos de alimentos para mascotas, incluidos los perfiles de nutrientes de la AAFCO (Asociación Americana de Oficiales de Control de Alimentos) y las directrices de la FEDIAF (Federación Europea de la Industria de Alimentos para Mascotas) para la etapa de vida respectiva.",
        complianceBold:
          "Nuestros productos son completos y equilibrados para todas las etapas de la vida.",
      },
      products: {
        heroTitle: "Fórmulas Avanzadas de Proteína Única",
        heroSubtext:
          "Nutrición de precisión con fuentes de proteína animal única, adaptada por especie, etapa de vida y objetivos de salud funcional.",
        selectSpecies: "Seleccione la Especie de su Mascota",
        backToSpecies: "Volver a Selección de Especie",
        noProductsAvailable: "No se encontraron productos para esta categoría.",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
        resetFilters: "Restablecer Todo",
        format: "Formato de Producto",
        allFormats: "Todos los Formatos",
        formats: {
          dry: "Alimento Seco",
          wet: "Alimento Húmedo",
        },
        dryKibble: "Croquetas Secas",
        wetFood: "Alimento Húmedo",
        ingredient: "Proteína Primaria",
        allIngredients: "Todas las Proteínas",
        lifeStage: "Etapa de Vida",
        allStages: "Todas las Etapas",
        healthGoal: "Objetivo Funcional",
        allGoals: "Todos los Objetivos",
        healthBenefits: "Beneficios para la Salud",
        noResults:
          "No se encontraron fórmulas que coincidan con sus criterios.",
        details: "Detalles de la Fórmula",
        showLess: "Mostrar Menos",
        collapseAll: "Contraer Todo",
        size: "Contenido Neto",
        ingredients: "Ingredientes",
        fullIngredients: "Composición Completa",
        standard: "Estándar de Fabricación",
        packaging: "Tipo de Envase",
        aboutProduct: "CARACTERÍSTICAS",
        ingredientsLabel: "INGREDIENTES (COMPOSICIÓN)",
        analysisLabel: "ANÁLISIS GARANTIZADO (cuando esté disponible)",
        nutritionalAdditives: {
          sectionHeader: "Aditivos Nutricionales (por kg)",
          vitamins: "Vitaminas",
          traceElements: "Oligoelementos",
          functionalAdditives: "Aditivos Funcionales",
          prebioticProbioticComplex: "Complejo Pre- y Probiótico",
          botanicalExtracts: "Extractos Botánicos",

          vitaminA: "Vitamina A",
          vitaminD3: "Vitamina D₃",
          vitaminE: "Vitamina E",
          vitaminC: "Vitamina C",
          vitaminB1: "Vitamina B₁",
          vitaminB2: "Vitamina B₂",
          vitaminB6: "Vitamina B₆",
          vitaminB12: "Vitamina B₁₂",
          niacin: "Niacina",
          pantothenicAcid: "Ácido Pantoténico",
          folicAcid: "Ácido Fólico",
          biotin: "Biotina",
          cholineChloride: "Cloruro de Colina",
          taurine: "Taurina",
          lCarnitine: "L-Carnitina",
          dlMethionine: "DL-Metionina",

          iron: "Hierro",
          ferrousSulphate: "Sulfato Ferroso",
          zinc: "Zinc",
          zincSulphate: "Sulfato de Zinc",
          manganese: "Manganeso",
          manganeseSulphate: "Sulfato de Manganeso",
          copper: "Cobre",
          copperSulphate: "Sulfato de Cobre",
          iodine: "Yodo",
          calciumIodate: "Yodato de Calcio",
          selenium: "Selenio",
          sodiumSelenite: "Selenito de Sodio",

          glucosamine: "Glucosamina",
          chondroitinSulphate: "Sulfato de Condroitina",
          yuccaSchidigeraExtract: "Extracto de Yuca Schidigera",
          cranberryExtract: "Extracto de Arándano Rojo",

          inulinFOS: "Inulina (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucanos",
          probiotics: "Probióticos",
          cfu: "UFC",

          rosemary: "Romero",
          greenTea: "Té Verde",
          turmeric: "Cúrcuma",
          ginger: "Jengibre",
          kelp: "Alga Kelp",
          blueberry: "Arándano Azul",

          iu: "UI",
          mg: "mg",
          perKg: "por kg",
          asLabel: "como",
        },
        categories: {
          cat: "Nutrición Felina",
          cats: "Nutrición Felina",
          dog: "Nutrición Canina",
          dogs: "Nutrición Canina",
        },
        stages: {
          adult: "Adulto",
          adult_small_breed: "Adulto Raza Pequeña",
          sterilised: "Esterilizado",
          dog: {
            junior: "Cachorro",
          },
          cat: {
            junior: "Gatito",
          },
        },
        sizeCategory: "Tamaño / Raza",
        allSizes: "Todos los Tamaños",
        sizes: {
          allBreeds: "Todas las Razas",
          smallBreed: "Raza Pequeña",
          "all-breeds": "Todas las Razas",
          "small-breed": "Raza Pequeña",
          mediumBreed: "Raza Mediana",
          largeBreed: "Raza Grande",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Salud Digestiva",
          skin: "Nutrición de Piel y Pelaje",
          immune: "Soporte del Sistema Inmunológico",
          antioxidant: "Defensa Antioxidante",
          muscle: "Mantenimiento Muscular",
          joint: "Soporte Articular",
          weight: "Control de Peso",
          urinary: "Salud del Tracto Urinario",
          brain: "Salud Cerebral y Cognitiva",
          bone: "Desarrollo Óseo y Articular",
        },
        goals: {
          digestion: "Salud Digestiva",
          skin: "Nutrición de Piel y Pelaje",
          weight: "Control de Peso",
          urinary: "Salud del Tracto Urinario",
          immune: "Soporte Inmunológico",
          antioxidant: "Protección Antioxidante",
          muscle: "Mantenimiento Muscular",
          joint: "Soporte Articular",
        },
        flavors: {
          beef: "Buey",
          duck: "Pato",
          lamb: "Cordero",
          rabbit: "Conejo",
          turkey: "Pavo",
          whitefish: "Pescado Blanco",
        },
        textures: {
          kibble: "Croqueta Seca",
          "chunks in jelly": "Trozos en Gelatina",
        },
        linekey: {
          dailyCare: "Cuidado Diario",
          superfoodPlus: "Superalimento+",
        },
        animals: {
          dog: "Perro",
          cat: "Gato",
        },
        description:
          "Una receta premium de proteína única de {{flavor}} en formato {{texture}}, diseñada para {{animal}} en la etapa de vida {{stage}}.",
        types: {
          dry: "Seco",
          wet: "Húmedo",
        },
        singleProtein: "proteína única",
        grainFree: "sin cereales",
        premiumCompleteFood: "Alimento completo y equilibrado premium",
        frontView: "Vista frontal",
        backView: "Vista trasera",
        feedingGuideNotAvailable:
          "Guía de alimentación no disponible para este producto.",
        technicalSpecs: "Especificaciones Técnicas",
        keyBenefits: "Principales Beneficios Funcionales",
        analyticalConstituents: "Constituyentes Analíticos",
        feedingGuide: "Guía de Alimentación",
        functionalIngredients: "Ingredientes Funcionales y Additivos",
        petWeight: "Peso de la Mascota",
        gramsPerDay: "Gramos por Día",
        viewBack: "Ver Etiqueta Trasera",
        viewFront: "Ver Etiqueta Frontal",
        clickToZoom: "Haga clic en la imagen para ampliar",
        analysis: {
          protein: "Proteína Bruta",
          fat: "Grasa Bruta",
          fiber: "Fibra Bruta",
          ash: "Ceniza Bruta",
          omega3: "Omega-3",
          omega6: "Omega-6",
        },
        netContentLabel: "Contenido Neto",
        packagingTypeLabel: "Envase",
        standardLabel: "Estándar",
        pillarNoChicken:
          "Estrictamente sin Pollo. Sin Subproductos de Pollo. Siempre Monoproteico.",
        noChickenTitle: "Nuestra Promesa Central",
        noChickenText:
          "GENOYA® nunca utiliza pollo ni subproductos de pollo. Cada fórmula se basa en una fuente pura de proteína animal: completa y equilibrada para cada etapa de vida.",
        filterReinforce:
          "Todas las fórmulas son Completas y Equilibradas – Estrictamente Sin Pollo / Siempre Monoproteico",
        complianceTitle: "Cumplimiento Nutricional",
        complianceText:
          "Formulado para cumplir con los niveles nutricionales establecidos por los estándares internacionales de alimentos para mascotas, incluidos los perfiles de la AAFCO y las directrices de la FEDIAF para la etapa de vida correspondiente.",
        completeBalanced: "Completo y Equilibrado",
        nutritionalAdequacyTitle: "Declaración de Adecuación Nutricional",
        nutritionalAdequacyText:
          "Formulado en consonancia con las directrices de perfiles de nutrientes de la AAFCO y la FEDIAF para la etapa de vida prevista. La adecuación nutricional se basa en el análisis de la formulación.",
        regulatoryDisclaimer:
          "AAFCO y FEDIAF son organizaciones de directrices reguladoras. Los productos GENOYA™ no están aprobados ni certificados por estas organizaciones.",
        tabs: {
          ingredients: "Ingredientes",
          feeding: "Guía de Alimentación",
          nutrition: "Nutrición",
          aminoAcids: "Aminoácidos",
        },
        analytical: {
          guaranteedAnalysis: "Análisis Garantizado",
          analyticalValues: "Valores Analíticos",
          metabolisable_energy: "Energía Metabolizable",
          digestibility: "Digestibilidad",
          estimated: "Estimado",
          crude_protein_min: "Proteína Bruta (mín)",
          crude_fat_min: "Grasa Bruta (mín)",
          crude_fibre_max: "Fibra Bruta (máx)",
          crude_ash_max: "Ceniza Bruta (máx)",
          moisture_max: "Humedad (máx)",
          taurine: "Taurina",
          omega3: "Omega-3",
          omega6: "Omega-6",
          calcium_min: "Calcio (mín)",
          calcium_max: "Calcio (máx)",
          phosphorus_min: "Fósforo (mín)",
          phosphorus_max: "Fósforo (máx)",
          l_carnitine: "L-Carnitina",
          metabolisable_energy_kcal: "Energía metabolizable (kcal/kg)",
          metabolisable_energy_mj: "Energía metabolizable (MJ/kg)",
          omega3_fatty_acids: "Omega-3",
          omega6_fatty_acids: "Omega-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Glucosamina",
          chondroitin_sulphate: "Sulfato de Condroitina",
          dl_methionine_ga: "DL-Metionina",
          sodium: "Sodio",
          magnesium: "Magnesio",
          potassium: "Potasio",
          ca_p_ratio: "Relación Calcio : Fósforo",
        },
        fullIngredientList: "Lista completa de ingredientes",
        functionalHighlights: "Aspectos Funcionales Destacados",
        storageShelfLife: "Almacenamiento y Vida Útil",
        storageText:
          "VIDA ÚTIL: 18 meses desde la fecha de fabricación.\nALMACENAMIENTO Y SEGURIDAD\nConservar en lugar fresco y seco.\nResellarlo después de cada uso.\nNo congelar.",
        storageTextWet:
          "VIDA ÚTIL: 3 años (sin abrir desde la fecha de fabricación).\nALMACENAMIENTO Y SEGURIDAD\nConservar en lugar fresco y seco, alejado de la luz solar directa.\nRefrigerar tras abrir y consumir en 5 días.\nNo congelar.",
        functionalIngredientsText:
          "INGREDIENTES FUNCIONALES\n- Inulina (FOS): Favorece el equilibrio del microbioma\n- MOS: Ayuda a bloquear bacterias intestinales dañinas\n- β-Glucanos: Apoya la función inmunológica\nAceite de salmón: EPA y DHA favorecen el desarrollo cerebral y visual\nDL-Metionina: Apoya la salud urinaria\nTaurina: Esencial para la función cardíaca, la visión y el soporte neurológico",
        complianceTemplates: {
          kitten_cat:
            "{{name}} está formulado para cumplir los niveles nutricionales establecidos por los Perfiles Nutricionales para Alimentos para Gatos de la AAFCO para Crecimiento y Reproducción, y cumple con las directrices nutricionales de la FEDIAF para alimentos completos y equilibrados para gatitos.",
          adult_cat:
            "{{name}} está formulado para cumplir los niveles nutricionales establecidos por los Perfiles Nutricionales para Alimentos para Gatos de la AAFCO para Mantenimiento de Adultos y cumple con las directrices nutricionales de la FEDIAF para alimentos completos y equilibrados para gatos adultos.",
          sterilised_cat:
            "{{name}} está formulado para cumplir los niveles nutricionales establecidos por los Perfiles Nutricionales para Alimentos para Gatos de la AAFCO para Mantenimiento de Adultos y cumple con las directrices nutricionales de la FEDIAF para alimentos completos y equilibrados para gatos adultos esterilizados.",
          smallbreed_puppy:
            "{{name}} está formulado para cumplir los niveles nutricionales establecidos por los Perfiles Nutricionales para Alimentos para Perros de la AAFCO para Crecimiento y cumple con las directrices nutricionales de la FEDIAF para alimentos completos y equilibrados para cachorros de raza pequeña.",
          medlarge_puppy:
            "{{name}} está formulado para cumplir los niveles nutricionales establecidos por los Perfiles Nutricionales para Alimentos para Perros de la AAFCO para Crecimiento y cumple con las directrices nutricionales de la FEDIAF para alimentos completos y equilibrados para cachorros de raza mediana y grande.",
          adult_small_dog:
            "{{name}} es una dieta funcional sin cereales de proteína animal única formulada para satisfacer las necesidades nutricionales de perros adultos de raza pequeña. Elaborado exclusivamente con {{protein}} como única fuente de proteína animal, apoya el mantenimiento muscular, piel y pelaje saludables, salud digestiva, función inmunológica y vitalidad. Sin aves de corral, cereales, soja ni conservantes artificiales. Alimento completo y equilibrado para perros adultos de raza pequeña.",
          adult_allbreed_dog:
            "{{name}} es una dieta funcional sin cereales de proteína animal única formulada para satisfacer las necesidades nutricionales de perros adultos de todas las razas. Elaborado exclusivamente con {{protein}} como única fuente de proteína animal, apoya el mantenimiento muscular, piel y pelaje saludables, salud digestiva, función inmunológica y vitalidad. Sin aves de corral, cereales, soja ni conservantes artificiales. Alimento completo y equilibrado para perros adultos.",
        },
        complianceStatement: "Declaración de Conformidad",
        nutritionalAdditivesPerKg: "Aditivos Nutricionales (por kg)",
        vitamins: "Vitaminas",
        traceElements: "Oligoelementos",
        functionalAdditives: "Aditivos Funcionales",
        prebioticProbioticComplex: "Complejo Pre- y Probiótico",
        botanicalExtracts: "Extractos Botánicos",
        aminoAcids: {
          lysine: "Lisina",
          methionine: "Metionina",
          threonine: "Treonina",
          tryptophan: "Triptófano",
          leucine: "Leucina",
          isoleucine: "Isoleucina",
          valine: "Valina",
          histidine: "Histidina",
          phenylalanine: "Fenilalanina",
          arginine: "Arginina",
        },
        aminoAcidProfile: "Perfil de Aminoácidos Esenciales",
        aminoNote:
          "† Valores aproximados. La taurina se añade como aditivo nutricional en el nivel mínimo declarado.",
        feeding: {
          day: "día",
          can: "lata",
          cans: "latas",
          dryNote:
            "Las cantidades son pautas diarias. Dividir en 2–3 comidas. Proporcionar siempre agua fresca.",
          kitten__2_4months: "Gatito (2–4 meses)",
          kitten__4_6months: "Gatito (4–6 meses)",
          junior_7_12months: "Junior (7–12 meses)",
          puppy___2_4_months: "Cachorro (2–4 meses)",
          puppy___4_9_months: "Cachorro (4–9 meses)",
          junior__7_9_months: "Junior (7–9 meses)",
          junior__9_12_months: "Junior (9–12 meses)",
          junior___9_12_months: "Junior (9–12 meses)",
          junior___12_15_months: "Junior (12–15 meses)",
          junior__15_20_months: "Junior (15–20 meses)",
          adult_cat__1_3_yrs: "Gato Adulto (1–3 años)",
          adult_cat__3_7_yrs: "Gato Adulto (3–7 años)",
          adult_cat__7__yrs: "Gato Adulto (7+ años)",
          adult_dog__1_3_yrs: "Perro Adulto (1–3 años)",
          adult_dog___3_7_yrs: "Perro Adulto (3–7 años)",
          adult_dog__7__yrs: "Perro Adulto (7+ años)",
          "1_3_yrs": "1–3 años",
          "3_7_yrs": "3–7 años",
          "7__yrs": "7+ años",
          stage_label: "Etapa de vida",
        },
      },
      distributors: {
        emailLabel: "Correo electrónico",
        websiteLabel: "Sitio web",
        heroTitle: "Asociaciones de Distribución Internacional",
        heroSubtext:
          "GENOYA® es una marca global premium y estructurada, centrada exclusivamente en asociaciones de distribución a largo plazo y OEM.",
        contactUs: "Contactar con el Equipo de Exportación",
        exportTitle: "Capacidad Global de Exportación y Carga de Contenedores",
        fcl: "Carga de Contenedor Completo (FCL) Disponible",
        fclDesc:
          "Soporte para contenedores 20DC / 40HC / 45FT con coordinación de envío a todo el mundo.",
        mixedSku: "Carga de SKUs Mixtos",
        mixedSkuDesc:
          "Configuraciones de palés flexibles para múltiples variantes de producto.",
        compliance: "Cumplimiento Normativo y Garantía de Calidad",
        complianceDesc:
          "Supervisión total para garantizar el cumplimiento en los mercados de destino.",
        palletStandards: "Estándares de Palés Soportados",
        eurPallets: "Palés EUR / EPAL (1200 × 800 mm)",
        ukPallets: "Palés Estándar UK (1200 × 1000 mm)",
        usPallets: "Palés US GMA (48” × 40”)",
        whyPartnerTitle: "Por qué asociarse con GENOYA®",
        benefitScience: "Formulaciones Impulsadas por la Ciencia",
        benefitScienceDesc:
          "Nutrición monoproteica completa y equilibrada alineada con AAFCO/FEDIAF.",
        benefitSingleProtein: "Estricta Filosofía de Proteína Única",
        benefitSingleProteinDesc:
          "Sin pollo, sin subproductos; proteínas animales puras y trazables.",
        benefitProduction: "Producción Escalable Lista para Exportación",
        benefitProductionDesc:
          "Cargas de contenedores completos con flexibilidad de SKUs mixtos.",
        benefitLongTerm: "Asociación Estratégica a Largo Plazo",
        benefitLongTermDesc:
          "Integridad de marca y soporte dedicado al distribuidor.",
        officialOversight: "Supervisión Oficial de Exportación y Producción",
        oversightText:
          "Las operaciones de comercio internacional de GENOYA® y la supervisión de la producción OEM se gestionan a través de nuestra entidad de exportación designada para garantizar:",
        oversight1: "Cumplimiento normativo en mercados internacionales",
        oversight2:
          "Coordinación de exportación de Contenedor Completo (FCL) (20DC / 40HC / 45FT)",
        oversight3: "Supervisión de producción y garantía de calidad",
        oversight4: "Integridad de la marca y cumplimiento de la formulación",
        oversight5: "Gestión de asociaciones con distribuidores globales",
        exportContact: "Departamento de Exportación y Comercio Internacional",
        exportEntity: "Entidad Oficial de Exportación",
        founder: "Fundador y Director General Global",
        registeredAddress: "Dirección Registrada",
        inquiryTitle: "Envíe su Solicitud de Asociación",
        inquiryDesc:
          "Agradecemos las consultas serias de importadores nacionales, distribuidores regionales y socios estratégicos.",
        finalCtaTitle: "¿Listo para asociarse con GENOYA®?",
        finalCtaDesc:
          "Únase a nuestra red global de socios de distribución premium.",
        contactExport: "Contactar con el Equipo de Exportación",
        becomePartner: "Consultar Ahora",
        form: {
          companyName: "Nombre de la Empresa / Entidad Legal",
          country: "Mercado Principal / País",
          businessType: "Tipo de Negocio",
          select: "Seleccionar tipo",
          nationalImporter: "Importador Nacional",
          regionalDistributor: "Distribuidor Regional",
          premiumRetail: "Cadena de Retail Premium",
          vetChannel: "Canal Veterinario / Profesional",
          oem: "Socio OEM / Marca Blanca",
          volume: "Volumen Anual Estimado",
          volumePlaceholder: "ej. 10–50 contenedores / año",
          containerInterest: "Tamaño de Contenedor Preferido (si se conoce)",
          email: "Correo Electrónico Corporativo",
          phone: "Teléfono (con código de país)",
          submit: "Enviar Solicitud de Asociación",
        },
      },
      contact: {
        phone: "Teléfono",
  country: "País",
  optional: "opcional",
  selectCountry: "Seleccione su país",
  messagePlaceholder: "¿Cómo podemos ayudarle?",
  sending: "Enviando...",
  sendAnother: "Enviar otro mensaje",
  operatedBy: "Operado por",
  searchCountries: "Buscar países...",
  noResults: "Sin resultados",
        title: "Conecte con GENOYA™",
        generalTitle: "Consultas Generales",
        generalDesc:
          "Para información de productos y preguntas relacionadas con la marca:",
        partnershipTitle: "Consultas de Distribución",
        partnershipDesc:
          "Para asociaciones comerciales y oportunidades de distribución:",
        formName: "Nombre Completo",
        formEmail: "Correo Electrónico",
        formMessage: "Mensaje",
        sendButton: "Enviar Mensaje",
        name: "Nombre",
        email: "Correo Electrónico",
        message: "Mensaje",
        send: "Enviar",
        successTitle: "Mensaje Enviado con Éxito",
        successDesc:
          "Gracias por contactarnos. Nuestro equipo le responderá a la brevedad.",
      },
      nav: {
        home: "Inicio",
        about: "Nosotros",
        products: "Fórmulas",
        distributors: "Distribuidores",
        contact: "Contacto",
        toggleMenu: "Alternar navegación",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Todos los derechos reservados.",
        tagline: "Formulado por la Ciencia. Proteína Pura.",
        quickLinks: "Navegación",
        global: "Operaciones Globales",
        languages: "Selección de Idioma",
        distributorInfo: "Especificaciones de Exportación",
        email: "Correo de Contacto",
        legal: "Cumplimiento Normativo",
        privacy: "Política de Privacidad",
        terms: "Términos de Servicio",
      },
      privacy: {
        label: "Legal",
        title: "Política de Privacidad",
        lastUpdated: "Última actualización: marzo de 2026",
        intro:
          "GENOYA™ se compromete a proteger su información personal. Esta Política de Privacidad explica qué datos recopilamos cuando visita genoyapetfood.com, cómo los utilizamos y sus derechos sobre dicha información.",
        informationCollectedTitle: "Información que recopilamos",
        info1: "Formularios de contacto: nombre, correo electrónico, nombre de la empresa, país y contenido del mensaje.",
        info2: "Datos de uso: páginas visitadas, tiempo en el sitio, tipo de navegador e información del dispositivo recopilada a través de herramientas de analítica.",
        info3: "Cookies y tecnologías similares utilizadas para el rendimiento del sitio y la analítica.",
        howWeUseTitle: "Cómo utilizamos su información",
        use1: "Para responder a consultas de distribuidores y formularios de contacto.",
        use2: "Para analizar el rendimiento del sitio web y mejorar la experiencia del usuario.",
        use3: "Para cumplir con obligaciones legales.",
        use4: "No vendemos, alquilamos ni cedemos su información personal a terceros.",
        dataRetentionTitle: "Retención de datos",
        dataRetentionText:
          "Conservamos los datos del formulario de contacto durante el tiempo necesario para responder a su consulta y por un período razonable posterior a efectos de registro.",
        thirdPartyTitle: "Servicios de terceros",
        thirdPartyText:
          "Nuestro sitio web puede utilizar servicios de terceros como proveedores de analítica. Estos servicios pueden recopilar datos sujetos a sus propias políticas de privacidad.",
        cookiesTitle: "Cookies",
        cookie1: "Utilizamos cookies esenciales necesarias para el correcto funcionamiento del sitio.",
        cookie2: "Pueden utilizarse cookies de analítica para comprender cómo los visitantes interactúan con el sitio. Puede desactivar las cookies en la configuración de su navegador.",
        yourRightsTitle: "Sus derechos",
        right1: "Tiene derecho a solicitar acceso a los datos personales que tenemos sobre usted.",
        right2: "Puede solicitar la corrección o eliminación de sus datos en cualquier momento.",
        right3: "Para ejercer estos derechos, contáctenos en la dirección de correo electrónico indicada a continuación.",
        changesTitle: "Cambios en esta política",
        changesText:
          "Podemos actualizar esta Política de Privacidad periódicamente. La versión más reciente estará siempre disponible en esta página con la fecha actualizada.",
        contactText: "Para preguntas o solicitudes relacionadas con la privacidad, contáctenos en",
      },
      terms: {
        label: "Legal",
        title: "Términos de Servicio",
        lastUpdated: "Última actualización: marzo de 2026",
        intro:
          "Al acceder y utilizar el sitio web de GENOYA™ (genoyapetfood.com), usted acepta quedar vinculado por estos Términos de Servicio. Léalos detenidamente antes de utilizar el sitio.",
        acceptanceTitle: "Aceptación de los términos",
        acceptanceText:
          "El uso de este sitio web implica la aceptación de estos Términos de Servicio. Si no está de acuerdo con alguna parte de estos términos, no utilice el sitio web.",
        useOfSiteTitle: "Uso del sitio web",
        use1: "Puede utilizar este sitio únicamente con fines lícitos y de acuerdo con estos términos.",
        use2: "No debe utilizar el sitio de ninguna manera que pueda dañarlo, desactivarlo o perjudicar a otros usuarios.",
        use3: "No debe intentar obtener acceso no autorizado a ninguna parte del sitio o sus sistemas relacionados.",
        use4: "El uso comercial del contenido del sitio sin permiso previo por escrito de GENOYA™ está prohibido.",
        intellectualPropertyTitle: "Propiedad intelectual",
        intellectualPropertyText:
          "Todo el contenido de este sitio web — incluidos textos, imágenes, logotipos, nombres de productos, fórmulas y diseño — es propiedad de GENOYA™ y está protegido por las leyes de propiedad intelectual aplicables.",
        disclaimerTitle: "Exclusión de garantías",
        disclaimerText:
          "Este sitio web y su contenido se proporcionan \"tal cual\", sin garantías de ningún tipo, expresas o implícitas. GENOYA™ no garantiza que el sitio esté libre de interrupciones, errores o componentes dañinos.",
        limitationTitle: "Limitación de responsabilidad",
        limitationText:
          "En la máxima medida permitida por la ley, GENOYA™ no será responsable de ningún daño indirecto, incidental, especial o consecuente derivado del uso o la imposibilidad de uso de este sitio.",
        thirdPartyLinksTitle: "Enlaces a terceros",
        thirdPartyLinksText:
          "Este sitio web puede contener enlaces a sitios web de terceros. GENOYA™ no tiene control sobre el contenido ni las prácticas de dichos sitios y no asume responsabilidad alguna al respecto.",
        governingLawTitle: "Legislación aplicable",
        governingLawText:
          "Estos Términos de Servicio se regirán e interpretarán de conformidad con el derecho comercial internacional aplicable. Cualquier disputa se resolverá mediante negociación de buena fe entre las partes.",
        changesTitle: "Cambios en estos términos",
        changesText:
          "GENOYA™ se reserva el derecho de modificar estos Términos de Servicio en cualquier momento. El uso continuado del sitio web tras la publicación de cambios implica la aceptación de los términos actualizados.",
        contactText: "Para preguntas sobre estos Términos de Servicio, contáctenos en",
      },
    },
  },
  fr: {
    translation: {
      ingredientCategories: {
        protein: "Protéine",
        carb: "Glucide",
        oil: "Huile & Matière Grasse",
        prebiotic: "Prébiotique",
        probiotic: "Probiotique",
        superfood: "Superaliment",
        mineral: "Minéral",
        amino: "Acide Aminé",
        botanical: "Botanique",
        premix: "Prémélange Vitamines & Minéraux",
        other: "Autre",
        showLess: "− Moins",
        more: "de plus",
      },
      ingredients: {
        beef: "Bœuf",
        rabbit: "Lapin",
        duck: "Canard",
        lamb: "Agneau",
        turkey: "Dinde",
        whitefish: "Poisson Blanc",
        freshly_prepared_beef: "Bœuf Fraîchement Préparé",
        beef_meal: "Farine de Bœuf",
        dehydrated_beef_protein: "Protéine de Bœuf Déshydratée",
        freshly_prepared_rabbit: "Lapin Fraîchement Préparé",
        rabbit_meal: "Farine de Lapin",
        dehydrated_rabbit_protein: "Protéine de Lapin Déshydratée",
        freshly_prepared_turkey: "Dinde Fraîchement Préparée",
        turkey_meal: "Farine de Dinde",
        dehydrated_turkey_protein: "Protéine de Dinde Déshydratée",
        freshly_prepared_duck: "Canard Fraîchement Préparé",
        duck_meal: "Farine de Canard",
        dehydrated_duck_protein: "Protéine de Canard Déshydratée",
        freshly_prepared_whitefish: "Poisson Blanc Fraîchement Préparé",
        whitefish_meal: "Farine de Poisson Blanc",
        dehydrated_whitefish_protein: "Protéine de Poisson Blanc Déshydratée",
        freshly_prepared_lamb: "Agneau Fraîchement Préparé",
        lamb_meal: "Farine d'Agneau",
        dehydrated_lamb_protein: "Protéine d'Agneau Déshydratée",
        beef_broth: "Bouillon de Bœuf",
        lamb_broth: "Bouillon d'Agneau",
        rabbit_broth: "Bouillon de Lapin",
        turkey_broth: "Bouillon de Dinde",
        whitefish_broth: "Bouillon de Poisson Blanc",
        potato_flour: "Farine de Pomme de Terre",
        tapioca: "Tapioca",
        pumpkin: "Citrouille",
        dried_cellulose_fibre: "Fibre de Cellulose Séchée",
        salmon_oil: "Huile de Saumon",
        flaxseed: "Graine de Lin",
        dried_brewers_yeast: "Levure de Bière Séchée",
        probiotics: "Probiotiques",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Épinard",
        blueberry: "Myrtille",
        kelp_powder: "Poudre d'Algue Kelp",
        chicory_root: "Racine de Chicorée",
        inulin: "Inuline",
        fos: "FOS (Fructooligosaccharides)",
        mos: "MOS (Mannooligosaccharides)",
        yeast_β_glucans: "β-Glucanes de Levure",
        dicalcium_phosphate: "Phosphate Dicalcique",
        potassium_chloride: "Chlorure de Potassium",
        sodium_phosphate: "Phosphate de Sodium",
        dl_methionine: "DL-Méthionine",
        taurine: "Taurine",
        l_carnitine: "L-Carnitine",
        yucca_schidigera_extract: "Extrait de Yucca Schidigera",
        cranberry_extract: "Extrait de Canneberge",
        "turmeric_&_ginger_extracts": "Extraits de Curcuma & Gingembre",
        "rosemary_&_green_tea_extracts": "Extraits de Romarin & Thé Vert",
        "vitamin_&_mineral_premix": "Prémélange Vitamines & Minéraux",
      },
      home: {
        heroTitle1: "Formulé par la science.",
        heroTitle2: "Protéines pures.",
        heroTitle3: "Santé fonctionnelle.",
        heroSubtext:
          "Nutrition premium pour animaux à base de protéines uniques, conçue par des systèmes de formulation structurés pour favoriser la clarté digestive, l'équilibre métabolique et la vitalité à long terme.",
        viewProducts: "Explorer nos formules",
        becomeDistibutor: "Devenir distributeur",
        noChickenTitle:
          "Strictement sans poulet. Sans sous-produits de poulet.",
        noChickenSubtitle:
          "Toujours monoprotéique – Notre promesse fondamentale",
        noChickenText:
          "Chaque formule GENOYA utilise uniquement une source de protéine animale pure et nommée. Pas de protéines mixtes. Pas de poulet. Pas de sous-produits de poulet. Cette philosophie de protéine unique offre une nutrition de précision, une meilleure digestibilité et une gestion plus claire des allergies pour les animaux du monde entier.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ est une marque de nutrition animale premium formulée scientifiquement, reposant sur une philosophie stricte de protéine unique.",
        introPoint1: "Précision nutritionnelle",
        introPoint2: "Clarté digestive",
        introPoint3: "Complexité alimentaire réduite",
        introPoint4: "Optimisation de la santé fonctionnelle",
        introFooter:
          "Nous concevons des systèmes nutritionnels structurés — pas des produits basés sur les tendances.",
        diffTitle: "Différenciateurs clés",
        diff1Title: "Architecture de protéine animale unique",
        diff1Desc:
          "Chaque formule est construite autour d'une seule source de protéine animale primaire clairement définie.",
        diff2Title: "Formulation sans céréales",
        diff2Desc:
          "Structure macronutritionnelle équilibrée sans agents de remplissage inutiles.",
        diff3Title: "Politique sans poulet",
        diff3Desc:
          "Norme de pureté protéique stricte sur toutes les références. Sans poulet ni sous-produits de poulet.",
        diff4Title: "Intégration fonctionnelle",
        diff4Desc:
          "Prébiotiques, probiotiques, composés de soutien articulaire et équilibre optimisé en oméga.",
        scienceTitle: "Basé sur la recherche. Structuré pour la performance.",
        scienceLead: "Les formulations GENOYA™ sont élaborées à l'aide de :",
        sciencePoint1: "Rapports protéines/graisses contrôlés",
        sciencePoint2: "Profils équilibrés en Oméga 3 et 6",
        sciencePoint3: "Systèmes prébiotiques FOS & MOS",
        sciencePoint4: "β-glucanes pour le soutien immunitaire",
        sciencePoint5:
          "Glucosamine & Chondroïtine pour l'intégrité articulaire",
        sciencePoint6:
          "Taurine et L-Carnitine lorsque requis fonctionnellement",
        scienceFooter:
          "Chaque ingrédient sert un objectif défini. Chaque pourcentage suit une logique de formulation.",
        previewTitle: "Aperçu des formules",
        previewCats: "Chats",
        previewDogs: "Chiens",
        previewKitten: "Chaton",
        previewAdult: "Adulte",
        previewSterilised: "Adulte stérilisé",
        previewPuppy: "Chiot",
        previewSmallBreed: "Adulte petite race",
        previewAllBreeds: "Adulte (toutes races)",
        distributorHeading: "Opportunités de distribution mondiale",
        distributorSubtext:
          "GENOYA™ se développe via des partenariats internationaux structurés. Nous gérons les conteneurs 20DC, 40HC et 45ft avec une documentation prête pour l'exportation.",
        getStarted: "Devenir partenaire de GENOYA™",
      },
      about: {
        heroTitle1: "Nutrition de précision",
        heroTitle2: "Vision mondiale",
        heroSubtext:
          "GENOYA™ est une marque axée sur la science qui conçoit une nutrition animale premium en utilisant des systèmes basés sur la clarté de la protéine unique et la performance de la santé fonctionnelle.",
        viewProducts: "Voir toutes les formules",
        missionTitle: "Notre mission",
        missionText:
          "Concevoir une nutrition animale premium à l'aide de systèmes de formulation fondés sur la science, reposant sur la clarté de la protéine unique et la performance de la santé fonctionnelle.",
        valuesTitle: "Nos principes",
        value1: "Pureté des protéines",
        value1subtext:
          "Architecture de protéine animale unique sur toutes les références.",
        value2: "Intégrité nutritionnelle",
        value2subtext:
          "Formules structurées alignées sur les cadres nutritionnels reconnus.",
        value3: "Focus santé fonctionnelle",
        value3subtext:
          "Soutien digestif, intégrité articulaire, équilibre immunitaire et optimisation métabolique.",
        value4: "Sans poulet. Sans sous-produits de poulet.",
        value4subtext: "Une norme de marque GENOYA™ non négociable.",
        viewOurProducts: "Explorer les produits",
        leadershipTitle: "Expertise & Positioning",
        leadershipHeadText:
          " est construit par des professionnels expérimentés en :",
        leadershipValue1: "Commerce international d'aliments pour animaux",
        leadershipValue2: "Supervision de production OEM",
        leadershipValue3: "Développement d'architecture de marque",
        leadershipValue4: "Développement de la distribution",
        leadershipValue5: "Systèmes d'étiquetage conformes à la réglementation",
        leadershipTextBelow:
          "opère via des installations de production structurées en Chine sous des systèmes de formulation contrôlés et une supervision de la qualité conçus pour la distribution internationale.",
        leadershipTextFinal:
          "Nous bâtissons des marques structurées conçues pour une croissance mondiale à long terme.",
        noChickenTitle:
          "Strictement sans poulet. Sans sous-produits de poulet.",
        noChickenSubtitle:
          "Toujours monoprotéique – Notre engagement fondateur",
        noChickenText:
          "GENOYA® n'utilise jamais de poulet ou de sous-produits de poulet dans aucune de ses formules. Nous reposons sur une philosophie stricte de protéine unique : une source animale pure et nommée par produit. Cela garantit une meilleure digestibilité, une gestion plus claire des allergies et une transparence inégalée pour les propriétaires d'animaux du monde entier.",
        complianceTitle: "Déclaration de conformité nutritionnelle",
        complianceText:
          "Formulé pour répondre aux niveaux nutritionnels établis par les normes internationales reconnues, notamment les profils nutritionnels de l'AAFCO (Association of American Feed Control Officials) et les directives de la FEDIAF (Fédération européenne de l'industrie des aliments pour animaux familiers) pour les stades de vie respectifs.",
        complianceBold:
          "Nos produits sont complets et équilibrés pour tous les stades de vie.",
      },
      products: {
        heroTitle: "Formules avancées à protéine unique",
        heroSubtext:
          "Nutrition de précision avec des sources de protéines animales uniques, adaptées par espèce, stade de vie et objectifs de santé fonctionnelle.",
        selectSpecies: "Sélectionnez l'espèce de votre animal",
        backToSpecies: "Retour à la sélection de l'espèce",
        noProductsAvailable: "Aucun produit trouvé pour cette catégorie.",
        filter: "Filtrer",
        clearFilters: "Effacer les filtres",
        resetFilters: "Réinitialiser tout",
        format: "Format du produit",
        allFormats: "Tous les formats",
        formats: {
          dry: "Aliments secs",
          wet: "Aliments humides",
        },
        dryKibble: "Croquettes sèches",
        wetFood: "Pâtée / Aliments humides",
        ingredient: "Protéine primaire",
        allIngredients: "Toutes les protéines",
        lifeStage: "Stade de vie",
        allStages: "Tous les stades",
        healthGoal: "Objectif fonctionnel",
        allGoals: "Tous les objectifs",
        healthBenefits: "Avantages pour la santé",
        noResults: "Aucune formule ne correspond à vos critères.",
        details: "Détails de la formule",
        showLess: "Afficher moins",
        collapseAll: "Tout réduire",
        size: "Contenu net",
        ingredients: "Ingrédients",
        fullIngredients: "Composition complète",
        standard: "Norme de fabrication",
        packaging: "Type d'emballage",
        aboutProduct: "CARACTÉRISTIQUES",
        ingredientsLabel: "INGRÉDIENTS (COMPOSITION)",
        analysisLabel: "ANALYSE GARANTIE (si disponible)",
        nutritionalAdditives: {
          sectionHeader: "Additifs Nutritionnels (par kg)",
          vitamins: "Vitamines",
          traceElements: "Oligoéléments",
          functionalAdditives: "Additifs Fonctionnels",
          prebioticProbioticComplex: "Complexe Pré- et Probiotique",
          botanicalExtracts: "Extraits Botaniques",

          vitaminA: "Vitamine A",
          vitaminD3: "Vitamine D₃",
          vitaminE: "Vitamine E",
          vitaminC: "Vitamine C",
          vitaminB1: "Vitamine B₁",
          vitaminB2: "Vitamine B₂",
          vitaminB6: "Vitamine B₆",
          vitaminB12: "Vitamine B₁₂",
          niacin: "Niacine",
          pantothenicAcid: "Acide Pantothénique",
          folicAcid: "Acide Folique",
          biotin: "Biotine",
          cholineChloride: "Chlorure de Choline",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Méthionine",

          iron: "Fer",
          ferrousSulphate: "Sulfate Ferreux",
          zinc: "Zinc",
          zincSulphate: "Sulfate de Zinc",
          manganese: "Manganèse",
          manganeseSulphate: "Sulfate de Manganèse",
          copper: "Cuivre",
          copperSulphate: "Sulfate de Cuivre",
          iodine: "Iode",
          calciumIodate: "Iodate de Calcium",
          selenium: "Sélénium",
          sodiumSelenite: "Sélénite de Sodium",

          glucosamine: "Glucosamine",
          chondroitinSulphate: "Sulfate de Chondroïtine",
          yuccaSchidigeraExtract: "Extrait de Yucca Schidigera",
          cranberryExtract: "Extrait de Canneberge",

          inulinFOS: "Inuline (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucanes",
          probiotics: "Probiotiques",
          cfu: "UFC",

          rosemary: "Romarin",
          greenTea: "Thé Vert",
          turmeric: "Curcuma",
          ginger: "Gingembre",
          kelp: "Kelp",
          blueberry: "Myrtille",

          iu: "UI",
          mg: "mg",
          perKg: "par kg",
          asLabel: "sous forme de",
        },
        categories: {
          cat: "Nutrition féline",
          cats: "Nutrition féline",
          dog: "Nutrition canine",
          dogs: "Nutrition canine",
        },
        stages: {
          adult: "Adulte",
          adult_small_breed: "Adulte Petite Race",
          sterilised: "Stérilisé",
          dog: {
            junior: "Chiot",
          },
          cat: {
            junior: "Chaton",
          },
        },
        sizeCategory: "Taille / Race",
        allSizes: "Toutes les tailles",
        sizes: {
          allBreeds: "Toutes races",
          smallBreed: "Petite race",
          "all-breeds": "Toutes races",
          "small-breed": "Petite race",
          mediumBreed: "Race moyenne",
          largeBreed: "Grande race",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Santé digestive",
          skin: "Nutrition de la peau et du pelage",
          immune: "Soutien du système immunitaire",
          antioxidant: "Défense antioxydante",
          muscle: "Entretien musculaire",
          joint: "Soutien articulaire",
          weight: "Gestion du poids",
          urinary: "Santé des voies urinaires",
          brain: "Santé cérébrale et cognitive",
          bone: "Développement osseux et articulaire",
        },
        goals: {
          digestion: "Santé digestive",
          skin: "Nutrition de la peau et du pelage",
          weight: "Gestion du poids",
          urinary: "Santé des voies urinaires",
          immune: "Soutien immunitaire",
          antioxidant: "Protection antioxydante",
          muscle: "Entretien musculaire",
          joint: "Soutien articulaire",
        },
        flavors: {
          beef: "Bœuf",
          duck: "Canard",
          lamb: "Agneau",
          rabbit: "Lapin",
          turkey: "Dinde",
          whitefish: "Poisson blanc",
        },
        textures: {
          kibble: "Croquettes sèches",
          "chunks in jelly": "Bouchées en gelée",
        },
        linekey: {
          dailyCare: "Soin Quotidien",
          superfoodPlus: "Super Aliment+",
        },
        animals: {
          dog: "Chien",
          cat: "Chat",
        },
        description:
          "Une recette premium à protéine unique au {{flavor}} en format {{texture}}, conçue pour {{animal}} au stade de vie {{stage}}.",
        types: {
          dry: "Sec",
          wet: "Humide",
        },
        singleProtein: "monoprotéique",
        grainFree: "sans céréales",
        premiumCompleteFood: "Aliment complet et équilibré premium",
        frontView: "Vue de face",
        backView: "Vue de dos",
        feedingGuideNotAvailable:
          "Guide alimentaire non disponible pour ce produit.",
        technicalSpecs: "Spécifications techniques",
        keyBenefits: "Avantages fonctionnels clés",
        analyticalConstituents: "Constituants analytiques",
        feedingGuide: "Guide alimentaire",
        functionalIngredients: "Ingrédients fonctionnels & Additifs",
        petWeight: "Poids de l'animal",
        gramsPerDay: "Grammes par jour",
        viewBack: "Voir étiquette arrière",
        viewFront: "Voir étiquette avant",
        clickToZoom: "Cliquez sur l'image pour zoomer",
        analysis: {
          protein: "Protéines brutes",
          fat: "Matières grasses brutes",
          fiber: "Cellulose brute",
          ash: "Cendres brutes",
          omega3: "Acides gras Oméga-3",
          omega6: "Acides gras Oméga-6",
        },
        netContentLabel: "Contenu net",
        packagingTypeLabel: "Emballage",
        standardLabel: "Norme",
        pillarNoChicken:
          "Strictement sans poulet. Sans sous-produits de poulet. Toujours monoprotéique.",
        noChickenTitle: "Notre promesse fondamentale",
        noChickenText:
          "GENOYA® n'utilise jamais de poulet ou de sous-produits de poulet. Chaque formule est construite sur une source pure de protéine animale – complète et équilibrée pour le stade de vie.",
        filterReinforce:
          "Toutes les formules sont complètes et équilibrées – Strictement sans poulet / Toujours monoprotéique",
        complianceTitle: "Conformité nutritionnelle",
        complianceText:
          "Formulé pour répondre aux niveaux nutritionnels établis par les normes internationales reconnues, y compris les profils nutritionnels de l'AAFCO et les directives de la FEDIAF pour les stades de vie respectifs.",
        completeBalanced: "Complet et équilibré",
        nutritionalAdequacyTitle: "Déclaration d'adéquation nutritionnelle",
        nutritionalAdequacyText:
          "Formulé en alignement avec les directives reconnues des profils nutritionnels AAFCO et FEDIAF pour le stade de vie visé. L'adéquation nutritionnelle est basée sur l'analyse de la formulation.",
        regulatoryDisclaimer:
          "L'AAFCO et la FEDIAF sont des organismes de directives réglementaires. Les produits GENOYA™ ne sont pas approuvés ou certifiés par ces organismes.",
        tabs: {
          ingredients: "Ingrédients",
          feeding: "Guide alimentaire",
          nutrition: "Nutrition",
          aminoAcids: "Acides aminés",
        },
        analytical: {
          guaranteedAnalysis: "Analyse garantie",
          analyticalValues: "Valeurs analytiques",
          metabolisable_energy: "Énergie métabolisable",
          digestibility: "Digestibilité",
          estimated: "Estimé",
          crude_protein_min: "Protéines brutes (min)",
          crude_fat_min: "Matières grasses brutes (min)",
          crude_fibre_max: "Cellulose brute (max)",
          crude_ash_max: "Cendres brutes (max)",
          moisture_max: "Humidité (max)",
          taurine: "Taurine",
          omega3: "Oméga-3 Acides Gras",
          omega6: "Oméga-6 Acides Gras",
          calcium_min: "Calcium (min)",
          calcium_max: "Calcium (max)",
          phosphorus_min: "Phosphore (min)",
          phosphorus_max: "Phosphore (max)",
          l_carnitine: "L-Carnitine",
          metabolisable_energy_kcal: "Énergie métabolisable (kcal/kg)",
          metabolisable_energy_mj: "Énergie métabolisable (MJ/kg)",
          omega3_fatty_acids: "Acides Gras Oméga-3",
          omega6_fatty_acids: "Acides Gras Oméga-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Glucosamine",
          chondroitin_sulphate: "Sulfate de Chondroïtine",
          dl_methionine_ga: "DL-Méthionine",
          sodium: "Sodium",
          magnesium: "Magnésium",
          potassium: "Potassium",
          ca_p_ratio: "Rapport Calcium : Phosphore",
        },
        fullIngredientList: "Liste complète des ingrédients",
        functionalHighlights: "Points fonctionnels clés",
        storageShelfLife: "Conservation et durée de vie",
        storageText:
          "DURÉE DE CONSERVATION : 18 mois à compter de la date de fabrication.\nCONSERVATION & SÉCURITÉ\nConserver dans un endroit frais et sec.\nRefermer après ouverture.\nNe pas congeler.",
        storageTextWet:
          "DURÉE DE CONSERVATION : 3 ans (non ouvert à compter de la date de fabrication).\nCONSERVATION & SÉCURITÉ\nConserver dans un endroit frais et sec, à l'abri de la lumière directe du soleil.\nRéfrigérer après ouverture et consommer dans les 5 jours.\nNe pas congeler.",
        functionalIngredientsText:
          "INGRÉDIENTS FONCTIONNELS\n- Inuline (FOS) : Soutient l'équilibre du microbiome\n- MOS : Aide à bloquer les bactéries intestinales nuisibles\n- β-Glucanes : Soutient la fonction immunitaire\nHuile de saumon : EPA et DHA favorisent le développement cérébral et visuel\nDL-Méthionine : Soutient la santé urinaire\nTaurine : Essentielle pour la fonction cardiaque, la vision et le soutien neurologique",
        complianceTemplates: {
          kitten_cat:
            "{{name}} est formulé pour répondre aux niveaux nutritionnels établis par les Profils de Nutriments pour Aliments pour Chats de l'AAFCO pour la Croissance et la Reproduction, et est conforme aux directives nutritionnelles de la FEDIAF pour les aliments complets et équilibrés pour chatons.",
          adult_cat:
            "{{name}} est formulé pour répondre aux niveaux nutritionnels établis par les Profils de Nutriments pour Aliments pour Chats de l'AAFCO pour l'Entretien des Adultes et est conforme aux directives nutritionnelles de la FEDIAF pour les aliments complets et équilibrés pour chats adultes.",
          sterilised_cat:
            "{{name}} est formulé pour répondre aux niveaux nutritionnels établis par les Profils de Nutriments pour Aliments pour Chats de l'AAFCO pour l'Entretien des Adultes et est conforme aux directives nutritionnelles de la FEDIAF pour les aliments complets et équilibrés pour chats adultes stérilisés.",
          smallbreed_puppy:
            "{{name}} est formulé pour répondre aux niveaux nutritionnels établis par les Profils de Nutriments pour Aliments pour Chiens de l'AAFCO pour la Croissance et est conforme aux directives nutritionnelles de la FEDIAF pour les aliments complets et équilibrés pour chiots de petite race.",
          medlarge_puppy:
            "{{name}} est formulé pour répondre aux niveaux nutritionnels établis par les Profils de Nutriments pour Aliments pour Chiens de l'AAFCO pour la Croissance et est conforme aux directives nutritionnelles de la FEDIAF pour les aliments complets et équilibrés pour chiots de race moyenne et grande.",
          adult_small_dog:
            "{{name}} est un aliment fonctionnel sans céréales à protéine animale unique formulé pour répondre aux besoins nutritionnels des chiens adultes de petite race. Élaboré exclusivement avec {{protein}} comme seule source de protéine animale, il soutient le maintien musculaire, la peau et le pelage, la santé digestive, la fonction immunitaire et la vitalité. Sans volaille, céréales, soja ni conservateurs artificiels. Aliment complet et équilibré pour chiens adultes de petite race.",
          adult_allbreed_dog:
            "{{name}} est un aliment fonctionnel sans céréales à protéine animale unique formulé pour répondre aux besoins nutritionnels des chiens adultes de toutes races. Élaboré exclusivement avec {{protein}} comme seule source de protéine animale, il soutient le maintien musculaire, la peau et le pelage, la santé digestive, la fonction immunitaire et la vitalité. Sans volaille, céréales, soja ni conservateurs artificiels. Aliment complet et équilibré pour chiens adultes.",
        },
        complianceStatement: "Déclaration de conformité",
        nutritionalAdditivesPerKg: "Additifs nutritionnels (par kg)",
        vitamins: "Vitamines",
        traceElements: "Oligoéléments",
        functionalAdditives: "Additifs fonctionnels",
        prebioticProbioticComplex: "Complexe Pré- et Probiotique",
        botanicalExtracts: "Extraits botaniques",
        aminoAcids: {
          lysine: "Lysine",
          methionine: "Méthionine",
          threonine: "Thréonine",
          tryptophan: "Tryptophane",
          leucine: "Leucine",
          isoleucine: "Isoleucine",
          valine: "Valine",
          histidine: "Histidine",
          phenylalanine: "Phénylalanine",
          arginine: "Arginine",
        },
        aminoAcidProfile: "Profil en acides aminés essentiels",
        aminoNote:
          "† Valeurs approximatives. La taurine est ajoutée en tant qu'additif nutritionnel au niveau minimum déclaré.",
        feeding: {
          day: "jour",
          can: "boîte",
          cans: "boîtes",
          dryNote:
            "Les quantités sont des repères journaliers. Diviser en 2 à 3 repas. Fournir toujours de l'eau fraîche.",
          kitten__2_4months: "Chaton (2–4 mois)",
          kitten__4_6months: "Chaton (4–6 mois)",
          junior_7_12months: "Junior (7–12 mois)",
          puppy___2_4_months: "Chiot (2–4 mois)",
          puppy___4_9_months: "Chiot (4–9 mois)",
          junior__7_9_months: "Junior (7–9 mois)",
          junior__9_12_months: "Junior (9–12 mois)",
          junior___9_12_months: "Junior (9–12 mois)",
          junior___12_15_months: "Junior (12–15 mois)",
          junior__15_20_months: "Junior (15–20 mois)",
          adult_cat__1_3_yrs: "Chat adulte (1–3 ans)",
          adult_cat__3_7_yrs: "Chat adulte (3–7 ans)",
          adult_cat__7__yrs: "Chat adulte (7+ ans)",
          adult_dog__1_3_yrs: "Chien adulte (1–3 ans)",
          adult_dog___3_7_yrs: "Chien adulte (3–7 ans)",
          adult_dog__7__yrs: "Chien adulte (7+ ans)",
          "1_3_yrs": "1–3 ans",
          "3_7_yrs": "3–7 ans",
          "7__yrs": "7+ ans",
          stage_label: "Stade de vie",
        },
      },
      distributors: {
        emailLabel: "E-mail",
        websiteLabel: "Site web",
        heroTitle: "Partenariats de distribution internationale",
        heroSubtext:
          "GENOYA® est une marque mondiale premium et structurée axée exclusivement sur la distribution à long terme et les partenariats OEM.",
        contactUs: "Contacter l'équipe export",
        exportTitle:
          "Capacité mondiale d'exportation et de chargement de conteneurs",
        fcl: "Chargement complet de conteneur (FCL) disponible",
        fclDesc:
          "Conteneurs 20DC / 40HC / 45FT gérés avec coordination d'expédition mondiale.",
        mixedSku: "Chargement SKU mixte",
        mixedSkuDesc:
          "Configurations de palettes flexibles pour plusieurs variantes de produits.",
        compliance: "Conformité réglementaire et assurance qualité",
        complianceDesc:
          "Surveillance complète pour assurer la conformité sur les marchés cibles.",
        palletStandards: "Normes de palettes supportées",
        eurPallets: "Palettes EUR / EPAL (1200 × 800 mm)",
        ukPallets: "Palettes standard UK (1200 × 1000 mm)",
        usPallets: "Palettes US GMA (48” × 40”)",
        whyPartnerTitle: "Pourquoi devenir partenaire de GENOYA®",
        benefitScience: "Formulations basées sur la science",
        benefitScienceDesc:
          "Nutrition monoprotéique complète et équilibrée alignée sur l'AAFCO/FEDIAF.",
        benefitSingleProtein: "Philosophie stricte de protéine unique",
        benefitSingleProteinDesc:
          "Pas de poulet, pas de sous-produits – des protéines animales pures et traçables.",
        benefitProduction: "Production évolutive prête pour l'exportation",
        benefitProductionDesc:
          "Chargements complets de conteneurs avec flexibilité de SKU mixte.",
        benefitLongTerm: "Partenariat stratégique à long terme",
        benefitLongTermDesc:
          "Intégrité de la marque et soutien dédié aux distributeurs.",
        officialOversight:
          "Supervision officielle des exportations et de la production",
        oversightText:
          "Les opérations de commerce international de GENOYA® et la supervision de la production OEM sont gérées par notre entité d'exportation désignée pour garantir :",
        oversight1:
          "La conformité réglementaire sur les marchés internationaux",
        oversight2: "La coordination de l'exportation FCL (20DC / 40HC / 45FT)",
        oversight3: "La supervision de la production et l'assurance qualité",
        oversight4:
          "L'intégrité de la marque et la conformité des formulations",
        oversight5: "La gestion des partenariats de distribution mondiale",
        exportContact:
          "Département de l'exportation et du commerce international",
        exportEntity: "Entité d'exportation officielle",
        founder: "Fondateur et Directeur Général Mondial",
        registeredAddress: "Siège social",
        inquiryTitle: "Soumettre votre demande de partenariat",
        inquiryDesc:
          "Nous accueillons les demandes sérieuses d'importateurs nationaux, de distributeurs régionaux et de partenaires stratégiques.",
        finalCtaTitle: "Prêt à devenir partenaire de GENOYA® ?",
        finalCtaDesc:
          "Rejoignez notre réseau mondial de partenaires de distribution premium.",
        contactExport: "Contacter l'équipe export",
        becomePartner: "Faire une demande",
        form: {
          companyName: "Nom de la société / Entité juridique",
          country: "Marché principal / Pays",
          businessType: "Type d'entreprise",
          select: "Sélectionnez le type",
          nationalImporter: "Importateur national",
          regionalDistributor: "Distributeur régional",
          premiumRetail: "Chaîne de vente au détail premium",
          vetChannel: "Canal vétérinaire / professionnel",
          oem: "Partenaire OEM / Marque blanche",
          volume: "Volume annuel estimé",
          volumePlaceholder: "ex: 10–50 conteneurs / an",
          containerInterest: "Taille de conteneur préférée (si connue)",
          email: "E-mail professionnel",
          phone: "Téléphone (avec indicatif pays)",
          submit: "Envoyer la demande de partenariat",
        },
      },
      contact: {
        phone: "Téléphone",
  country: "Pays",
  optional: "optionnel",
  selectCountry: "Sélectionnez votre pays",
  messagePlaceholder: "Comment pouvons-nous vous aider ?",
  sending: "Envoi en cours...",
  sendAnother: "Envoyer un autre message",
  operatedBy: "Opéré par",
  searchCountries: "Rechercher des pays...",
  noResults: "Aucun résultat",
        title: "Contactez GENOYA™",
        generalTitle: "Demandes générales",
        generalDesc:
          "Pour des informations sur les produits et des questions relatives à la marque :",
        partnershipTitle: "Demandes de distribution",
        partnershipDesc:
          "Pour les partenariats commerciaux et opportunités de distribution :",
        formName: "Nom complet",
        formEmail: "Adresse e-mail",
        formMessage: "Message",
        sendButton: "Envoyer le message",
        name: "Nom",
        email: "Adresse e-mail",
        message: "Message",
        send: "Envoyer",
        successTitle: "Message Envoyé avec Succès",
        successDesc:
          "Merci de nous avoir contactés. Notre équipe vous répondra dans les plus brefs délais.",
      },
      nav: {
        home: "Accueil",
        about: "À propos",
        products: "Formules",
        distributors: "Distributeurs",
        contact: "Contact",
        toggleMenu: "Basculer la navigation",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Tous droits réservés.",
        tagline: "Formulé par la science. Protéines pures.",
        quickLinks: "Navigation",
        global: "Opérations mondiales",
        languages: "Sélection de la langue",
        distributorInfo: "Spécifications export",
        email: "E-mail de contact",
        legal: "Conformité",
        privacy: "Politique de confidentialité",
        terms: "Conditions d'utilisation",
      },
      privacy: {
        label: "Mentions légales",
        title: "Politique de confidentialité",
        lastUpdated: "Dernière mise à jour : mars 2026",
        intro:
          "GENOYA™ s'engage à protéger vos informations personnelles. Cette politique de confidentialité explique les données que nous collectons lorsque vous visitez genoyapetfood.com, la manière dont nous les utilisons et vos droits concernant ces données.",
        informationCollectedTitle: "Informations collectées",
        info1: "Formulaires de contact : nom, adresse e-mail, nom de l'entreprise, pays et contenu du message.",
        info2: "Données d'utilisation : pages visitées, temps passé sur le site, type de navigateur et informations sur l'appareil collectées via des outils d'analyse.",
        info3: "Cookies et technologies similaires utilisés pour la performance du site et l'analyse.",
        howWeUseTitle: "Utilisation de vos informations",
        use1: "Pour répondre aux demandes des distributeurs et aux formulaires de contact.",
        use2: "Pour analyser les performances du site web et améliorer l'expérience utilisateur.",
        use3: "Pour respecter les obligations légales.",
        use4: "Nous ne vendons, ne louons ni ne partageons vos informations personnelles à des tiers.",
        dataRetentionTitle: "Conservation des données",
        dataRetentionText:
          "Nous conservons les données des formulaires de contact aussi longtemps que nécessaire pour répondre à votre demande, puis pendant une période raisonnable à des fins d'archivage.",
        thirdPartyTitle: "Services tiers",
        thirdPartyText:
          "Notre site web peut utiliser des services tiers tels que des fournisseurs d'analyse. Ces services peuvent collecter des données soumises à leurs propres politiques de confidentialité.",
        cookiesTitle: "Cookies",
        cookie1: "Nous utilisons des cookies essentiels nécessaires au bon fonctionnement du site.",
        cookie2: "Des cookies d'analyse peuvent être utilisés pour comprendre comment les visiteurs interagissent avec le site. Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.",
        yourRightsTitle: "Vos droits",
        right1: "Vous avez le droit de demander l'accès aux données personnelles que nous détenons à votre sujet.",
        right2: "Vous pouvez demander la correction ou la suppression de vos données à tout moment.",
        right3: "Pour exercer ces droits, contactez-nous à l'adresse e-mail indiquée ci-dessous.",
        changesTitle: "Modifications de cette politique",
        changesText:
          "Nous pouvons mettre à jour cette politique de confidentialité à tout moment. La version la plus récente sera toujours disponible sur cette page avec la date de mise à jour.",
        contactText: "Pour toute question relative à la confidentialité, contactez-nous à",
      },
      terms: {
        label: "Mentions légales",
        title: "Conditions d'utilisation",
        lastUpdated: "Dernière mise à jour : mars 2026",
        intro:
          "En accédant et en utilisant le site web de GENOYA™ (genoyapetfood.com), vous acceptez d'être lié par ces Conditions d'utilisation. Veuillez les lire attentivement avant d'utiliser le site.",
        acceptanceTitle: "Acceptation des conditions",
        acceptanceText:
          "L'utilisation de ce site web constitue une acceptation de ces Conditions d'utilisation. Si vous n'acceptez pas une partie de ces conditions, veuillez ne pas utiliser le site.",
        useOfSiteTitle: "Utilisation du site web",
        use1: "Vous pouvez utiliser ce site uniquement à des fins légales et conformément à ces conditions.",
        use2: "Vous ne devez pas utiliser le site d'une manière qui pourrait l'endommager, le désactiver ou nuire à d'autres utilisateurs.",
        use3: "Vous ne devez pas tenter d'obtenir un accès non autorisé à une partie du site ou à ses systèmes associés.",
        use4: "L'utilisation commerciale du contenu du site sans autorisation écrite préalable de GENOYA™ est interdite.",
        intellectualPropertyTitle: "Propriété intellectuelle",
        intellectualPropertyText:
          "Tout le contenu de ce site web — y compris les textes, images, logos, noms de produits, formules et design — est la propriété de GENOYA™ et est protégé par les lois applicables en matière de propriété intellectuelle.",
        disclaimerTitle: "Exclusion de garanties",
        disclaimerText:
          "Ce site web et son contenu sont fournis \"en l'état\", sans garantie d'aucune sorte, expresse ou implicite. GENOYA™ ne garantit pas que le site sera continu, exempt d'erreurs ou de composants nuisibles.",
        limitationTitle: "Limitation de responsabilité",
        limitationText:
          "Dans toute la mesure permise par la loi, GENOYA™ ne sera pas responsable des dommages indirects, accessoires, spéciaux ou consécutifs résultant de votre utilisation ou de votre impossibilité d'utiliser ce site.",
        thirdPartyLinksTitle: "Liens vers des tiers",
        thirdPartyLinksText:
          "Ce site web peut contenir des liens vers des sites tiers. GENOYA™ n'a aucun contrôle sur le contenu ou les pratiques de ces sites et n'assume aucune responsabilité à leur égard.",
        governingLawTitle: "Droit applicable",
        governingLawText:
          "Ces Conditions d'utilisation sont régies et interprétées conformément au droit commercial international applicable. Tout litige sera résolu par voie de négociation de bonne foi entre les parties.",
        changesTitle: "Modifications des conditions",
        changesText:
          "GENOYA™ se réserve le droit de modifier ces Conditions d'utilisation à tout moment. La poursuite de l'utilisation du site après la publication des modifications constitue une acceptation des conditions mises à jour.",
        contactText: "Pour toute question concernant ces Conditions d'utilisation, contactez-nous à",
      },
    },
  },
  de: {
    translation: {
      ingredientCategories: {
        protein: "Protein",
        carb: "Kohlenhydrat",
        oil: "Öl & Fett",
        prebiotic: "Präbiotikum",
        probiotic: "Probiotikum",
        superfood: "Superfood",
        mineral: "Mineral",
        amino: "Aminosäure",
        botanical: "Botanisch",
        premix: "Vitamin- & Mineralstoff-Vormischung",
        other: "Sonstiges",
        showLess: "− Weniger",
        more: "mehr",
      },
      ingredients: {
        beef: "Rind",
        rabbit: "Kaninchen",
        duck: "Ente",
        lamb: "Lamm",
        turkey: "Pute",
        whitefish: "Weißfisch",
        freshly_prepared_beef: "Frisch zubereitetes Rindfleisch",
        beef_meal: "Rindfleischmehl",
        dehydrated_beef_protein: "Dehydriertes Rinderprotein",
        freshly_prepared_rabbit: "Frisch zubereitetes Kaninchen",
        rabbit_meal: "Kaninchenmehl",
        dehydrated_rabbit_protein: "Dehydriertes Kaninchenprotein",
        freshly_prepared_turkey: "Frisch zubereitete Pute",
        turkey_meal: "Putenmehl",
        dehydrated_turkey_protein: "Dehydriertes Putenprotein",
        freshly_prepared_duck: "Frisch zubereitete Ente",
        duck_meal: "Entenmehl",
        dehydrated_duck_protein: "Dehydriertes Entenprotein",
        freshly_prepared_whitefish: "Frisch zubereiteter Weißfisch",
        whitefish_meal: "Weißfischmehl",
        dehydrated_whitefish_protein: "Dehydriertes Weißfischprotein",
        freshly_prepared_lamb: "Frisch zubereitetes Lamm",
        lamb_meal: "Lammmehl",
        dehydrated_lamb_protein: "Dehydriertes Lammprotein",
        beef_broth: "Rinderbrühe",
        lamb_broth: "Lammbrühe",
        rabbit_broth: "Kaninchenbrühe",
        turkey_broth: "Putenbrühe",
        whitefish_broth: "Weißfischbrühe",
        potato_flour: "Kartoffelmehl",
        tapioca: "Tapioka",
        pumpkin: "Kürbis",
        dried_cellulose_fibre: "Getrocknete Cellulosefaser",
        salmon_oil: "Lachsöl",
        flaxseed: "Leinsamen",
        dried_brewers_yeast: "Getrocknete Bierhefe",
        probiotics: "Probiotika",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Spinat",
        blueberry: "Heidelbeere",
        kelp_powder: "Kelpmehl",
        chicory_root: "Zichorienwurzel",
        inulin: "Inulin",
        fos: "FOS (Fructooligosaccharide)",
        mos: "MOS (Mannanoligosaccharide)",
        yeast_β_glucans: "Hefe-β-Glucane",
        dicalcium_phosphate: "Dicalciumphosphat",
        potassium_chloride: "Kaliumchlorid",
        sodium_phosphate: "Natriumphosphat",
        dl_methionine: "DL-Methionin",
        taurine: "Taurin",
        l_carnitine: "L-Carnitin",
        yucca_schidigera_extract: "Yucca-Schidigera-Extrakt",
        cranberry_extract: "Cranberry-Extrakt",
        "turmeric_&_ginger_extracts": "Kurkuma- & Ingwerextrakte",
        "rosemary_&_green_tea_extracts": "Rosmarin- & Grüntee-Extrakte",
        "vitamin_&_mineral_premix": "Vitamin- & Mineralstoff-Vormischung",
      },
      home: {
        heroTitle1: "Wissenschaftlich formuliert.",
        heroTitle2: "Reine Proteine.",
        heroTitle3: "Funktionale Gesundheit.",
        heroSubtext:
          "Premium-Tiernahrung auf Monoprotein-Basis, entwickelt durch strukturierte Formulierungssysteme zur Förderung der Verdauungsklarheit, des metabolischen Gleichgewichts und der langfristigen Vitalität.",
        viewProducts: "Unsere Rezepturen entdecken",
        becomeDistibutor: "Vertriebspartner werden",
        noChickenTitle:
          "Strikt ohne Huhn. Keine hühnerbasierten Nebenerzeugnisse.",
        noChickenSubtitle: "Immer Monoprotein – Unser zentrales Versprechen",
        noChickenText:
          "Jede GENOYA-Rezeptur verwendet ausschließlich eine einzige, klar benannte tierische Proteinquelle. Keine gemischten Proteine. Kein Huhn. Keine Nebenerzeugnisse vom Huhn. Diese Monoprotein-Philosophie bietet präzise Ernährung, bessere Verdaulichkeit und ein klares Allergiemanagement für Haustiere weltweit.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ ist eine wissenschaftlich fundierte Premium-Tiernahrungsmarke, die auf einer strikten Monoprotein-Philosophie basiert.",
        introPoint1: "Ernährungspräzision",
        introPoint2: "Klarheit der Verdauung",
        introPoint3: "Reduzierte diätetische Komplexität",
        introPoint4: "Optimierung der funktionalen Gesundheit",
        introFooter:
          "Wir entwickeln strukturierte Ernährungssysteme – keine trendbasierten Produkte.",
        diffTitle: "Hauptmerkmale",
        diff1Title: "Einzeltierprotein-Architektur",
        diff1Desc:
          "Jede Rezeptur basiert auf einer einzigen, klar definierten primären tierischen Proteinquelle.",
        diff2Title: "Getreidefreie Rezeptur",
        diff2Desc:
          "Ausgewogene Makronährstoffstruktur ohne unnötige Füllstoffe.",
        diff3Title: "Keine-Huhn-Politik",
        diff3Desc:
          "Strikter Standard für Proteinpureté über alle Produkte hinweg. Ohne Huhn oder hühnerbasierte Nebenerzeugnisse.",
        diff4Title: "Funktionale Integration",
        diff4Desc:
          "Präbiotika, Probiotika, Verbindungen zur Gelenkunterstützung und optimiertes Omega-Gleichgewicht.",
        scienceTitle: "Forschungsbasiert. Auf Leistung strukturiert.",
        scienceLead:
          "GENOYA™-Formulierungen werden entwickelt unter Verwendung von:",
        sciencePoint1: "Kontrollierten Protein-Fett-Verhältnissen",
        sciencePoint2: "Ausgewogenen Omega-3- und 6-Profilen",
        sciencePoint3: "Präbiotischen FOS- & MOS-Systemen",
        sciencePoint4: "β-Glucanen zur Unterstützung des Immunsystems",
        sciencePoint5: "Glucosamin & Chondroitin für die Gelenkintegrität",
        sciencePoint6: "Taurin und L-Carnitin bei funktionalem Bedarf",
        scienceFooter:
          "Jeder Inhaltsstoff dient einem definierten Zweck. Jeder Prozentsatz folgt einer Formulierungslogik.",
        previewTitle: "Rezeptur-Übersicht",
        previewCats: "Katzen",
        previewDogs: "Hunde",
        previewKitten: "Kätzchen",
        previewAdult: "Erwachsen",
        previewSterilised: "Erwachsen (Sterilisiert)",
        previewPuppy: "Welpe",
        previewSmallBreed: "Erwachsen (Kleine Rassen)",
        previewAllBreeds: "Erwachsen (Alle Rassen)",
        distributorHeading: "Globale Vertriebsmöglichkeiten",
        distributorSubtext:
          "GENOYA™ expandiert durch strukturierte internationale Partnerschaften. Wir wickeln 20DC-, 40HC- und 45ft-Container mit exportfertiger Dokumentation ab.",
        getStarted: "Partner von GENOYA™ werden",
      },
      about: {
        heroTitle1: "Präzisionsernährung",
        heroTitle2: "Globale Vision",
        heroSubtext:
          "GENOYA™ ist eine wissenschaftsorientierte Marke, die Premium-Tiernahrung auf Basis von Monoprotein-Klarheit und funktionaler Gesundheitsleistung entwickelt.",
        viewProducts: "Alle Rezepturen anzeigen",
        missionTitle: "Unsere Mission",
        missionText:
          "Premium-Tiernahrung durch wissenschaftlich fundierte Formulierungssysteme zu entwerfen, die auf Monoprotein-Reinheit und funktionaler Leistung basieren.",
        valuesTitle: "Unsere Prinzipien",
        value1: "Proteinreinheit",
        value1subtext:
          "Einzeltierprotein-Architektur über alle Produktlinien hinweg.",
        value2: "Ernährungsintegrität",
        value2subtext:
          "Strukturierte Rezepturen, die an anerkannten Ernährungsrahmen ausgerichtet sind.",
        value3: "Fokus auf funktionale Gesundheit",
        value3subtext:
          "Verdauungsunterstützung, Gelenkintegrität, Immunbalance und Stoffwechseloptimierung.",
        value4: "Kein Huhn. Keine hühnerbasierten Nebenerzeugnisse.",
        value4subtext: "Ein nicht verhandelbarer GENOYA™ Markenstandard.",
        viewOurProducts: "Produkte erkunden",
        leadershipTitle: "Expertise & Positionierung",
        leadershipHeadText:
          " wurde von Fachleuten entwickelt mit Erfahrung in:",
        leadershipValue1: "Internationalem Tiernahrungshandel",
        leadershipValue2: "OEM-Produktionsüberwachung",
        leadershipValue3: "Markenarchitektur-Entwicklung",
        leadershipValue4: "Vertriebsskalierung",
        leadershipValue5: "Regelkonformen Kennzeichnungssystemen",
        leadershipTextBelow:
          "operiert über strukturierte Produktionsstätten in China unter kontrollierten Formulierungssystemen und Qualitätsüberwachung für den internationalen Vertrieb.",
        leadershipTextFinal:
          "Wir bauen strukturierte Marken auf, die auf langfristiges globales Wachstum ausgelegt sind.",
        noChickenTitle:
          "Strikt ohne Huhn. Keine hühnerbasierten Nebenerzeugnisse.",
        noChickenSubtitle: "Immer Monoprotein – Unser Gründungsversprechen",
        noChickenText:
          "GENOYA® verwendet niemals Huhn oder hühnerbasierte Nebenerzeugnisse in irgendeiner Rezeptur. Wir stützen uns auf eine strikte Monoprotein-Philosophie: eine reine, benannte tierische Quelle pro Produkt. Dies garantiert bessere Verdaulichkeit und unübertroffene Transparenz für Tierhalter weltweit.",
        complianceTitle: "Erklärung zur Ernährungskonformität",
        complianceText:
          "Formuliert, um die Ernährungsniveaus zu erfüllen, die von anerkannten internationalen Standards festgelegt wurden, einschließlich der AAFCO-Nährstoffprofile und der FEDIAF-Richtlinien für die jeweiligen Lebensphasen.",
        complianceBold:
          "Unsere Produkte sind alle vollständig und ausgewogen für alle Lebensphasen.",
      },
      products: {
        heroTitle: "Fortschrittliche Monoprotein-Rezepturen",
        heroSubtext:
          "Präzisionsernährung mit Einzeltierproteinquellen, angepasst nach Spezies, Lebensphase und funktionalen Gesundheitszielen.",
        selectSpecies: "Wählen Sie die Spezies Ihres Haustieres",
        backToSpecies: "Zurück zur Spezies-Auswahl",
        noProductsAvailable: "Keine Produkte für diese Kategorie gefunden.",
        filter: "Filter",
        clearFilters: "Filter löschen",
        resetFilters: "Alles zurücksetzen",
        format: "Produktformat",
        allFormats: "Alle Formate",
        formats: {
          dry: "Trockenfutter",
          wet: "Nassfutter",
        },
        dryKibble: "Trockenfutter (Kroketten)",
        wetFood: "Nassfutter",
        ingredient: "Primärprotein",
        allIngredients: "Alle Proteine",
        lifeStage: "Lebensphase",
        allStages: "Alle Phasen",
        healthGoal: "Funktionales Ziel",
        allGoals: "Alle Ziele",
        healthBenefits: "Gesundheitliche Vorteile",
        noResults:
          "Keine Rezepturen gefunden, die Ihren Kriterien entsprechen.",
        details: "Rezeptur-Details",
        showLess: "Weniger anzeigen",
        collapseAll: "Alles einklappen",
        size: "Nettoinhalt",
        ingredients: "Zutaten",
        fullIngredients: "Vollständige Zusammensetzung",
        standard: "Herstellungsstandard",
        packaging: "Verpackungsart",
        aboutProduct: "EIGENSCHAFTEN",
        ingredientsLabel: "ZUTATEN (ZUSAMMENSETZUNG)",
        analysisLabel: "GARANTIERTE ANALYSE (sofern verfügbar)",
        nutritionalAdditives: {
          sectionHeader: "Nutritional Additives (per kg)",
          vitamins: "Vitamins",
          traceElements: "Trace Elements",
          functionalAdditives: "Functional Additives",
          prebioticProbioticComplex: "Pre- & Probiotic Complex",
          botanicalExtracts: "Botanical Extracts",

          // Vitamins
          vitaminA: "Vitamin A",
          vitaminD3: "Vitamin D₃",
          vitaminE: "Vitamin E",
          vitaminC: "Vitamin C",
          vitaminB1: "Vitamin B₁",
          vitaminB2: "Vitamin B₂",
          vitaminB6: "Vitamin B₆",
          vitaminB12: "Vitamin B₁₂",
          niacin: "Niacin",
          pantothenicAcid: "Pantothenic Acid",
          folicAcid: "Folic Acid",
          biotin: "Biotin",
          cholineChloride: "Choline Chloride",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Methionine",

          // Trace Elements
          iron: "Iron",
          ferrousSulphate: "Ferrous Sulphate",
          zinc: "Zinc",
          zincSulphate: "Zinc Sulphate",
          manganese: "Manganese",
          manganeseSulphate: "Manganese Sulphate",
          copper: "Copper",
          copperSulphate: "Copper Sulphate",
          iodine: "Iodine",
          calciumIodate: "Calcium Iodate",
          selenium: "Selenium",
          sodiumSelenite: "Sodium Selenite",

          // Functional Additives
          glucosamine: "Glucosamine",
          chondroitinSulphate: "Chondroitin Sulphate",
          yuccaSchidigeraExtract: "Yucca Schidigera Extract",
          cranberryExtract: "Cranberry Extract",

          // Pre- & Probiotic Complex
          inulinFOS: "Inulin (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucans",
          probiotics: "Probiotics",
          cfu: "CFU",

          // Botanical Extracts
          rosemary: "Rosemary",
          greenTea: "Green Tea",
          turmeric: "Turmeric",
          ginger: "Ginger",
          kelp: "Kelp",
          blueberry: "Blueberry",

          // Units / labels
          iu: "IU",
          mg: "mg",
          perKg: "per kg",
          asLabel: "as",
        },
        categories: {
          cat: "Feline Ernährung",
          cats: "Feline Ernährung",
          dog: "Canine Ernährung",
          dogs: "Canine Ernährung",
        },
        stages: {
          adult: "Erwachsen",
          adult_small_breed: "Erwachsen Kleinrasse",
          sterilised: "Kastriert",
          dog: {
            junior: "Welpe",
          },
          cat: {
            junior: "Kätzchen",
          },
        },
        sizeCategory: "Größe / Rasse",
        allSizes: "Alle Größen",
        sizes: {
          allBreeds: "Alle Rassen",
          smallBreed: "Kleine Rassen",
          "all-breeds": "Alle Rassen",
          "small-breed": "Kleine Rassen",
          mediumBreed: "Mittlere Rassen",
          largeBreed: "Große Rassen",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Verdauungsgesundheit",
          skin: "Haut- & Fellpflege",
          immune: "Immununterstützung",
          antioxidant: "Antioxidative Abwehr",
          muscle: "Muskelerhalt",
          joint: "Gelenkunterstützung",
          weight: "Gewichtsmanagement",
          urinary: "Harnwegsgesundheit",
          brain: "Gehirn- & kognitive Gesundheit",
          bone: "Knochen- & Gelenkentwicklung",
        },
        goals: {
          digestion: "Verdauungsgesundheit",
          skin: "Haut- & Fellpflege",
          weight: "Gewichtsmanagement",
          urinary: "Harnwegsgesundheit",
          immune: "Immununterstützung",
          antioxidant: "Antioxidativer Schutz",
          muscle: "Muskelerhalt",
          joint: "Gelenkunterstützung",
        },
        flavors: {
          beef: "Rind",
          duck: "Ente",
          lamb: "Lamm",
          rabbit: "Kaninchen",
          turkey: "Pute",
          whitefish: "Weißfisch",
        },
        textures: {
          kibble: "Trockenfutter",
          "chunks in jelly": "Stückchen in Gelee",
        },
        linekey: {
          dailyCare: "Tägliche Pflege",
          superfoodPlus: "Superfood+",
        },
        animals: {
          dog: "Hund",
          cat: "Katze",
        },
        description:
          "Ein Premium-Monoprotein-Rezept mit {{flavor}} im Format {{texture}}, entwickelt für {{animal}} in der Lebensphase {{stage}}.",
        types: {
          dry: "Trocken",
          wet: "Nass",
        },
        singleProtein: "Monoprotein",
        grainFree: "getreidefrei",
        premiumCompleteFood: "Vollständiges & ausgewogenes Premium-Futter",
        frontView: "Vorderansicht",
        backView: "Rückansicht",
        feedingGuideNotAvailable:
          "Fütterungsempfehlung für dieses Produkt nicht verfügbar.",
        technicalSpecs: "Technische Spezifikationen",
        keyBenefits: "Funktionale Hauptvorteile",
        analyticalConstituents: "Analytische Bestandteile",
        feedingGuide: "Fütterungsempfehlung",
        functionalIngredients: "Funktionale Inhaltsstoffe & Zusatzstoffe",
        petWeight: "Gewicht des Tieres",
        gramsPerDay: "Gramm pro Tag",
        viewBack: "Rückseite anzeigen",
        viewFront: "Vorderseite anzeigen",
        clickToZoom: "Zum Vergrößern auf das Bild klicken",
        analysis: {
          protein: "Rohprotein",
          fat: "Rohfett",
          fiber: "Rohfaser",
          ash: "Rohasche",
          omega3: "Omega-3",
          omega6: "Omega-6",
        },
        netContentLabel: "Nettoinhalt",
        packagingTypeLabel: "Verpackung",
        standardLabel: "Standard",
        pillarNoChicken:
          "Strikt ohne Huhn. Keine hühnerbasierten Nebenerzeugnisse. Immer Monoprotein.",
        noChickenTitle: "Unser zentrales Versprechen",
        noChickenText:
          "GENOYA® verwendet niemals Huhn oder hühnerbasierte Nebenerzeugnisse. Jede Rezeptur basiert auf einer reinen tierischen Proteinquelle – vollständig und ausgewogen.",
        filterReinforce:
          "Alle Rezepturen sind vollständig & ausgewogen – Strikt ohne Huhn / Immer Monoprotein",
        complianceTitle: "Ernährungskonformität",
        complianceText:
          "Formuliert, um die Ernährungsniveaus zu erfüllen, die durch internationale Standards wie AAFCO-Nährstoffprofile und FEDIAF-Richtlinien festgelegt wurden.",
        completeBalanced: "Vollständig & Ausgewogen",
        nutritionalAdequacyTitle: "Erklärung zur Ernährungsphysiologie",
        nutritionalAdequacyText:
          "Formuliert in Übereinstimmung mit den Richtlinien der AAFCO- und FEDIAF-Nährstoffprofile für die angestrebte Lebensphase.",
        regulatoryDisclaimer:
          "AAFCO und FEDIAF sind Organisationen für regulatorische Richtlinien. GENOYA™-Produkte sind nicht von diesen Organisationen zertifiziert.",
        tabs: {
          ingredients: "Zutaten",
          feeding: "Fütterungsempfehlung",
          nutrition: "Nährwerte",
          aminoAcids: "Aminosäuren",
        },
        analytical: {
          guaranteedAnalysis: "Garantierte Analyse",
          analyticalValues: "Analytische Werte",
          metabolisable_energy: "Umsetzbare Energie",
          digestibility: "Verdaulichkeit",
          estimated: "Geschätzt",
          crude_protein_min: "Rohprotein (min)",
          crude_fat_min: "Rohfett (min)",
          crude_fibre_max: "Rohfaser (max)",
          crude_ash_max: "Rohasche (max)",
          moisture_max: "Feuchtigkeit (max)",
          taurine: "Taurin",
          omega3: "Omega-3",
          omega6: "Omega-6",
          calcium_min: "Kalzium (min)",
          calcium_max: "Kalzium (max)",
          phosphorus_min: "Phosphor (min)",
          phosphorus_max: "Phosphor (max)",
          l_carnitine: "L-Carnitin",
          metabolisable_energy_kcal: "Umsetzbare Energie (kcal/kg)",
          metabolisable_energy_mj: "Umsetzbare Energie (MJ/kg)",
          omega3_fatty_acids: "Omega-3",
          omega6_fatty_acids: "Omega-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Glucosamin",
          chondroitin_sulphate: "Chondroitinsulfat",
          dl_methionine_ga: "DL-Methionin",
          sodium: "Natrium",
          magnesium: "Magnesium",
          potassium: "Kalium",
          ca_p_ratio: "Kalzium : Phosphor-Verhältnis",
        },
        fullIngredientList: "Vollständige Zutatenliste",
        functionalHighlights: "Funktionale Highlights",
        storageShelfLife: "Lagerung & Haltbarkeit",
        storageText:
          "HALTBARKEIT: 18 Monate ab Herstellungsdatum.\nLAGERUNG & SICHERHEIT\nAn einem kühlen, trockenen Ort lagern.\nNach dem Öffnen verschließen.\nNicht einfrieren.",
        storageTextWet:
          "HALTBARKEIT: 3 Jahre (ungeöffnet ab Herstellungsdatum).\nLAGERUNG & SICHERHEIT\nAn einem kühlen, trockenen Ort, vor direkter Sonneneinstrahlung geschützt, lagern.\nNach dem Öffnen kühlen und innerhalb von 5 Tagen verbrauchen.\nNicht einfrieren.",
        functionalIngredientsText:
          "FUNKTIONELLE INHALTSSTOFFE\n- Inulin (FOS): Unterstützt das Mikrobiom-Gleichgewicht\n- MOS: Hilft, schädliche Darmbakterien zu blockieren\n- β-Glucane: Unterstützt die Immunfunktion\nLachsöl: EPA und DHA fördern die Gehirn- und Sehentwicklung\nDL-Methionin: Unterstützt die Harnwegsgesundheit\nTaurin: Unverzichtbar für Herzfunktion, Sehen und neurologische Unterstützung",
        complianceTemplates: {
          kitten_cat:
            "{{name}} ist formuliert, um die Nährstoffniveaus zu erfüllen, die durch die AAFCO-Katzennahrungs-Nährstoffprofile für Wachstum und Reproduktion festgelegt wurden, und entspricht den FEDIAF-Ernährungsrichtlinien für vollständige und ausgewogene Kätzchennahrung.",
          adult_cat:
            "{{name}} ist formuliert, um die Nährstoffniveaus zu erfüllen, die durch die AAFCO-Katzennahrungs-Nährstoffprofile für die Erwachsenenerhaltung festgelegt wurden, und entspricht den FEDIAF-Ernährungsrichtlinien für vollständige und ausgewogene Erwachsenenkatzennahrung.",
          sterilised_cat:
            "{{name}} ist formuliert, um die Nährstoffniveaus zu erfüllen, die durch die AAFCO-Katzennahrungs-Nährstoffprofile für die Erwachsenenerhaltung festgelegt wurden, und entspricht den FEDIAF-Ernährungsrichtlinien für vollständige und ausgewogene Nahrung für sterilisierte Erwachsenenkatzen.",
          smallbreed_puppy:
            "{{name}} ist formuliert, um die Nährstoffniveaus zu erfüllen, die durch die AAFCO-Hundenahrungs-Nährstoffprofile für Wachstum festgelegt wurden, und entspricht den FEDIAF-Ernährungsrichtlinien für vollständige und ausgewogene Welpennahrung für Kleinrassen.",
          medlarge_puppy:
            "{{name}} ist formuliert, um die Nährstoffniveaus zu erfüllen, die durch die AAFCO-Hundenahrungs-Nährstoffprofile für Wachstum festgelegt wurden, und entspricht den FEDIAF-Ernährungsrichtlinien für vollständige und ausgewogene Welpennahrung für mittelgroße und große Rassen.",
          adult_small_dog:
            "{{name}} ist ein funktionelles, getreidefreies Alleinfuttermittel mit einem einzigen tierischen Protein, formuliert für erwachsene Kleinrassen-Hunde. Ausschließlich mit {{protein}} als einziger tierischer Proteinquelle unterstützt es Muskelerhalt, Haut und Fell, Verdauungsgesundheit, Immunfunktion und Vitalität bei Kleinrassen. Frei von Geflügel, Getreide, Soja und künstlichen Konservierungsstoffen. Vollständige und ausgewogene Nahrung für erwachsene Kleinrassen-Hunde.",
          adult_allbreed_dog:
            "{{name}} ist ein funktionelles, getreidefreies Alleinfuttermittel mit einem einzigen tierischen Protein, formuliert für erwachsene Hunde aller Rassen. Ausschließlich mit {{protein}} als einziger tierischer Proteinquelle unterstützt es Muskelerhalt, Haut und Fell, Verdauungsgesundheit, Immunfunktion und Vitalität. Frei von Geflügel, Getreide, Soja und künstlichen Konservierungsstoffen. Vollständige und ausgewogene Nahrung für erwachsene Hunde.",
        },
        complianceStatement: "Konformitätserklärung",
        nutritionalAdditivesPerKg: "Nährstoffzusätze (pro kg)",
        vitamins: "Vitamine",
        traceElements: "Spurenelemente",
        functionalAdditives: "Funktionelle Zusatzstoffe",
        prebioticProbioticComplex: "Prä- & Probiotischer Komplex",
        botanicalExtracts: "Botanische Extrakte",
        aminoAcids: {
          lysine: "Lysin",
          methionine: "Methionin",
          threonine: "Threonin",
          tryptophan: "Tryptophan",
          leucine: "Leucin",
          isoleucine: "Isoleucin",
          valine: "Valin",
          histidine: "Histidin",
          phenylalanine: "Phenylalanin",
          arginine: "Arginin",
        },
        aminoAcidProfile: "Essentielles Aminosäureprofil",
        aminoNote:
          "† Ungefähre Werte. Taurin wird als Nährstoffzusatz in der angegebenen Mindestmenge hinzugefügt.",
        feeding: {
          day: "Tag",
          can: "Dose",
          cans: "Dosen",
          dryNote:
            "Die Mengen sind tägliche Richtwerte. In 2–3 Mahlzeiten aufteilen. Immer frisches Wasser bereitstellen.",
          kitten__2_4months: "Kätzchen (2–4 Monate)",
          kitten__4_6months: "Kätzchen (4–6 Monate)",
          junior_7_12months: "Junior (7–12 Monate)",
          puppy___2_4_months: "Welpe (2–4 Monate)",
          puppy___4_9_months: "Welpe (4–9 Monate)",
          junior__7_9_months: "Junior (7–9 Monate)",
          junior__9_12_months: "Junior (9–12 Monate)",
          junior___9_12_months: "Junior (9–12 Monate)",
          junior___12_15_months: "Junior (12–15 Monate)",
          junior__15_20_months: "Junior (15–20 Monate)",
          adult_cat__1_3_yrs: "Erwachsene Katze (1–3 J.)",
          adult_cat__3_7_yrs: "Erwachsene Katze (3–7 J.)",
          adult_cat__7__yrs: "Erwachsene Katze (7+ J.)",
          adult_dog__1_3_yrs: "Erwachsener Hund (1–3 J.)",
          adult_dog___3_7_yrs: "Erwachsener Hund (3–7 J.)",
          adult_dog__7__yrs: "Erwachsener Hund (7+ J.)",
          "1_3_yrs": "1–3 J.",
          "3_7_yrs": "3–7 J.",
          "7__yrs": "7+ J.",
          stage_label: "Lebensphase",
        },
      },
      distributors: {
        emailLabel: "E-Mail",
        websiteLabel: "Website",
        heroTitle: "Internationale Vertriebspartnerschaften",
        heroSubtext:
          "GENOYA® ist eine globale Premium-Marke, die sich ausschließlich auf langfristige Vertriebs- und OEM-Partnerschaften konzentriert.",
        contactUs: "Export-Team kontaktieren",
        exportTitle: "Globale Export- & Containerladekapazität",
        fcl: "Vollcontainerladung (FCL) verfügbar",
        fclDesc:
          "Abwicklung von 20DC / 40HC / 45FT Containern mit weltweiter Versandkoordination.",
        mixedSku: "Gemischte SKU-Ladung",
        mixedSkuDesc:
          "Flexible Palettenkonfigurationen für mehrere Produktvarianten.",
        compliance: "Qualitäts- & Regulierungsprüfung",
        complianceDesc:
          "Vollständige Überwachung zur Gewährleistung der Konformität in den Zielmärkten.",
        palletStandards: "Unterstützte Palettenstandards",
        eurPallets: "EUR / EPAL Paletten (1200 × 800 mm)",
        ukPallets: "UK Standard Paletten (1200 × 1000 mm)",
        usPallets: "US GMA Paletten (48” × 40”)",
        whyPartnerTitle: "Warum Partner von GENOYA® werden",
        benefitScience: "Wissenschaftlich fundierte Formulierungen",
        benefitScienceDesc:
          "Vollständige Monoprotein-Ernährung nach AAFCO/FEDIAF-Standard.",
        benefitSingleProtein: "Strikte Monoprotein-Philosophie",
        benefitSingleProteinDesc:
          "Kein Huhn, keine Nebenerzeugnisse – reine, rückverfolgbare Tierproteine.",
        benefitProduction: "Skalierbare, exportfertige Produktion",
        benefitProductionDesc:
          "Vollcontainerladungen mit flexiblen Mischoptionen.",
        benefitLongTerm: "Strategische langfristige Partnerschaft",
        benefitLongTermDesc:
          "Markenintegrität und engagierte Unterstützung für Vertriebspartner.",
        officialOversight: "Offizielle Export- & Produktionsüberwachung",
        oversightText:
          "GENOYA®-Handelsoperationen und OEM-Produktionsüberwachung werden durch unsere Exportabteilung verwaltet, um Folgendes zu gewährleisten:",
        oversight1:
          "Einhaltung gesetzlicher Vorschriften auf internationalen Märkten",
        oversight2: "FCL-Exportkoordination (20DC / 40HC / 45FT)",
        oversight3: "Produktionsüberwachung und Qualitätssicherung",
        oversight4: "Markenintegrität und Formulierungs-Compliance",
        oversight5: "Management globaler Vertriebspartnerschaften",
        exportContact: "Abteilung für Export & Internationalen Handel",
        exportEntity: "Offizielle Exportstelle",
        founder: "Gründer & Globaler Geschäftsführer",
        registeredAddress: "Eingetragener Sitz",
        inquiryTitle: "Partnerschaftsanfrage senden",
        inquiryDesc:
          "Wir begrüßen ernsthafte Anfragen von nationalen Importeuren, regionalen Distributoren und strategischen Partnern.",
        finalCtaTitle: "Bereit für eine Partnerschaft mit GENOYA®?",
        finalCtaDesc:
          "Treten Sie unserem globalen Netzwerk von Premium-Vertriebspartnern bei.",
        contactExport: "Export-Team kontaktieren",
        becomePartner: "Jetzt anfragen",
        form: {
          companyName: "Firmenname / Juristische Person",
          country: "Hauptmarkt / Land",
          businessType: "Geschäftsart",
          select: "Typ auswählen",
          nationalImporter: "Nationaler Importeur",
          regionalDistributor: "Regionaler Distributor",
          premiumRetail: "Premium-Einzelhandelskette",
          vetChannel: "Tierärztlicher Kanal / Profi-Bereich",
          oem: "OEM-Partner / Eigenmarke",
          volume: "Geschätztes Jahresvolumen",
          volumePlaceholder: "z.B. 10–50 Container / Jahr",
          containerInterest: "Bevorzugte Containergröße (falls bekannt)",
          email: "Geschäftliche E-Mail",
          phone: "Telefon (mit Ländervorwahl)",
          submit: "Partnerschaftsanfrage senden",
        },
      },
      contact: {
        phone: "Telefon",
  country: "Land",
  optional: "optional",
  selectCountry: "Wählen Sie Ihr Land",
  messagePlaceholder: "Wie können wir Ihnen helfen?",
  sending: "Wird gesendet...",
  sendAnother: "Weitere Nachricht senden",
  operatedBy: "Betrieben von",
  searchCountries: "Länder suchen...",
  noResults: "Keine Ergebnisse",
        title: "Kontaktieren Sie GENOYA™",
        generalTitle: "Allgemeine Anfragen",
        generalDesc: "Für Produktinformationen und Fragen zur Marke:",
        partnershipTitle: "Vertriebsanfragen",
        partnershipDesc:
          "Für Geschäftspartnerschaften und Vertriebsmöglichkeiten:",
        formName: "Vollständiger Name",
        formEmail: "E-Mail-Adresse",
        formMessage: "Nachricht",
        sendButton: "Nachricht senden",
        name: "Name",
        email: "E-Mail-Adresse",
        message: "Nachricht",
        send: "Senden",
        successTitle: "Nachricht erfolgreich gesendet",
        successDesc:
          "Vielen Dank für Ihre Nachricht. Unser Team wird sich in Kürze mit Ihnen in Verbindung setzen.",
      },
      nav: {
        home: "Startseite",
        about: "Über uns",
        products: "Rezepturen",
        distributors: "Vertrieb",
        contact: "Kontakt",
        toggleMenu: "Navigation umschalten",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Alle Rechte vorbehalten.",
        tagline: "Wissenschaftlich formuliert. Reine Proteine.",
        quickLinks: "Navigation",
        global: "Globale Operationen",
        languages: "Sprachauswahl",
        distributorInfo: "Export-Spezifikationen",
        email: "Kontakt-E-Mail",
        legal: "Einhaltung",
        privacy: "Datenschutz",
        terms: "Nutzungsbedingungen",
      },
      privacy: {
        label: "Rechtliches",
        title: "Datenschutzerklärung",
        lastUpdated: "Zuletzt aktualisiert: März 2026",
        intro:
          "GENOYA™ ist dem Schutz Ihrer personenbezogenen Daten verpflichtet. Diese Datenschutzerklärung erläutert, welche Daten wir beim Besuch von genoyapetfood.com erheben, wie wir sie verwenden und welche Rechte Sie in Bezug auf diese Daten haben.",
        informationCollectedTitle: "Erhobene Informationen",
        info1: "Kontaktformulare: Name, E-Mail-Adresse, Unternehmensname, Land und Nachrichteninhalt.",
        info2: "Nutzungsdaten: besuchte Seiten, Verweildauer, Browsertyp und Gerätedaten, die über Analysetools erhoben werden.",
        info3: "Cookies und ähnliche Technologien zur Website-Performance und Analyse.",
        howWeUseTitle: "Verwendung Ihrer Informationen",
        use1: "Zur Beantwortung von Händleranfragen und Kontaktformularen.",
        use2: "Zur Analyse der Website-Performance und Verbesserung der Benutzererfahrung.",
        use3: "Zur Erfüllung gesetzlicher Verpflichtungen.",
        use4: "Wir verkaufen, vermieten oder übermitteln Ihre personenbezogenen Daten nicht an Dritte.",
        dataRetentionTitle: "Datenspeicherung",
        dataRetentionText:
          "Wir speichern Kontaktformulardaten so lange, wie es zur Beantwortung Ihrer Anfrage erforderlich ist, und danach für einen angemessenen Zeitraum zu Aufzeichnungszwecken.",
        thirdPartyTitle: "Drittanbieter-Dienste",
        thirdPartyText:
          "Unsere Website kann Drittanbieter-Dienste wie Analyseanbieter verwenden. Diese Dienste können Daten gemäß ihren eigenen Datenschutzrichtlinien erheben.",
        cookiesTitle: "Cookies",
        cookie1: "Wir verwenden essentielle Cookies, die für den ordnungsgemäßen Betrieb der Website erforderlich sind.",
        cookie2: "Analyse-Cookies können verwendet werden, um zu verstehen, wie Besucher mit der Website interagieren. Sie können Cookies in Ihren Browser-Einstellungen deaktivieren.",
        yourRightsTitle: "Ihre Rechte",
        right1: "Sie haben das Recht, Auskunft über die von uns gespeicherten personenbezogenen Daten zu verlangen.",
        right2: "Sie können jederzeit die Berichtigung oder Löschung Ihrer Daten verlangen.",
        right3: "Um diese Rechte geltend zu machen, kontaktieren Sie uns unter der unten angegebenen E-Mail-Adresse.",
        changesTitle: "Änderungen dieser Richtlinie",
        changesText:
          "Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Die aktuellste Version ist stets auf dieser Seite mit dem aktualisierten Datum verfügbar.",
        contactText: "Für datenschutzbezogene Fragen oder Anfragen kontaktieren Sie uns unter",
      },
      terms: {
        label: "Rechtliches",
        title: "Nutzungsbedingungen",
        lastUpdated: "Zuletzt aktualisiert: März 2026",
        intro:
          "Durch den Zugriff auf und die Nutzung der GENOYA™-Website (genoyapetfood.com) erklären Sie sich mit diesen Nutzungsbedingungen einverstanden. Bitte lesen Sie diese sorgfältig, bevor Sie die Website nutzen.",
        acceptanceTitle: "Annahme der Bedingungen",
        acceptanceText:
          "Die Nutzung dieser Website gilt als Annahme dieser Nutzungsbedingungen. Wenn Sie mit einem Teil dieser Bedingungen nicht einverstanden sind, nutzen Sie die Website bitte nicht.",
        useOfSiteTitle: "Nutzung der Website",
        use1: "Sie dürfen diese Website nur für rechtmäßige Zwecke und in Übereinstimmung mit diesen Bedingungen nutzen.",
        use2: "Sie dürfen die Website nicht so nutzen, dass sie beschädigt, deaktiviert oder beeinträchtigt wird oder andere Nutzer gestört werden.",
        use3: "Sie dürfen nicht versuchen, unbefugten Zugang zu Teilen der Website oder zugehörigen Systemen zu erlangen.",
        use4: "Die kommerzielle Nutzung von Website-Inhalten ohne vorherige schriftliche Genehmigung von GENOYA™ ist untersagt.",
        intellectualPropertyTitle: "Geistiges Eigentum",
        intellectualPropertyText:
          "Alle Inhalte dieser Website — einschließlich Texte, Bilder, Logos, Produktnamen, Formeln und Design — sind Eigentum von GENOYA™ und durch geltende Gesetze zum Schutz des geistigen Eigentums geschützt.",
        disclaimerTitle: "Haftungsausschluss",
        disclaimerText:
          "Diese Website und ihre Inhalte werden \"wie besehen\" ohne ausdrückliche oder stillschweigende Garantien jeglicher Art bereitgestellt. GENOYA™ garantiert nicht, dass die Website unterbrechungsfrei, fehlerfrei oder frei von schädlichen Komponenten ist.",
        limitationTitle: "Haftungsbeschränkung",
        limitationText:
          "Im größtmöglichen gesetzlich zulässigen Umfang haftet GENOYA™ nicht für indirekte, zufällige, besondere oder Folgeschäden, die aus der Nutzung oder Nichtnutzung dieser Website entstehen.",
        thirdPartyLinksTitle: "Links zu Dritten",
        thirdPartyLinksText:
          "Diese Website kann Links zu Websites Dritter enthalten. GENOYA™ hat keine Kontrolle über den Inhalt oder die Praktiken dieser Websites und übernimmt keine Verantwortung dafür.",
        governingLawTitle: "Anwendbares Recht",
        governingLawText:
          "Diese Nutzungsbedingungen unterliegen dem anwendbaren internationalen Handelsrecht und sind entsprechend auszulegen. Streitigkeiten werden durch gütliche Einigung zwischen den Parteien beigelegt.",
        changesTitle: "Änderungen der Bedingungen",
        changesText:
          "GENOYA™ behält sich das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Die fortgesetzte Nutzung der Website nach der Veröffentlichung von Änderungen gilt als Annahme der aktualisierten Bedingungen.",
        contactText: "Bei Fragen zu diesen Nutzungsbedingungen kontaktieren Sie uns unter",
      },
    },
  },
  zh: {
    translation: {
      ingredientCategories: {
        protein: "蛋白质",
        carb: "碳水化合物",
        oil: "油脂",
        prebiotic: "益生元",
        probiotic: "益生菌",
        superfood: "超级食物",
        mineral: "矿物质",
        amino: "氨基酸",
        botanical: "植物提取物",
        premix: "复合维生素矿物质预混料",
        other: "其他",
        showLess: "− 收起",
        more: "更多",
      },
      ingredients: {
        beef: "牛肉",
        rabbit: "兔肉",
        duck: "鸭肉",
        lamb: "羊肉",
        turkey: "火鸡肉",
        whitefish: "白身鱼",
        freshly_prepared_beef: "新鲜牛肉",
        beef_meal: "牛肉粉",
        dehydrated_beef_protein: "脱水牛肉蛋白",
        freshly_prepared_rabbit: "新鲜兔肉",
        rabbit_meal: "兔肉粉",
        dehydrated_rabbit_protein: "脱水兔肉蛋白",
        freshly_prepared_turkey: "新鲜火鸡肉",
        turkey_meal: "火鸡肉粉",
        dehydrated_turkey_protein: "脱水火鸡蛋白",
        freshly_prepared_duck: "新鲜鸭肉",
        duck_meal: "鸭肉粉",
        dehydrated_duck_protein: "脱水鸭肉蛋白",
        freshly_prepared_whitefish: "新鲜白身鱼",
        whitefish_meal: "白身鱼粉",
        dehydrated_whitefish_protein: "脱水白身鱼蛋白",
        freshly_prepared_lamb: "新鲜羊肉",
        lamb_meal: "羊肉粉",
        dehydrated_lamb_protein: "脱水羊肉蛋白",
        beef_broth: "牛肉汤",
        lamb_broth: "羊肉汤",
        rabbit_broth: "兔肉汤",
        turkey_broth: "火鸡汤",
        whitefish_broth: "白身鱼汤",
        potato_flour: "马铃薯粉",
        tapioca: "木薯",
        pumpkin: "南瓜",
        dried_cellulose_fibre: "干燥纤维素纤维",
        salmon_oil: "三文鱼油",
        flaxseed: "亚麻籽",
        dried_brewers_yeast: "干啤酒酵母",
        probiotics: "益生菌",
        "bacillus/lactobacillus": "芽孢杆菌/乳酸菌",
        spinach: "菠菜",
        blueberry: "蓝莓",
        kelp_powder: "海带粉",
        chicory_root: "菊苣根",
        inulin: "菊粉",
        fos: "FOS（低聚果糖）",
        mos: "MOS（甘露寡糖）",
        yeast_β_glucans: "酵母β-葡聚糖",
        dicalcium_phosphate: "磷酸氢钙",
        potassium_chloride: "氯化钾",
        sodium_phosphate: "磷酸钠",
        dl_methionine: "DL-蛋氨酸",
        taurine: "牛磺酸",
        l_carnitine: "左旋肉碱",
        yucca_schidigera_extract: "丝兰提取物",
        cranberry_extract: "蔓越莓提取物",
        "turmeric_&_ginger_extracts": "姜黄和生姜提取物",
        "rosemary_&_green_tea_extracts": "迷迭香和绿茶提取物",
        "vitamin_&_mineral_premix": "复合维生素矿物质预混料",
      },
      home: {
        heroTitle1: "科学配方，",
        heroTitle2: "纯净蛋白。",
        heroTitle3: "功能性健康。",
        heroSubtext:
          "基于单一蛋白的宠物营养品牌。通过系统化的科学配方设计，旨在提升消化透明度、平衡新陈代谢并维持长期活力。",
        viewProducts: "探索我们的配方",
        becomeDistibutor: "成为经销商",
        noChickenTitle: "严格无鸡肉。不含鸡肉副产品。",
        noChickenSubtitle: "始终坚持单一蛋白 —— 我们的核心承诺",
        noChickenText:
          "GENOYA 的每种配方仅使用单一、明确的纯净动物蛋白来源。无混合蛋白，无鸡肉，无鸡肉副产品。这种单一蛋白哲学提供了精准的营养、更好的消化率，并为全球宠物提供更清晰的过敏管理方案。",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ 是一个遵循严格单一蛋白哲学的科学化高端宠物营养品牌。",
        introPoint1: "营养精准化",
        introPoint2: "消化透明化",
        introPoint3: "降低饮食复杂度",
        introPoint4: "功能性健康优化",
        introFooter: "我们设计的是结构化的营养体系，而非紧跟潮流的短期产品。",
        diffTitle: "核心优势",
        diff1Title: "单一动物蛋白架构",
        diff1Desc: "每种配方都围绕一种明确定义的单一动物蛋白来源构建。",
        diff2Title: "无谷物配方",
        diff2Desc: "平衡的宏量营养结构，不含多余的填充物。",
        diff3Title: "无鸡肉政策",
        diff3Desc: "所有产品均执行严格的蛋白纯净标准。绝不含鸡肉或鸡肉副产品。",
        diff4Title: "功能性集成",
        diff4Desc: "包含益生元、益生菌、关节支撑成分及优化的 Omega 平衡。",
        scienceTitle: "基于研究，为表现而生。",
        scienceLead: "GENOYA™ 的配方设计包含：",
        sciencePoint1: "受控的蛋白质与脂肪比例",
        sciencePoint2: "平衡的 Omega 3 与 6 特性",
        sciencePoint3: "FOS 与 MOS 益生元系统",
        sciencePoint4: "用于免疫支持的 β-葡聚糖",
        sciencePoint5: "用于关节健康的氨基葡萄糖与软骨素",
        sciencePoint6: "根据功能需求添加牛磺酸与左旋肉碱",
        scienceFooter:
          "每种成分都有其明确的作用，每个百分比都遵循严密的配方逻辑。",
        previewTitle: "配方概览",
        previewCats: "猫用",
        previewDogs: "狗用",
        previewKitten: "幼猫",
        previewAdult: "成猫",
        previewSterilised: "绝育/室内猫",
        previewPuppy: "幼犬",
        previewSmallBreed: "小型犬（成年）",
        previewAllBreeds: "全犬种（成年）",
        distributorHeading: "全球经销机会",
        distributorSubtext:
          "GENOYA™ 正在通过结构化的国际伙伴关系进行扩张。我们支持 20DC、40HC 及 45ft 集装箱运输，并提供完整的出口报关文件。",
        getStarted: "与 GENOYA™ 建立合作",
      },
      about: {
        heroTitle1: "精准营养",
        heroTitle2: "全球视野",
        heroSubtext:
          "GENOYA™ 是一个以科学为核心的品牌，利用单一蛋白的透明性和功能性健康的表现来设计高端宠物营养方案。",
        viewProducts: "查看所有配方",
        missionTitle: "我们的使命",
        missionText:
          "通过科学驱动的配方系统，设计基于单一蛋白纯净度和功能性表现的高端宠物营养产品。",
        valuesTitle: "我们的原则",
        value1: "蛋白质纯净度",
        value1subtext: "所有产品线均采用单一动物蛋白架构。",
        value2: "营养完整性",
        value2subtext: "结构化配方，与国际公认的营养框架保持一致。",
        value3: "关注功能性健康",
        value3subtext: "支持消化系统、关节完整性、免疫平衡和代谢优化。",
        value4: "无鸡肉，无鸡肉副产品。",
        value4subtext: "GENOYA™ 品牌不可逾越的标准。",
        viewOurProducts: "探索产品",
        leadershipTitle: "专业知识与定位",
        leadershipHeadText: " 由具备以下领域经验的专业人士创立：",
        leadershipValue1: "国际宠物食品贸易",
        leadershipValue2: "OEM 生产监督",
        leadershipValue3: "品牌架构开发",
        leadershipValue4: "经销渠道扩展",
        leadershipValue5: "合规标签系统",
        leadershipTextBelow:
          "通过位于中国的结构化生产设施运行，在专为国际分销设计的受控配方系统和质量监督下进行生产。",
        leadershipTextFinal: "我们致力于打造旨在实现长期全球增长的结构化品牌。",
        noChickenTitle: "严格无鸡肉。不含鸡肉副产品。",
        noChickenSubtitle: "始终单一蛋白 —— 我们的创始承诺",
        noChickenText:
          "GENOYA® 绝不在任何配方中使用鸡肉或鸡肉副产品。我们坚持严格的单一蛋白哲学：每个产品仅含有一种纯净且明确的动物蛋白源。这确保了更好的消化率、更清晰的过敏管理，并为全球宠物主提供无与伦比的透明度。",
        complianceTitle: "营养合规声明",
        complianceText:
          "配方符合国际公认标准设定的营养水平，包括 AAFCO（美国饲料管理协会）营养概况和 FEDIAF（欧洲宠物食品工业联合会）针对各生命阶段的指导方针。",
        complianceBold: "我们的产品针对所有生命阶段均实现了完整且平衡的营养。",
      },
      products: {
        heroTitle: "先进单一蛋白配方",
        heroSubtext:
          "根据物种、生命阶段和功能性健康目标量身定制的单一动物蛋白精准营养。",
        selectSpecies: "选择您的宠物物种",
        backToSpecies: "返回物种选择",
        noProductsAvailable: "未找到该类别的产品。",
        filter: "筛选",
        clearFilters: "清除筛选",
        resetFilters: "重置全部",
        format: "产品形式",
        allFormats: "所有形式",
        formats: {
          dry: "干粮",
          wet: "湿粮",
        },
        dryKibble: "膨化干粮",
        wetFood: "湿粮/餐包",
        ingredient: "主蛋白源",
        allIngredients: "所有蛋白质",
        lifeStage: "生命阶段",
        allStages: "所有阶段",
        healthGoal: "功能目标",
        allGoals: "所有目标",
        healthBenefits: "健康益处",
        noResults: "未找到符合您标准的配方。",
        details: "配方详情",
        showLess: "折叠内容",
        collapseAll: "折叠全部",
        size: "净含量",
        ingredients: "原料",
        fullIngredients: "完整成分表",
        standard: "制造标准",
        packaging: "包装类型",
        aboutProduct: "产品特点",
        ingredientsLabel: "配料表（成分）",
        analysisLabel: "保证成分分析（如有）",
        nutritionalAdditives: {
          sectionHeader: "营养添加剂（每千克）",
          vitamins: "维生素",
          traceElements: "微量元素",
          functionalAdditives: "功能性添加剂",
          prebioticProbioticComplex: "益生元与益生菌复合物",
          botanicalExtracts: "植物提取物",

          vitaminA: "维生素A",
          vitaminD3: "维生素D₃",
          vitaminE: "维生素E",
          vitaminC: "维生素C",
          vitaminB1: "维生素B₁",
          vitaminB2: "维生素B₂",
          vitaminB6: "维生素B₆",
          vitaminB12: "维生素B₁₂",
          niacin: "烟酸",
          pantothenicAcid: "泛酸",
          folicAcid: "叶酸",
          biotin: "生物素",
          cholineChloride: "氯化胆碱",
          taurine: "牛磺酸",
          lCarnitine: "左旋肉碱",
          dlMethionine: "DL-蛋氨酸",

          iron: "铁",
          ferrousSulphate: "硫酸亚铁",
          zinc: "锌",
          zincSulphate: "硫酸锌",
          manganese: "锰",
          manganeseSulphate: "硫酸锰",
          copper: "铜",
          copperSulphate: "硫酸铜",
          iodine: "碘",
          calciumIodate: "碘酸钙",
          selenium: "硒",
          sodiumSelenite: "亚硒酸钠",

          glucosamine: "葡萄糖胺",
          chondroitinSulphate: "硫酸软骨素",
          yuccaSchidigeraExtract: "丝兰提取物",
          cranberryExtract: "蔓越莓提取物",

          inulinFOS: "菊粉（低聚果糖）",
          mos: "甘露寡糖（MOS）",
          betaGlucans: "β-葡聚糖",
          probiotics: "益生菌",
          cfu: "CFU",

          rosemary: "迷迭香",
          greenTea: "绿茶",
          turmeric: "姜黄",
          ginger: "生姜",
          kelp: "海带",
          blueberry: "蓝莓",

          iu: "IU",
          mg: "mg",
          perKg: "每千克",
          asLabel: "来源",
        },
        categories: {
          cat: "猫用营养",
          cats: "猫用营养",
          dog: "狗用营养",
          dogs: "狗用营养",
        },
        stages: {
          adult: "成年期",
          adult_small_breed: "成年小型犬",
          sterilised: "绝育期",
          dog: {
            junior: "幼犬期",
          },
          cat: {
            junior: "幼猫期",
          },
        },
        sizeCategory: "体型/品种",
        allSizes: "所有体型",
        sizes: {
          allBreeds: "全品种",
          smallBreed: "小型犬",
          "all-breeds": "全品种",
          "small-breed": "小型犬",
          mediumBreed: "中型犬",
          largeBreed: "大型犬",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "肠胃消化健康",
          skin: "皮肤与被毛营养",
          immune: "免疫系统支持",
          antioxidant: "抗氧化防御",
          muscle: "肌肉维持",
          joint: "关节支持",
          weight: "体重控制",
          urinary: "泌尿系统健康",
          brain: "脑部与认知健康",
          bone: "骨骼与关节发育",
        },
        goals: {
          digestion: "肠胃健康",
          skin: "美毛护肤",
          weight: "体重控制",
          urinary: "泌尿健康",
          immune: "免疫支持",
          antioxidant: "抗氧化保护",
          muscle: "肌肉维持",
          joint: "关节支持",
        },
        flavors: {
          beef: "牛肉",
          duck: "鸭肉",
          lamb: "羔羊肉",
          rabbit: "兔肉",
          turkey: "火鸡肉",
          whitefish: "白身鱼",
        },
        textures: {
          kibble: "干颗粒",
          "chunks in jelly": "果冻肉块",
        },
        linekey: {
          dailyCare: "日常护理系列",
          superfoodPlus: "超级食物系列+",
        },
        animals: {
          dog: "狗狗",
          cat: "猫咪",
        },
        description:
          "一份针对 {{stage}} {{animal}} 设计的，高端单一蛋白 {{flavor}} 口味 {{texture}} 配方。",
        types: {
          dry: "干粮",
          wet: "湿粮",
        },
        singleProtein: "单一蛋白",
        grainFree: "无谷",
        premiumCompleteFood: "高端全价平衡宠物食品",
        frontView: "正面视图",
        backView: "背面视图",
        feedingGuideNotAvailable: "该产品暂无饲喂指南。",
        technicalSpecs: "技术规格",
        keyBenefits: "核心功能益处",
        analyticalConstituents: "成分分析",
        feedingGuide: "饲喂建议",
        functionalIngredients: "功能性成分与添加剂",
        petWeight: "宠物体重",
        gramsPerDay: "每日建议饲喂量（克）",
        viewBack: "查看背面标签",
        viewFront: "查看正面标签",
        clickToZoom: "点击图片放大查看",
        analysis: {
          protein: "粗蛋白质",
          fat: "粗脂肪",
          fiber: "粗纤维",
          ash: "粗灰分",
          omega3: "Omega-3",
          omega6: "Omega-6",
        },
        netContentLabel: "净含量",
        packagingTypeLabel: "包装",
        standardLabel: "标准",
        pillarNoChicken: "严格无鸡肉。无鸡肉副产品。始终单一蛋白。",
        noChickenTitle: "我们的核心承诺",
        noChickenText:
          "GENOYA® 绝不使用鸡肉或鸡肉副产品。每种配方都基于纯净的单一动物蛋白来源 —— 为各生命阶段提供完整且平衡的营养。",
        filterReinforce:
          "所有配方均为全价平衡营养 —— 严格无鸡肉 / 始终单一蛋白",
        complianceTitle: "营养合规性",
        complianceText:
          "配方旨在满足由国际宠物食品标准设定的营养水平，包括 AAFCO 营养概况和针对相应生命阶段的 FEDIAF 指导方针。",
        completeBalanced: "全价平衡营养",
        nutritionalAdequacyTitle: "营养充足性声明",
        nutritionalAdequacyText:
          "根据针对目标生命阶段的 AAFCO 和 FEDIAF 营养特性指南配制。营养充足性基于配方分析得出。",
        regulatoryDisclaimer:
          "AAFCO 和 FEDIAF 是制定监管指南的机构。GENOYA™ 产品未经这些机构直接批准或认证。",
        tabs: {
          ingredients: "原料",
          feeding: "饲喂指南",
          nutrition: "营养成分",
          aminoAcids: "氨基酸",
        },
        analytical: {
          guaranteedAnalysis: "保证成分分析",
          analyticalValues: "分析值",
          metabolisable_energy: "代谢能",
          digestibility: "消化率",
          estimated: "估计",
          crude_protein_min: "粗蛋白质（最低）",
          crude_fat_min: "粗脂肪（最低）",
          crude_fibre_max: "粗纤维（最高）",
          crude_ash_max: "粗灰分（最高）",
          moisture_max: "水分（最高）",
          taurine: "牛磺酸",
          omega3: "Omega-3",
          omega6: "Omega-6",
          calcium_min: "钙（最低）",
          calcium_max: "钙（最高）",
          phosphorus_min: "磷（最低）",
          phosphorus_max: "磷（最高）",
          l_carnitine: "左旋肉碱",
          metabolisable_energy_kcal: "代谢能（千卡/千克）",
          metabolisable_energy_mj: "代谢能（兆焦/千克）",
          omega3_fatty_acids: "Omega-3",
          omega6_fatty_acids: "Omega-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "葡萄糖胺",
          chondroitin_sulphate: "硫酸软骨素",
          dl_methionine_ga: "DL-蛋氨酸",
          sodium: "钠",
          magnesium: "镁",
          potassium: "钾",
          ca_p_ratio: "钙磷比",
        },
        fullIngredientList: "查看完整配料表",
        functionalHighlights: "功能性成分亮点",
        storageShelfLife: "储存与保质期",
        storageText:
          "保质期：自生产之日起18个月。\n储存与安全\n存放于阴凉干燥处。\n开封后请重新密封。\n请勿冷冻。",
        storageTextWet:
          "保质期：自生产之日起3年（未开封）。\n储存与安全\n存放于阴凉干燥处，远离直射阳光。\n开封后冷藏，并在5天内食用完毕。\n请勿冷冻。",
        functionalIngredientsText:
          "功能性成分\n- 菊粉（FOS）：支持微生物群平衡\n- MOS：帮助阻止有害肠道细菌\n- β-葡聚糖：支持免疫功能\n三文鱼油：EPA和DHA支持大脑与视力发育\nDL-蛋氨酸：支持泌尿系统健康\n牛磺酸：对心脏功能、视力及神经系统支持至关重要",
        complianceTemplates: {
          kitten_cat:
            "{{name}}按照美国饲料管理官员协会（AAFCO）猫粮营养素档案中关于生长和繁殖阶段的营养水平配制，并符合欧洲宠物食品工业联合会（FEDIAF）关于幼猫完整均衡宠物食品的营养指南。",
          adult_cat:
            "{{name}}按照美国饲料管理官员协会（AAFCO）猫粮营养素档案中关于成年维持阶段的营养水平配制，并符合欧洲宠物食品工业联合会（FEDIAF）关于成年猫完整均衡宠物食品的营养指南。",
          sterilised_cat:
            "{{name}}按照美国饲料管理官员协会（AAFCO）猫粮营养素档案中关于成年维持阶段的营养水平配制，并符合欧洲宠物食品工业联合会（FEDIAF）关于绝育成年猫完整均衡宠物食品的营养指南。",
          smallbreed_puppy:
            "{{name}}按照美国饲料管理官员协会（AAFCO）犬粮营养素档案中关于生长阶段的营养水平配制，并符合欧洲宠物食品工业联合会（FEDIAF）关于小型犬幼犬完整均衡宠物食品的营养指南。",
          medlarge_puppy:
            "{{name}}按照美国饲料管理官员协会（AAFCO）犬粮营养素档案中关于生长阶段的营养水平配制，并符合欧洲宠物食品工业联合会（FEDIAF）关于中大型犬幼犬完整均衡宠物食品的营养指南。",
          adult_small_dog:
            "{{name}}是一款单一动物蛋白、无谷物功能性膳食，专为成年小型犬的营养需求而配制。仅使用{{protein}}作为唯一动物蛋白来源，支持肌肉维护、皮肤与毛发健康、消化健康、免疫功能和整体活力。不含家禽、谷物、大豆及人工防腐剂。小型成年犬完整均衡宠物食品。",
          adult_allbreed_dog:
            "{{name}}是一款单一动物蛋白、无谷物功能性膳食，专为各品种成年犬的营养需求而配制。仅使用{{protein}}作为唯一动物蛋白来源，支持肌肉维护、皮肤与毛发健康、消化健康、免疫功能和整体活力。不含家禽、谷物、大豆及人工防腐剂。成年犬完整均衡宠物食品。",
        },
        complianceStatement: "合规声明",
        nutritionalAdditivesPerKg: "营养添加剂（每千克）",
        vitamins: "维生素",
        traceElements: "微量元素",
        functionalAdditives: "功能性添加剂",
        prebioticProbioticComplex: "益生元与益生菌复合物",
        botanicalExtracts: "植物提取物",
        aminoAcids: {
          lysine: "赖氨酸",
          methionine: "蛋氨酸",
          threonine: "苏氨酸",
          tryptophan: "色氨酸",
          leucine: "亮氨酸",
          isoleucine: "异亮氨酸",
          valine: "缬氨酸",
          histidine: "组氨酸",
          phenylalanine: "苯丙氨酸",
          arginine: "精氨酸",
        },
        aminoAcidProfile: "必需氨基酸特性",
        aminoNote: "† 近似值。牛磺酸作为营养添加剂按声明的最低水平添加。",
        feeding: {
          day: "天",
          can: "罐",
          cans: "罐",
          dryNote: "以上为每日饲喂参考量，请分2–3次喂食，并随时提供新鲜饮水。",
          kitten__2_4months: "幼猫（2–4个月）",
          kitten__4_6months: "幼猫（4–6个月）",
          junior_7_12months: "小猫（7–12个月）",
          puppy___2_4_months: "幼犬（2–4个月）",
          puppy___4_9_months: "幼犬（4–9个月）",
          junior__7_9_months: "小猫（7–9个月）",
          junior__9_12_months: "小猫（9–12个月）",
          junior___9_12_months: "小猫（9–12个月）",
          junior___12_15_months: "小犬（12–15个月）",
          junior__15_20_months: "小犬（15–20个月）",
          adult_cat__1_3_yrs: "成年猫（1–3岁）",
          adult_cat__3_7_yrs: "成年猫（3–7岁）",
          adult_cat__7__yrs: "成年猫（7岁以上）",
          adult_dog__1_3_yrs: "成年犬（1–3岁）",
          adult_dog___3_7_yrs: "成年犬（3–7岁）",
          adult_dog__7__yrs: "成年犬（7岁以上）",
          "1_3_yrs": "1–3岁",
          "3_7_yrs": "3–7岁",
          "7__yrs": "7岁以上",
          stage_label: "生命阶段",
        },
      },
      distributors: {
        emailLabel: "邮箱",
        websiteLabel: "网站",
        heroTitle: "国际经销合作伙伴",
        heroSubtext:
          "GENOYA® 是一个结构化的高端全球品牌，专注于长期的经销合作与 OEM 业务。",
        contactUs: "联系出口团队",
        exportTitle: "全球出口与集装箱装载能力",
        fcl: "支持全集装箱装载 (FCL)",
        fclDesc: "支持 20DC / 40HC / 45FT 集装箱，提供全球物流协调支持。",
        mixedSku: "支持多品类 (SKU) 混装",
        mixedSkuDesc: "灵活的托盘配置，支持多种产品变体同柜运输。",
        compliance: "监管与质量保证",
        complianceDesc: "全程监控以确保符合目标市场的准入要求。",
        palletStandards: "支持的托盘标准",
        eurPallets: "欧标托盘 (1200 × 800 mm)",
        ukPallets: "英标托盘 (1200 × 1000 mm)",
        usPallets: "美标托盘 (48” × 40”)",
        whyPartnerTitle: "为什么选择与 GENOYA® 合作",
        benefitScience: "科学驱动的配方",
        benefitScienceDesc: "符合 AAFCO/FEDIAF 标准的全价单一蛋白营养。",
        benefitSingleProtein: "严格的单一蛋白哲学",
        benefitSingleProteinDesc:
          "无鸡肉，无副产品；采用纯净、可追溯的动物蛋白。",
        benefitProduction: "具备出口能力的规模化生产",
        benefitProductionDesc: "支持全柜装载及灵活的混装方案。",
        benefitLongTerm: "战略性长期合作伙伴关系",
        benefitLongTermDesc: "维护品牌完整性，为经销商提供专业支持。",
        officialOversight: "官方出口与生产监督",
        oversightText:
          "GENOYA® 的国际贸易运营和 OEM 生产监督由我们指定的出口实体统一管理，以确保：",
        oversight1: "符合国际市场的监管要求",
        oversight2: "FCL 整柜出口协调 (20DC / 40HC / 45FT)",
        oversight3: "生产现场监督与质量保证",
        oversight4: "品牌完整性与配方一致性",
        oversight5: "全球合作伙伴关系管理",
        exportContact: "出口与国际贸易部",
        exportEntity: "官方出口实体",
        founder: "创始人及全球董事总经理",
        registeredAddress: "注册地址",
        inquiryTitle: "提交您的合作申请",
        inquiryDesc:
          "我们欢迎来自国家进口商、区域经销商和战略合作伙伴的正式咨询。",
        finalCtaTitle: "准备好成为 GENOYA® 的合作伙伴吗？",
        finalCtaDesc: "加入我们的全球高端经销网络。",
        contactExport: "联系出口团队",
        becomePartner: "立即咨询",
        form: {
          companyName: "公司名称 / 法定实体",
          country: "目标市场 / 国家",
          businessType: "业务类型",
          select: "请选择类型",
          nationalImporter: "国家级进口商",
          regionalDistributor: "区域经销商",
          premiumRetail: "高端零售连锁",
          vetChannel: "兽医/专业渠道",
          oem: "OEM 合作伙伴 / 自有品牌",
          volume: "预计年采购量",
          volumePlaceholder: "例如：10–50 柜 / 年",
          containerInterest: "首选集装箱规格（如已知）",
          email: "公司电子邮箱",
          phone: "联系电话（含国家代码）",
          submit: "提交合作申请",
        },
      },
      contact: {
        phone: "电话",
  country: "国家",
  optional: "选填",
  selectCountry: "选择您的国家",
  messagePlaceholder: "我们能为您做些什么？",
  sending: "发送中...",
  sendAnother: "再发一条消息",
  operatedBy: "运营方",
  searchCountries: "搜索国家...",
  noResults: "无结果",
        title: "联系 GENOYA™",
        generalTitle: "一般咨询",
        generalDesc: "关于产品信息和品牌相关问题：",
        partnershipTitle: "经销商咨询",
        partnershipDesc: "关于业务合作和经销机会：",
        formName: "全名",
        formEmail: "电子邮箱",
        formMessage: "留言内容",
        sendButton: "发送邮件",
        name: "姓名",
        email: "电子邮箱",
        message: "留言内容",
        send: "发送",
        successTitle: "消息发送成功",
        successDesc: "感谢您的联系。我们的团队会尽快给您回复。",
      },
      nav: {
        home: "首页",
        about: "关于我们",
        products: "产品配方",
        distributors: "经销合作",
        contact: "联系我们",
        toggleMenu: "切换导航",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. 保留所有权利。",
        tagline: "科学配方，纯净蛋白。",
        quickLinks: "快速导航",
        global: "全球运营",
        languages: "语言选择",
        distributorInfo: "出口规格",
        email: "联系邮箱",
        legal: "合规说明",
        privacy: "隐私政策",
        terms: "服务条款",
      },
      privacy: {
        label: "法律",
        title: "隐私政策",
        lastUpdated: "最后更新：2026年3月",
        intro:
          "GENOYA™ 致力于保护您的个人信息。本隐私政策说明我们在您访问 genoyapetfood.com 时收集哪些数据、如何使用这些数据以及您对这些数据的权利。",
        informationCollectedTitle: "我们收集的信息",
        info1: "联系表格：姓名、电子邮件地址、公司名称、国家及消息内容。",
        info2: "使用数据：访问的页面、网站停留时间、浏览器类型及设备信息，通过分析工具收集。",
        info3: "用于网站性能和分析的 Cookie 及类似技术。",
        howWeUseTitle: "我们如何使用您的信息",
        use1: "回复经销商咨询和联系表格提交。",
        use2: "分析网站性能，改善用户体验。",
        use3: "履行法律义务。",
        use4: "我们不会向第三方出售、租赁或转让您的个人信息。",
        dataRetentionTitle: "数据保留",
        dataRetentionText:
          "我们将联系表格数据保留至回复您的咨询所需的时间，并在此后保留合理期限用于记录目的。",
        thirdPartyTitle: "第三方服务",
        thirdPartyText:
          "我们的网站可能使用第三方服务，例如分析服务提供商。这些服务可能根据其自己的隐私政策收集数据。",
        cookiesTitle: "Cookie",
        cookie1: "我们使用网站正常运行所需的必要 Cookie。",
        cookie2: "可能使用分析 Cookie 了解访客与网站的互动情况。您可以在浏览器设置中禁用 Cookie。",
        yourRightsTitle: "您的权利",
        right1: "您有权请求访问我们持有的关于您的个人数据。",
        right2: "您可以随时请求更正或删除您的数据。",
        right3: "如需行使这些权利，请通过以下电子邮件地址联系我们。",
        changesTitle: "政策变更",
        changesText:
          "我们可能会不时更新本隐私政策。最新版本将始终在本页面以更新日期显示。",
        contactText: "如有隐私相关问题或请求，请通过以下方式联系我们",
      },
      terms: {
        label: "法律",
        title: "服务条款",
        lastUpdated: "最后更新：2026年3月",
        intro:
          "通过访问和使用 GENOYA™ 网站（genoyapetfood.com），您同意受这些服务条款的约束。在使用本网站之前，请仔细阅读。",
        acceptanceTitle: "条款接受",
        acceptanceText:
          "使用本网站即表示接受这些服务条款。如果您不同意这些条款的任何部分，请不要使用本网站。",
        useOfSiteTitle: "网站使用",
        use1: "您只能出于合法目的并按照这些条款使用本网站。",
        use2: "您不得以任何可能损坏、禁用或损害网站或干扰其他用户的方式使用本网站。",
        use3: "您不得试图未经授权访问本网站的任何部分或其相关系统。",
        use4: "未经 GENOYA™ 事先书面许可，禁止商业使用网站内容。",
        intellectualPropertyTitle: "知识产权",
        intellectualPropertyText:
          "本网站上的所有内容——包括文字、图像、标志、产品名称、配方和设计——均为 GENOYA™ 的财产，受适用知识产权法律保护。",
        disclaimerTitle: "免责声明",
        disclaimerText:
          "本网站及其内容按 原样提供，不附任何明示或暗示的保证。GENOYA™ 不保证网站不间断、无错误或不含有害组件运行。",
        limitationTitle: "责任限制",
        limitationText:
          "在法律允许的最大范围内，GENOYA™ 对因您使用或无法使用本网站而引起的任何间接、附带、特殊或后果性损害不承担责任。",
        thirdPartyLinksTitle: "第三方链接",
        thirdPartyLinksText:
          "本网站可能包含第三方网站链接。GENOYA™ 对这些第三方网站的内容或做法没有控制权，也不承担任何责任。",
        governingLawTitle: "适用法律",
        governingLawText:
          "这些服务条款受适用的国际商业法律管辖并按其解释。任何争议应由双方通过诚信协商解决。",
        changesTitle: "条款变更",
        changesText:
          "GENOYA™ 保留随时修改这些服务条款的权利。发布变更后继续使用本网站即表示接受更新后的条款。",
        contactText: "如有关于这些服务条款的问题，请通过以下方式联系我们",
      },
    },
  },
  tr: {
    translation: {
      ingredientCategories: {
        protein: "Protein",
        carb: "Karbonhidrat",
        oil: "Yağ",
        prebiotic: "Prebiyotik",
        probiotic: "Probiyotik",
        superfood: "Süper Besin",
        mineral: "Mineral",
        amino: "Amino Asit",
        botanical: "Botanik",
        premix: "Vitamin ve Mineral Ön Karışımı",
        other: "Diğer",
        showLess: "− Daha Az",
        more: "daha fazla",
      },
      ingredients: {
        beef: "Dana Eti",
        rabbit: "Tavşan",
        duck: "Ördek",
        lamb: "Kuzu",
        turkey: "Hindi",
        whitefish: "Beyaz Etli Balık",
        freshly_prepared_beef: "Taze Hazırlanmış Dana Eti",
        beef_meal: "Dana Eti Unu",
        dehydrated_beef_protein: "Dehidrate Dana Proteini",
        freshly_prepared_rabbit: "Taze Hazırlanmış Tavşan",
        rabbit_meal: "Tavşan Unu",
        dehydrated_rabbit_protein: "Dehidrate Tavşan Proteini",
        freshly_prepared_turkey: "Taze Hazırlanmış Hindi",
        turkey_meal: "Hindi Unu",
        dehydrated_turkey_protein: "Dehidrate Hindi Proteini",
        freshly_prepared_duck: "Taze Hazırlanmış Ördek",
        duck_meal: "Ördek Unu",
        dehydrated_duck_protein: "Dehidrate Ördek Proteini",
        freshly_prepared_whitefish: "Taze Hazırlanmış Beyaz Etli Balık",
        whitefish_meal: "Beyaz Etli Balık Unu",
        dehydrated_whitefish_protein: "Dehidrate Beyaz Balık Proteini",
        freshly_prepared_lamb: "Taze Hazırlanmış Kuzu",
        lamb_meal: "Kuzu Unu",
        dehydrated_lamb_protein: "Dehidrate Kuzu Proteini",
        beef_broth: "Dana Suyu",
        lamb_broth: "Kuzu Suyu",
        rabbit_broth: "Tavşan Suyu",
        turkey_broth: "Hindi Suyu",
        whitefish_broth: "Beyaz Balık Suyu",
        potato_flour: "Patates Unu",
        tapioca: "Tapioka",
        pumpkin: "Balkabağı",
        dried_cellulose_fibre: "Kuru Selüloz Lifi",
        salmon_oil: "Somon Yağı",
        flaxseed: "Keten Tohumu",
        dried_brewers_yeast: "Kurutulmuş Bira Mayası",
        probiotics: "Probiyotikler",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Ispanak",
        blueberry: "Yaban Mersini",
        kelp_powder: "Kelp Tozu",
        chicory_root: "Hindiba Kökü",
        inulin: "İnülin",
        fos: "FOS (Fruktooligosakkaritler)",
        mos: "MOS (Mannooligosakkaritler)",
        yeast_β_glucans: "Maya β-Glukanları",
        dicalcium_phosphate: "Dikalsiyum Fosfat",
        potassium_chloride: "Potasyum Klorür",
        sodium_phosphate: "Sodyum Fosfat",
        dl_methionine: "DL-Metiyonin",
        taurine: "Taurin",
        l_carnitine: "L-Karnitin",
        yucca_schidigera_extract: "Yucca Schidigera Özü",
        cranberry_extract: "Kızılcık Özü",
        "turmeric_&_ginger_extracts": "Zerdeçal ve Zencefil Özleri",
        "rosemary_&_green_tea_extracts": "Biberiye ve Yeşil Çay Özleri",
        "vitamin_&_mineral_premix": "Vitamin ve Mineral Ön Karışımı",
      },
      home: {
        heroTitle1: "Bilimsel Formül.",
        heroTitle2: "Saf Protein.",
        heroTitle3: "Fonksiyonel Sağlık.",
        heroSubtext:
          "Sindirim netliğini, metabolik dengeyi ve uzun vadeli canlılığı desteklemek için yapılandırılmış formülasyon sistemleri ile tasarlanmış, tek proteinli premium evcil hayvan beslenmesi.",
        viewProducts: "Formüllerimizi Keşfedin",
        becomeDistibutor: "Distribütör Olun",
        noChickenTitle: "Kesinlikle Tavuk İçermez. Tavuk Yan Ürünleri İçermez.",
        noChickenSubtitle: "Daima Monoprotein – Temel Sözümüz",
        noChickenText:
          "Her GENOYA formülü yalnızca tek bir saf ve tanımlanmış hayvansal protein kaynağı kullanır. Karışık protein yok. Tavuk yok. Tavuk yan ürünü yok. Bu tek protein felsefesi, dünya çapındaki evcil hayvanlar için hassas beslenme, daha iyi sindirilebilirlik ve daha net alerji yönetimi sunar.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™, katı bir tek protein felsefesi üzerine bilimsel olarak formüle edilmiş premium bir evcil hayvan beslenme markasıdır.",
        introPoint1: "Beslenme hassasiyeti",
        introPoint2: "Sindirim berraklığı",
        introPoint3: "Azaltılmış diyet karmaşıklığı",
        introPoint4: "Fonksiyonel sağlık optimizasyonu",
        introFooter:
          "Trendlere dayalı ürünler değil, yapılandırılmış beslenme sistemleri tasarlıyoruz.",
        diffTitle: "Temel Farklılaştırıcılar",
        diff1Title: "Tek Hayvansal Protein Mimarisi",
        diff1Desc:
          "Her formül, açıkça tanımlanmış tek bir birincil hayvansal protein kaynağı etrafında oluşturulur.",
        diff2Title: "Tahılsız Formülasyon",
        diff2Desc:
          "Gereksiz dolgu maddeleri içermeyen dengeli makro besin yapısı.",
        diff3Title: "Tavuksuz Politika",
        diff3Desc:
          "Tüm ürünlerde katı protein saflığı standardı. Tavuk veya tavuk yan ürünleri içermez.",
        diff4Title: "Fonksiyonel Entegrasyon",
        diff4Desc:
          "Prebiyotikler, probiyotikler, eklem destek bileşikleri ve optimize edilmiş omega dengesi.",
        scienceTitle: "Araştırmaya Dayalı. Performans İçin Yapılandırılmış.",
        scienceLead:
          "GENOYA™ formülasyonları şunlar kullanılarak tasarlanmıştır:",
        sciencePoint1: "Kontrollü protein-yağ oranları",
        sciencePoint2: "Dengeli Omega 3 ve 6 profilleri",
        sciencePoint3: "Prebiyotik FOS ve MOS sistemleri",
        sciencePoint4: "Bağışıklık desteği için β-glukanlar",
        sciencePoint5: "Eklem bütünlüğü için Glukozamin ve Kondroitin",
        sciencePoint6: "Fonksiyonel gereksinimlere göre Taurin ve L-Karnitin",
        scienceFooter:
          "Her içerik tanımlanmış bir amaca hizmet eder. Her yüzde bir formülasyon mantığını takip eder.",
        previewTitle: "Formül Özeti",
        previewCats: "Kediler",
        previewDogs: "Köpekler",
        previewKitten: "Yavru Kedi",
        previewAdult: "Yetişkin",
        previewSterilised: "Kısırlaştırılmış Yetişkin",
        previewPuppy: "Yavru Köpek",
        previewSmallBreed: "Küçük Irk Yetişkin",
        previewAllBreeds: "Yetişkin (Tüm Irklar)",
        distributorHeading: "Küresel Distribütörlük Fırsatları",
        distributorSubtext:
          "GENOYA™ yapılandırılmış uluslararası ortaklıklar yoluyla genişliyor. İhracata hazır belgelerle 20DC, 40HC ve 45ft konteynerleri destekliyoruz.",
        getStarted: "GENOYA™ ile Ortak Olun",
      },
      about: {
        heroTitle1: "Hassas Beslenme",
        heroTitle2: "Küresel Vizyon",
        heroSubtext:
          "GENOYA™, tek protein netliği ve fonksiyonel sağlık performansı üzerine kurulu sistemleri kullanarak premium evcil hayvan beslenmesi tasarlayan bilim odaklı bir markadır.",
        viewProducts: "Tüm Formülleri Görüntüle",
        missionTitle: "Misyonumuz",
        missionText:
          "Tek protein saflığı ve fonksiyonel performansa dayalı, bilim destekli formülasyon sistemleri aracılığıyla premium evcil hayvan beslenmesi tasarlamak.",
        valuesTitle: "İlkelerimiz",
        value1: "Protein Saflığı",
        value1subtext: "Tüm ürünlerde tek hayvansal protein mimarisi.",
        value2: "Besin Bütünlüğü",
        value2subtext:
          "Tanınmış beslenme çerçeveleriyle uyumlu yapılandırılmış formüller.",
        value3: "Fonksiyonel Sağlık Odaklılık",
        value3subtext:
          "Sindirim desteği, eklem bütünlüğü, bağışıklık dengesi ve metabolik optimizasyon.",
        value4: "Tavuk Yok. Tavuk Yan Ürünleri Yok.",
        value4subtext: "Tartışılmaz bir GENOYA™ marka standardı.",
        viewOurProducts: "Ürünleri Keşfedin",
        leadershipTitle: "Uzmanlık ve Konumlandırma",
        leadershipHeadText:
          " aşağıdaki alanlarda deneyimli profesyoneller tarafından oluşturulmuştur:",
        leadershipValue1: "Uluslararası evcil hayvan maması ticareti",
        leadershipValue2: "OEM üretim denetimi",
        leadershipValue3: "Marka mimarisi geliştirme",
        leadershipValue4: "Dağıtım ölçeklendirme",
        leadershipValue5: "Mevzuata uygun etiketleme sistemleri",
        leadershipTextBelow:
          "uluslararası dağıtım için tasarlanmış kontrollü formülasyon sistemleri ve kalite denetimi altında Çin'deki yapılandırılmış üretim tesisleri aracılığıyla faaliyet göstermektedir.",
        leadershipTextFinal:
          "Uzun vadeli küresel büyüme için tasarlanmış yapılandırılmış markalar inşa ediyoruz.",
        noChickenTitle: "Kesinlikle Tavuk İçermez. Tavuk Yan Ürünleri İçermez.",
        noChickenSubtitle: "Daima Monoprotein – Temel Taahhüdümüz",
        noChickenText:
          "GENOYA® hiçbir formülde asla tavuk veya tavuk yan ürünleri kullanmaz. Sıkı bir tek protein felsefesine dayanıyoruz: ürün başına bir adet saf ve tanımlanmış hayvansal kaynak. Bu, dünya çapındaki evcil hayvan sahipleri için daha iyi sindirilebilirlik, daha net alerji yönetimi ve eşsiz bir şeffaflık sağlar.",
        complianceTitle: "Beslenme Uygunluk Beyanı",
        complianceText:
          "İlgili yaşam evreleri için AAFCO besin profilleri ve FEDIAF yönergeleri dahil olmak üzere tanınmış uluslararası evcil hayvan maması standartları tarafından belirlenen beslenme seviyelerini karşılamak üzere formüle edilmiştir.",
        complianceBold:
          "Ürünlerimiz tüm yaşam evreleri için tam ve dengelidir.",
      },
      products: {
        heroTitle: "Gelişmiş Tek Proteinli Formüller",
        heroSubtext:
          "Tür, yaşam evresi ve fonksiyonel sağlık hedeflerine göre uyarlanmış, tek hayvansal protein kaynaklı hassas beslenme.",
        selectSpecies: "Evcil Hayvanınızın Türünü Seçin",
        backToSpecies: "Tür Seçimine Dön",
        noProductsAvailable: "Bu kategori için ürün bulunamadı.",
        filter: "Filtrele",
        clearFilters: "Filtreleri Temizle",
        resetFilters: "Hepsini Sıfırla",
        format: "Ürün Formatı",
        allFormats: "Tüm Formatlar",
        formats: {
          dry: "Kuru Mama",
          wet: "Yaş Mama",
        },
        dryKibble: "Kuru Mama",
        wetFood: "Yaş Mama / Konserve",
        ingredient: "Birincil Protein",
        allIngredients: "Tüm Proteinler",
        lifeStage: "Yaşam Evresi",
        allStages: "Tüm Evreler",
        healthGoal: "Fonksiyonel Hedef",
        allGoals: "Tüm Hedefler",
        healthBenefits: "Sağlık Faydaları",
        noResults: "Kriterlerinize uygun formül bulunamadı.",
        details: "Formül Detayları",
        showLess: "Daha Az Göster",
        collapseAll: "Tümünü Kapat",
        size: "Net İçerik",
        ingredients: "İçerik",
        fullIngredients: "Tam Kompozisyon",
        standard: "Üretim Standardı",
        packaging: "Ambalaj Tipi",
        aboutProduct: "ÖZELLİKLER",
        ingredientsLabel: "İÇİNDEKİLER (BİLEŞİM)",
        analysisLabel: "GARANTİ EDİLEN ANALİZ (varsa)",
        nutritionalAdditives: {
          sectionHeader: "Nutritional Additives (per kg)",
          vitamins: "Vitamins",
          traceElements: "Trace Elements",
          functionalAdditives: "Functional Additives",
          prebioticProbioticComplex: "Pre- & Probiotic Complex",
          botanicalExtracts: "Botanical Extracts",

          // Vitamins
          vitaminA: "Vitamin A",
          vitaminD3: "Vitamin D₃",
          vitaminE: "Vitamin E",
          vitaminC: "Vitamin C",
          vitaminB1: "Vitamin B₁",
          vitaminB2: "Vitamin B₂",
          vitaminB6: "Vitamin B₆",
          vitaminB12: "Vitamin B₁₂",
          niacin: "Niacin",
          pantothenicAcid: "Pantothenic Acid",
          folicAcid: "Folic Acid",
          biotin: "Biotin",
          cholineChloride: "Choline Chloride",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Methionine",

          // Trace Elements
          iron: "Iron",
          ferrousSulphate: "Ferrous Sulphate",
          zinc: "Zinc",
          zincSulphate: "Zinc Sulphate",
          manganese: "Manganese",
          manganeseSulphate: "Manganese Sulphate",
          copper: "Copper",
          copperSulphate: "Copper Sulphate",
          iodine: "Iodine",
          calciumIodate: "Calcium Iodate",
          selenium: "Selenium",
          sodiumSelenite: "Sodium Selenite",

          // Functional Additives
          glucosamine: "Glucosamine",
          chondroitinSulphate: "Chondroitin Sulphate",
          yuccaSchidigeraExtract: "Yucca Schidigera Extract",
          cranberryExtract: "Cranberry Extract",

          // Pre- & Probiotic Complex
          inulinFOS: "Inulin (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucans",
          probiotics: "Probiotics",
          cfu: "CFU",

          // Botanical Extracts
          rosemary: "Rosemary",
          greenTea: "Green Tea",
          turmeric: "Turmeric",
          ginger: "Ginger",
          kelp: "Kelp",
          blueberry: "Blueberry",

          // Units / labels
          iu: "IU",
          mg: "mg",
          perKg: "per kg",
          asLabel: "as",
        },
        categories: {
          cat: "Kedi Beslenmesi",
          cats: "Kedi Beslenmesi",
          dog: "Köpek Beslenmesi",
          dogs: "Köpek Beslenmesi",
        },
        stages: {
          adult: "Yetişkin",
          adult_small_breed: "Küçük Irk Yetişkin",
          sterilised: "Kısırlaştırılmış",
          dog: {
            junior: "Yavru",
          },
          cat: {
            junior: "Yavru",
          },
        },
        sizeCategory: "Boyut / Irk",
        allSizes: "Tüm Boyutlar",
        sizes: {
          allBreeds: "Tüm Irklar",
          smallBreed: "Küçük Irk",
          "all-breeds": "Tüm Irklar",
          "small-breed": "Küçük Irk",
          mediumBreed: "Orta Irk",
          largeBreed: "Büyük Irk",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Sindirim Sağlığı",
          skin: "Deri ve Tüy Beslenmesi",
          immune: "Bağışıklık Sistemi Desteği",
          antioxidant: "Antioksidan Savunma",
          muscle: "Kas Bakımı",
          joint: "Eklem Desteği",
          weight: "Kilo Kontrolü",
          urinary: "Üriner Sistem Sağlığı",
          brain: "Beyin ve Bilişsel Sağlık",
          bone: "Kemik ve Eklem Gelişimi",
        },
        goals: {
          digestion: "Sindirim Sağlığı",
          skin: "Deri ve Tüy Beslenmesi",
          weight: "Kilo Kontrolü",
          urinary: "Üriner Sağlık",
          immune: "Bağışıklık Desteği",
          antioxidant: "Antioksidan Koruma",
          muscle: "Kas Bakımı",
          joint: "Eklem Desteği",
        },
        flavors: {
          beef: "Sığır Eti",
          duck: "Ördek",
          lamb: "Kuzu",
          rabbit: "Tavşan",
          turkey: "Hindi",
          whitefish: "Beyaz Etli Balık",
        },
        textures: {
          kibble: "Kuru Mama",
          "chunks in jelly": "Jöle İçinde Parçalar",
        },
        linekey: {
          dailyCare: "Günlük Bakım",
          superfoodPlus: "Süper Besin+",
        },
        animals: {
          dog: "Köpek",
          cat: "Kedi",
        },
        description:
          "{{stage}} {{animal}} için tasarlanmış, {{texture}} formatında premium tek proteinli {{flavor}} tarifi.",
        types: {
          dry: "Kuru",
          wet: "Yaş",
        },
        singleProtein: "tek proteinli",
        grainFree: "tahılsız",
        premiumCompleteFood: "Premium tam ve dengeli mama",
        frontView: "Ön Görünüm",
        backView: "Arka Görünüm",
        feedingGuideNotAvailable: "Bu ürün için besleme kılavuzu mevcut değil.",
        technicalSpecs: "Teknik Özellikler",
        keyBenefits: "Temel Fonksiyonel Faydalar",
        analyticalConstituents: "Analitik Bileşenler",
        feedingGuide: "Besleme Kılavuzu",
        functionalIngredients: "Fonksiyonel İçerikler ve Katkı Maddeleri",
        petWeight: "Evcil Hayvan Ağırlığı",
        gramsPerDay: "Günlük Gram",
        viewBack: "Arka Etiketi Görüntüle",
        viewFront: "Ön Etiketi Görüntüle",
        clickToZoom: "Yakınlaştırmak için resme tıklayın",
        analysis: {
          protein: "Ham Protein",
          fat: "Ham Yağ",
          fiber: "Ham Lif",
          ash: "Ham Kül",
          omega3: "Omega-3",
          omega6: "Omega-6",
        },
        netContentLabel: "Net İçerik",
        packagingTypeLabel: "Ambalaj",
        standardLabel: "Standart",
        pillarNoChicken:
          "Kesinlikle Tavuk İçermez. Tavuk Yan Ürünleri İçermez. Daima Monoprotein.",
        noChickenTitle: "Temel Sözümüz",
        noChickenText:
          "GENOYA® asla tavuk veya tavuk yan ürünleri kullanmaz. Her formül, saf bir hayvansal protein kaynağı üzerine kuruludur – yaşam evresi için tam ve dengelidir.",
        filterReinforce:
          "Tüm formüller Tam ve Dengelidir – Kesinlikle Tavuksuz / Daima Monoprotein",
        complianceTitle: "Beslenme Uygunluğu",
        complianceText:
          "AAFCO besin profilleri ve ilgili yaşam evresi için FEDIAF yönergeleri dahil olmak üzere uluslararası evcil hayvan maması standartları tarafından belirlenen beslenme seviyelerini karşılamak üzere formüle edilmiştir.",
        completeBalanced: "Tam ve Dengeli",
        nutritionalAdequacyTitle: "Besinsel Yeterlilik Beyanı",
        nutritionalAdequacyText:
          "Hedeflenen yaşam evresi için tanınmış AAFCO ve FEDIAF besin profili yönergeleriyle uyumlu olarak formüle edilmiştir. Besinsel yeterlilik, formülasyon analizine dayanmaktadır.",
        regulatoryDisclaimer:
          "AAFCO ve FEDIAF mevzuat yönerge kuruluşlarıdır. GENOYA™ ürünleri bu kuruluşlar tarafından onaylanmış veya sertifikalandırılmış değildir.",
        tabs: {
          ingredients: "İçerik",
          feeding: "Besleme Kılavuzu",
          nutrition: "Beslenme Değerleri",
          aminoAcids: "Amino Asitler",
        },
        analytical: {
          guaranteedAnalysis: "Garantili Analiz",
          analyticalValues: "Analitik Değerler",
          metabolisable_energy: "Metabolize Edilebilir Enerji",
          digestibility: "Sindirilebilirlik",
          estimated: "Tahmini",
          crude_protein_min: "Ham Protein (min)",
          crude_fat_min: "Ham Yağ (min)",
          crude_fibre_max: "Ham Lif (maks)",
          crude_ash_max: "Ham Kül (maks)",
          moisture_max: "Nem (maks)",
          taurine: "Taurin",
          omega3: "Omega-3",
          omega6: "Omega-6",
          calcium_min: "Kalsiyum (min)",
          calcium_max: "Kalsiyum (maks)",
          phosphorus_min: "Fosfor (min)",
          phosphorus_max: "Fosfor (maks)",
          l_carnitine: "L-Karnitin",
          metabolisable_energy_kcal: "Metabolize Edilebilir Enerji (kcal/kg)",
          metabolisable_energy_mj: "Metabolize Edilebilir Enerji (MJ/kg)",
          omega3_fatty_acids: "Omega-3",
          omega6_fatty_acids: "Omega-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Glukozamin",
          chondroitin_sulphate: "Kondroitin Sülfat",
          dl_methionine_ga: "DL-Metiyonin",
          sodium: "Sodyum",
          magnesium: "Magnezyum",
          potassium: "Potasyum",
          ca_p_ratio: "Kalsiyum : Fosfor Oranı",
        },
        fullIngredientList: "Tam içerik listesi",
        functionalHighlights: "Fonksiyonel Özellikler",
        storageShelfLife: "Saklama ve Raf Ömrü",
        storageText:
          "RAF ÖMRÜ: Üretim tarihinden itibaren 18 ay.\nSAKLAMA & GÜVENLİK\nSerin ve kuru bir yerde saklayın.\nAçtıktan sonra yeniden kapatın.\nDondurmayın.",
        storageTextWet:
          "RAF ÖMRÜ: 3 yıl (açılmamış, üretim tarihinden itibaren).\nSAKLAMA & GÜVENLİK\nDoğrudan güneş ışığından uzak, serin ve kuru bir yerde saklayın.\nAçtıktan sonra buzdolabına koyun ve 5 gün içinde tüketin.\nDondurmayın.",
        functionalIngredientsText:
          "FONKSİYONEL İÇERİKLER\n- İnülin (FOS): Mikrobiyom dengesini destekler\n- MOS: Zararlı bağırsak bakterilerini engellemeye yardımcı olur\n- β-Glukanlar: Bağışıklık fonksiyonunu destekler\nSomon Yağı: EPA ve DHA beyin ve görme gelişimini destekler\nDL-Metionin: İdrar yolu sağlığını destekler\nTaurin: Kalp fonksiyonu, görme ve nörolojik destek için gereklidir",
        complianceTemplates: {
          kitten_cat:
            "{{name}}, AAFCO Kedi Maması Besin Profilleri'nin Büyüme ve Üreme için belirlediği besin düzeylerini karşılayacak şekilde formüle edilmiştir ve yavru kediler için tam ve dengeli evcil hayvan gıdası konusundaki FEDIAF beslenme yönergelerine uygundur.",
          adult_cat:
            "{{name}}, AAFCO Kedi Maması Besin Profilleri'nin Yetişkin Bakımı için belirlediği besin düzeylerini karşılayacak şekilde formüle edilmiştir ve yetişkin kedi gıdası konusundaki FEDIAF beslenme yönergelerine uygundur.",
          sterilised_cat:
            "{{name}}, AAFCO Kedi Maması Besin Profilleri'nin Yetişkin Bakımı için belirlediği besin düzeylerini karşılayacak şekilde formüle edilmiştir ve kısırlaştırılmış yetişkin kedi gıdası konusundaki FEDIAF beslenme yönergelerine uygundur.",
          smallbreed_puppy:
            "{{name}}, AAFCO Köpek Maması Besin Profilleri'nin Büyüme için belirlediği besin düzeylerini karşılayacak şekilde formüle edilmiştir ve küçük ırk yavru köpek gıdası konusundaki FEDIAF beslenme yönergelerine uygundur.",
          medlarge_puppy:
            "{{name}}, AAFCO Köpek Maması Besin Profilleri'nin Büyüme için belirlediği besin düzeylerini karşılayacak şekilde formüle edilmiştir ve orta ve büyük ırk yavru köpek gıdası konusundaki FEDIAF beslenme yönergelerine uygundur.",
          adult_small_dog:
            "{{name}}, yetişkin küçük ırk köpeklerin beslenme ihtiyaçlarını karşılamak üzere formüle edilmiş tek hayvani proteinli, tahılsız fonksiyonel bir diyettir. Yalnızca {{protein}} tek hayvani protein kaynağı olarak kullanılarak hazırlanan bu yüksek sindirilebilirliğe sahip reçete; kas kütlesi bakımını, sağlıklı deri ve tüy yapısını, sindirim sağlığını, bağışıklık fonksiyonunu ve genel canlılığı destekler. Kümes hayvanı, tahıl, soya ve yapay koruyucu içermez. Yetişkin küçük ırk köpekler için tam ve dengeli evcil hayvan gıdası.",
          adult_allbreed_dog:
            "{{name}}, tüm ırktan yetişkin köpeklerin beslenme ihtiyaçlarını karşılamak üzere formüle edilmiş tek hayvani proteinli, tahılsız fonksiyonel bir diyettir. Yalnızca {{protein}} tek hayvani protein kaynağı olarak kullanılarak hazırlanan bu yüksek sindirilebilirliğe sahip reçete; kas kütlesi bakımını, sağlıklı deri ve tüy yapısını, sindirim sağlığını, bağışıklık fonksiyonunu ve genel canlılığı destekler. Kümes hayvanı, tahıl, soya ve yapay koruyucu içermez. Yetişkin köpekler için tam ve dengeli evcil hayvan gıdası.",
        },
        complianceStatement: "Uyumluluk Beyanı",
        nutritionalAdditivesPerKg: "Besinsel Katkı Maddeleri (kg başına)",
        vitamins: "Vitaminler",
        traceElements: "Eser Elementler",
        functionalAdditives: "Fonksiyonel Katkı Maddeleri",
        prebioticProbioticComplex: "Pre- ve Probiyotik Kompleks",
        botanicalExtracts: "Botanik Özler",
        aminoAcids: {
          lysine: "Lizin",
          methionine: "Metiyonin",
          threonine: "Treonin",
          tryptophan: "Triptofan",
          leucine: "Lösin",
          isoleucine: "İzolösin",
          valine: "Valin",
          histidine: "Histidin",
          phenylalanine: "Fenilalanin",
          arginine: "Arginin",
        },
        aminoAcidProfile: "Temel Amino Asit Profili",
        aminoNote:
          "† Yaklaşık değerler. Taurin, beyan edilen minimum düzeyde beslenme katkısı olarak eklenmektedir.",
        feeding: {
          day: "gün",
          can: "kutu",
          cans: "kutu",
          dryNote:
            "Miktarlar günlük kılavuz değerlerdir. 2–3 öğüne bölün. Her zaman taze su sağlayın.",
          kitten__2_4months: "Yavru Kedi (2–4 ay)",
          kitten__4_6months: "Yavru Kedi (4–6 ay)",
          junior_7_12months: "Junior (7–12 ay)",
          puppy___2_4_months: "Yavru Köpek (2–4 ay)",
          puppy___4_9_months: "Yavru Köpek (4–9 ay)",
          junior__7_9_months: "Junior (7–9 ay)",
          junior__9_12_months: "Junior (9–12 ay)",
          junior___9_12_months: "Junior (9–12 ay)",
          junior___12_15_months: "Junior (12–15 ay)",
          junior__15_20_months: "Junior (15–20 ay)",
          adult_cat__1_3_yrs: "Yetişkin Kedi (1–3 yıl)",
          adult_cat__3_7_yrs: "Yetişkin Kedi (3–7 yıl)",
          adult_cat__7__yrs: "Yetişkin Kedi (7+ yıl)",
          adult_dog__1_3_yrs: "Yetişkin Köpek (1–3 yıl)",
          adult_dog___3_7_yrs: "Yetişkin Köpek (3–7 yıl)",
          adult_dog__7__yrs: "Yetişkin Köpek (7+ yıl)",
          "1_3_yrs": "1–3 yıl",
          "3_7_yrs": "3–7 yıl",
          "7__yrs": "7+ yıl",
          stage_label: "Yaşam Evresi",
        },
      },
      distributors: {
        emailLabel: "E-posta",
        websiteLabel: "Web sitesi",
        heroTitle: "Uluslararası Distribütörlük Ortaklıkları",
        heroSubtext:
          "GENOYA®, münhasıran uzun vadeli distribütörlük ve OEM ortaklıklarına odaklanmış premium, yapılandırılmış küresel bir markadır.",
        contactUs: "İhracat Ekibiyle İletişime Geçin",
        exportTitle: "Küresel İhracat ve Konteyner Yükleme Kapasitesi",
        fcl: "Tam Konteyner Yükü (FCL) Mevcuttur",
        fclDesc:
          "Dünya çapında sevkiyat koordinasyonu ile 20DC / 40HC / 45FT konteyner desteği.",
        mixedSku: "Karışık SKU Yükleme",
        mixedSkuDesc:
          "Birden fazla ürün varyantı için esnek palet konfigürasyonları.",
        compliance: "Mevzuat ve Kalite Güvencesi",
        complianceDesc:
          "Hedef pazarlarda uyumluluğu sağlamak için tam denetim.",
        palletStandards: "Desteklenen Palet Standartları",
        eurPallets: "EUR / EPAL Paletler (1200 × 800 mm)",
        ukPallets: "İngiltere Standart Paletler (1200 × 1000 mm)",
        usPallets: "ABD GMA Paletler (48” × 40”)",
        whyPartnerTitle: "Neden GENOYA® ile Ortak Olmalısınız?",
        benefitScience: "Bilim Odaklı Formülasyonlar",
        benefitScienceDesc:
          "AAFCO/FEDIAF uyumlu tam ve dengeli monoprotein beslenmesi.",
        benefitSingleProtein: "Sıkı Tek Protein Felsefesi",
        benefitSingleProteinDesc:
          "Tavuk yok, yan ürün yok; saf ve izlenebilir hayvansal proteinler.",
        benefitProduction: "Ölçeklenebilir İhracata Hazır Üretim",
        benefitProductionDesc:
          "Esnek karışık SKU seçenekleriyle tam konteyner yüklemeleri.",
        benefitLongTerm: "Stratejik Uzun Vadeli Ortaklık",
        benefitLongTermDesc:
          "Marka bütünlüğü ve distribütörler için özel destek.",
        officialOversight: "Resmi İhracat ve Üretim Denetimi",
        oversightText:
          "GENOYA® uluslararası ticaret operasyonları ve OEM üretim denetimi, aşağıdakileri sağlamak için belirlenmiş ihracat birimimiz aracılığıyla yönetilir:",
        oversight1: "Uluslararası pazarlarda mevzuat uyumu",
        oversight2: "FCL ihracat koordinasyonu (20DC / 40HC / 45FT)",
        oversight3: "Üretim denetimi ve kalite güvencesi",
        oversight4: "Marka bütünlüğü ve formülasyon uyumu",
        oversight5: "Küresel distribütör ortaklık yönetimi",
        exportContact: "İhracat ve Uluslararası Ticaret Departmanı",
        exportEntity: "Resmi İhracat Birimi",
        founder: "Kurucu ve Küresel Genel Müdür",
        registeredAddress: "Kayıtlı Adres",
        inquiryTitle: "Ortaklık Talebinizi Gönderin",
        inquiryDesc:
          "Ulusal ithalatçılardan, bölgesel distribütörlerden ve stratejik ortaklardan gelen ciddi talepleri memnuniyetle karşılıyoruz.",
        finalCtaTitle: "GENOYA® ile Ortak Olmaya Hazır mısınız?",
        finalCtaDesc:
          "Premium distribütör ortaklarından oluşan küresel ağımıza katılın.",
        contactExport: "İhracat Ekibiyle İletişime Geçin",
        becomePartner: "Şimdi Sorgula",
        form: {
          companyName: "Şirket Adı / Tüzel Kişilik",
          country: "Ana Pazar / Ülke",
          businessType: "İş Türü",
          select: "Tür seçin",
          nationalImporter: "Ulusal İthalatçı",
          regionalDistributor: "Bölgesel Distribütör",
          premiumRetail: "Premium Perakende Zinciri",
          vetChannel: "Veteriner Kanalı / Profesyonel",
          oem: "OEM Ortağı / Özel Marka",
          volume: "Tahmini Yıllık Hacim",
          volumePlaceholder: "ör. 10–50 konteyner / yıl",
          containerInterest: "Tercih Edilen Konteyner Boyutu (biliniyorsa)",
          email: "Kurumsal E-posta",
          phone: "Telefon (ülke kodu ile)",
          submit: "Ortaklık Talebi Gönder",
        },
      },
      contact: {
        phone: "Telefon",
  country: "Ülke",
  optional: "isteğe bağlı",
  selectCountry: "Ülkenizi seçin",
  messagePlaceholder: "Size nasıl yardımcı olabiliriz?",
  sending: "Gönderiliyor...",
  sendAnother: "Başka bir mesaj gönder",
  operatedBy: "Operatör",
  searchCountries: "Ülke ara...",
  noResults: "Sonuç yok",
        title: "GENOYA™ ile Bağlantı Kurun",
        generalTitle: "Genel Sorular",
        generalDesc: "Ürün bilgileri ve markayla ilgili sorular için:",
        partnershipTitle: "Distribütör Soruları",
        partnershipDesc: "İş ortaklıkları ve dağıtım fırsatları için:",
        formName: "Ad Soyad",
        formEmail: "E-posta Adresi",
        formMessage: "Mesaj",
        sendButton: "Mesaj Gönder",
        name: "Ad Soyad",
        email: "E-posta",
        message: "Mesaj",
        send: "Gönder",
        successTitle: "Mesaj Başarıyla Gönderildi",
        successDesc:
          "Bizimle iletişime geçtiğiniz için teşekkür ederiz. Ekibimiz en kısa sürede size dönüş yapacaktır.",
      },
      nav: {
        home: "Ana Sayfa",
        about: "Hakkımızda",
        products: "Formüller",
        distributors: "Distribütörler",
        contact: "İletişim",
        toggleMenu: "Navigasyonu aç/kapat",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Tüm Hakları Saklıdır.",
        tagline: "Bilimsel Formül. Saf Protein.",
        quickLinks: "Navigasyon",
        global: "Küresel Operasyonlar",
        languages: "Dil Seçimi",
        distributorInfo: "İhracat Özellikleri",
        email: "İletişim E-postası",
        legal: "Uyumluluk",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Koşulları",
      },
      privacy: {
        label: "Hukuki",
        title: "Gizlilik Politikası",
        lastUpdated: "Son güncelleme: Mart 2026",
        intro:
          "GENOYA™, kişisel bilgilerinizi korumaya kararlıdır. Bu Gizlilik Politikası, genoyapetfood.com adresini ziyaret ettiğinizde hangi verileri topladığımızı, bunları nasıl kullandığımızı ve bu verilerle ilgili haklarınızı açıklamaktadır.",
        informationCollectedTitle: "Topladığımız Bilgiler",
        info1: "İletişim formları: ad, e-posta adresi, şirket adı, ülke ve mesaj içeriği.",
        info2: "Kullanım verileri: ziyaret edilen sayfalar, sitede geçirilen süre, tarayıcı türü ve analiz araçları aracılığıyla toplanan cihaz bilgileri.",
        info3: "Site performansı ve analiz için kullanılan çerezler ve benzer teknolojiler.",
        howWeUseTitle: "Bilgilerinizi Nasıl Kullanıyoruz",
        use1: "Distribütör sorgularına ve iletişim formu gönderimlerine yanıt vermek için.",
        use2: "Web sitesi performansını analiz etmek ve kullanıcı deneyimini iyileştirmek için.",
        use3: "Yasal yükümlülükleri yerine getirmek için.",
        use4: "Kişisel bilgilerinizi üçüncü taraflara satmıyor, kiralamıyor veya devretmiyoruz.",
        dataRetentionTitle: "Veri Saklama",
        dataRetentionText:
          "İletişim formu verilerini, başvurunuza yanıt vermek için gerekli olan süre boyunca ve ardından kayıt amaçlı makul bir süre için saklıyoruz.",
        thirdPartyTitle: "Üçüncü Taraf Hizmetler",
        thirdPartyText:
          "Web sitemiz, analiz sağlayıcıları gibi üçüncü taraf hizmetleri kullanabilir. Bu hizmetler, kendi gizlilik politikaları kapsamında veri toplayabilir.",
        cookiesTitle: "Çerezler",
        cookie1: "Sitenin doğru çalışması için gerekli olan temel çerezleri kullanıyoruz.",
        cookie2: "Ziyaretçilerin siteyle nasıl etkileşime girdiğini anlamak için analiz çerezleri kullanılabilir. Çerezleri tarayıcı ayarlarınızdan devre dışı bırakabilirsiniz.",
        yourRightsTitle: "Haklarınız",
        right1: "Hakkınızda tuttuğumuz kişisel verilere erişim talebinde bulunma hakkına sahipsiniz.",
        right2: "Verilerinizin düzeltilmesini veya silinmesini isteyebilirsiniz.",
        right3: "Bu hakları kullanmak için aşağıdaki e-posta adresinden bize ulaşın.",
        changesTitle: "Politika Değişiklikleri",
        changesText:
          "Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. En güncel sürüm, güncellenen tarihle birlikte her zaman bu sayfada mevcut olacaktır.",
        contactText: "Gizlilikle ilgili soru veya talepler için bize şu adresten ulaşın",
      },
      terms: {
        label: "Hukuki",
        title: "Kullanım Koşulları",
        lastUpdated: "Son güncelleme: Mart 2026",
        intro:
          "GENOYA™ web sitesine (genoyapetfood.com) erişerek ve kullanarak bu Kullanım Koşullarına bağlı olmayı kabul etmiş olursunuz. Siteyi kullanmadan önce lütfen dikkatlice okuyun.",
        acceptanceTitle: "Koşulların Kabulü",
        acceptanceText:
          "Bu web sitesini kullanmanız, Kullanım Koşullarını kabul ettiğiniz anlamına gelir. Bu koşulların herhangi bir bölümüne katılmıyorsanız lütfen web sitesini kullanmayın.",
        useOfSiteTitle: "Web Sitesinin Kullanımı",
        use1: "Bu siteyi yalnızca yasal amaçlarla ve bu koşullara uygun olarak kullanabilirsiniz.",
        use2: "Siteyi hasar verecek, devre dışı bırakacak veya diğer kullanıcılara zarar verecek şekilde kullanamazsınız.",
        use3: "Sitenin veya ilgili sistemlerin herhangi bir bölümüne yetkisiz erişim sağlamaya çalışamazsınız.",
        use4: "GENOYA™'nın önceden yazılı izni olmaksızın site içeriğinin ticari amaçlı kullanımı yasaktır.",
        intellectualPropertyTitle: "Fikri Mülkiyet",
        intellectualPropertyText:
          "Bu web sitesindeki tüm içerik — metin, görsel, logo, ürün adları, formüller ve tasarım dahil — GENOYA™'ya aittir ve geçerli fikri mülkiyet yasaları kapsamında korunmaktadır.",
        disclaimerTitle: "Garanti Reddi",
        disclaimerText:
          "Bu web sitesi ve içeriği, açık veya zımni herhangi bir garanti olmaksızın \"olduğu gibi\" sunulmaktadır. GENOYA™, sitenin kesintisiz, hatasız veya zararlı bileşenlerden arındırılmış olacağını garanti etmez.",
        limitationTitle: "Sorumluluğun Sınırlandırılması",
        limitationText:
          "Yasanın izin verdiği azami ölçüde, GENOYA™; bu web sitesini kullanmanızdan veya kullanamamanızdan kaynaklanan hiçbir dolaylı, arızi, özel veya sonuçsal zarardan sorumlu tutulamaz.",
        thirdPartyLinksTitle: "Üçüncü Taraf Bağlantılar",
        thirdPartyLinksText:
          "Bu web sitesi, üçüncü taraf web sitelerine bağlantılar içerebilir. GENOYA™, bu sitelerin içeriği veya uygulamaları üzerinde hiçbir kontrole sahip değildir ve bunlar için hiçbir sorumluluk üstlenmez.",
        governingLawTitle: "Uygulanacak Hukuk",
        governingLawText:
          "Bu Kullanım Koşulları, geçerli uluslararası ticaret hukukuna göre yönetilecek ve yorumlanacaktır. Herhangi bir anlaşmazlık, taraflar arasında iyi niyetli müzakere yoluyla çözülecektir.",
        changesTitle: "Koşul Değişiklikleri",
        changesText:
          "GENOYA™, bu Kullanım Koşullarını istediği zaman değiştirme hakkını saklı tutar. Değişikliklerin yayınlanmasından sonra web sitesini kullanmaya devam etmek, güncellenmiş koşulların kabulü anlamına gelir.",
        contactText: "Bu Kullanım Koşullarına ilişkin sorularınız için bize şu adresten ulaşın",
      },
    },
  },
  ru: {
    translation: {
      ingredientCategories: {
        protein: "Белок",
        carb: "Углевод",
        oil: "Масло и Жир",
        prebiotic: "Пребиотик",
        probiotic: "Пробиотик",
        superfood: "Суперфуд",
        mineral: "Минерал",
        amino: "Аминокислота",
        botanical: "Растительный экстракт",
        premix: "Витаминно-Минеральный Премикс",
        other: "Прочее",
        showLess: "− Меньше",
        more: "ещё",
      },
      ingredients: {
        beef: "Говядина",
        rabbit: "Кролик",
        duck: "Утка",
        lamb: "Ягнёнок",
        turkey: "Индейка",
        whitefish: "Белая Рыба",
        freshly_prepared_beef: "Свежеприготовленная Говядина",
        beef_meal: "Мука из Говядины",
        dehydrated_beef_protein: "Дегидратированный Говяжий Протеин",
        freshly_prepared_rabbit: "Свежеприготовленный Кролик",
        rabbit_meal: "Мука из Кролика",
        dehydrated_rabbit_protein: "Дегидратированный Протеин Кролика",
        freshly_prepared_turkey: "Свежеприготовленная Индейка",
        turkey_meal: "Мука из Индейки",
        dehydrated_turkey_protein: "Дегидратированный Протеин Индейки",
        freshly_prepared_duck: "Свежеприготовленная Утка",
        duck_meal: "Мука из Утки",
        dehydrated_duck_protein: "Дегидратированный Протеин Утки",
        freshly_prepared_whitefish: "Свежеприготовленная Белая Рыба",
        whitefish_meal: "Мука из Белой Рыбы",
        dehydrated_whitefish_protein: "Дегидратированный Протеин Белой Рыбы",
        freshly_prepared_lamb: "Свежеприготовленный Ягнёнок",
        lamb_meal: "Мука из Ягнёнка",
        dehydrated_lamb_protein: "Дегидратированный Протеин Ягнёнка",
        beef_broth: "Говяжий Бульон",
        lamb_broth: "Бульон из Ягнёнка",
        rabbit_broth: "Бульон из Кролика",
        turkey_broth: "Бульон из Индейки",
        whitefish_broth: "Бульон из Белой Рыбы",
        potato_flour: "Картофельная Мука",
        tapioca: "Тапиока",
        pumpkin: "Тыква",
        dried_cellulose_fibre: "Сухое Целлюлозное Волокно",
        salmon_oil: "Масло Лосося",
        flaxseed: "Льняное Семя",
        dried_brewers_yeast: "Сухие Пивные Дрожжи",
        probiotics: "Пробиотики",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Шпинат",
        blueberry: "Черника",
        kelp_powder: "Порошок Ламинарии",
        chicory_root: "Корень Цикория",
        inulin: "Инулин",
        fos: "ФОС (Фруктоолигосахариды)",
        mos: "МОС (Маннанолигосахариды)",
        yeast_β_glucans: "β-Глюканы Дрожжей",
        dicalcium_phosphate: "Дикальцийфосфат",
        potassium_chloride: "Хлорид Калия",
        sodium_phosphate: "Фосфат Натрия",
        dl_methionine: "DL-Метионин",
        taurine: "Таурин",
        l_carnitine: "L-Карнитин",
        yucca_schidigera_extract: "Экстракт Юкки Шидигера",
        cranberry_extract: "Экстракт Клюквы",
        "turmeric_&_ginger_extracts": "Экстракты Куркумы и Имбиря",
        "rosemary_&_green_tea_extracts": "Экстракты Розмарина и Зелёного Чая",
        "vitamin_&_mineral_premix": "Витаминно-Минеральный Премикс",
      },
      home: {
        heroTitle1: "Научная формула.",
        heroTitle2: "Чистый протеин.",
        heroTitle3: "Функциональное здоровье.",
        heroSubtext:
          "Премиальное питание для домашних животных на основе монопротеина, разработанное с использованием структурированных систем формуляции для улучшения пищеварения, метаболического баланса и долголетия.",
        viewProducts: "Ознакомиться с формулами",
        becomeDistibutor: "Стать дистрибьютором",
        noChickenTitle:
          "Строго без курицы. Без субпродуктов куриного происхождения.",
        noChickenSubtitle: "Всегда монопротеин — наше главное обещание",
        noChickenText:
          "Каждая формула GENOYA использует только один чистый и четко указанный источник животного белка. Никаких смешанных протеинов. Никакой курицы. Никаких куриных субпродуктов. Эта философия единственного белка обеспечивает точное питание, лучшую усвояемость и прозрачный контроль аллергий для животных по всему миру.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ — это научно обоснованный бренд премиального питания для животных, основанный на строгой философии монопротеина.",
        introPoint1: "Точность нутриентов",
        introPoint2: "Прозрачность пищеварения",
        introPoint3: "Сниженная диетическая сложность",
        introPoint4: "Оптимизация функционального здоровья",
        introFooter:
          "Мы проектируем структурированные системы питания, а не продукты, основанные на трендах.",
        diffTitle: "Ключевые отличия",
        diff1Title: "Архитектура единственного животного белка",
        diff1Desc:
          "Каждая формула построена вокруг одного четко определенного первичного источника животного белка.",
        diff2Title: "Беззерновая формула",
        diff2Desc:
          "Сбалансированная структура макронутриентов без лишних наполнителей.",
        diff3Title: "Политика «Без курицы»",
        diff3Desc:
          "Строгий стандарт чистоты протеина во всех продуктах. Без курицы и куриных субпродуктов.",
        diff4Title: "Функциональная интеграция",
        diff4Desc:
          "Пребиотики, пробиотики, комплексы для поддержки суставов и оптимизированный баланс Омега.",
        scienceTitle: "На основе исследований. Создано для результата.",
        scienceLead: "Формулы GENOYA™ разработаны с использованием:",
        sciencePoint1: "Контролируемого соотношения белков и жиров",
        sciencePoint2: "Сбалансированных профилей Омега 3 и 6",
        sciencePoint3: "Пребиотических систем FOS и MOS",
        sciencePoint4: "β-глюканов для поддержки иммунитета",
        sciencePoint5: "Глюкозамина и хондроитина для здоровья суставов",
        sciencePoint6: "Таурина и L-карнитина при функциональной необходимости",
        scienceFooter:
          "Каждый ингредиент служит определенной цели. Каждый процент следует логике формуляции.",
        previewTitle: "Обзор формул",
        previewCats: "Кошки",
        previewDogs: "Собаки",
        previewKitten: "Котенок",
        previewAdult: "Взрослая особь",
        previewSterilised: "Стерилизованная взрослая особь",
        previewPuppy: "Щенок",
        previewSmallBreed: "Взрослая особь малых пород",
        previewAllBreeds: "Взрослая особь (все породы)",
        distributorHeading: "Возможности глобальной дистрибуции",
        distributorSubtext:
          "GENOYA™ расширяется через структурированные международные партнерства. Мы обеспечиваем отгрузку контейнеров 20DC, 40HC и 45ft с полной экспортной документацией.",
        getStarted: "Стать партнером GENOYA™",
      },
      about: {
        heroTitle1: "Точное питание",
        heroTitle2: "Глобальное видение",
        heroSubtext:
          "GENOYA™ — это научно-ориентированный бренд, создающий премиальное питание, основываясь на чистоте монопротеина и функциональной эффективности.",
        viewProducts: "Посмотреть все формулы",
        missionTitle: "Наша миссия",
        missionText:
          "Проектировать премиальное питание для животных с помощью научно обоснованных систем, основанных на чистоте единственного белка и функциональных результатах.",
        valuesTitle: "Наши принципы",
        value1: "Чистота протеина",
        value1subtext:
          "Архитектура единственного животного белка во всех продуктах.",
        value2: "Целостность питания",
        value2subtext:
          "Структурированные формулы, соответствующие признанным международным стандартам.",
        value3: "Фокус на функциональном здоровье",
        value3subtext:
          "Поддержка пищеварения, здоровья суставов, иммунный баланс и метаболическая оптимизация.",
        value4: "Без курицы. Без куриных субпродуктов.",
        value4subtext: "Непоколебимый стандарт бренда GENOYA™.",
        viewOurProducts: "Ознакомиться с продукцией",
        leadershipTitle: "Экспертиза и позиционирование",
        leadershipHeadText: " создан профессионалами с опытом в сферах:",
        leadershipValue1: "Международная торговля кормами для животных",
        leadershipValue2: "Надзор за OEM-производством",
        leadershipValue3: "Разработка архитектуры бренда",
        leadershipValue4: "Масштабирование дистрибуции",
        leadershipValue5: "Системы маркировки согласно нормативам",
        leadershipTextBelow:
          "работает через структурированные производственные площадки в Китае под контролем систем формуляции и качества, разработанных для международной дистрибуции.",
        leadershipTextFinal:
          "Мы строим структурированные бренды, рассчитанные на долгосрочный глобальный рост.",
        noChickenTitle:
          "Строго без курицы. Без субпродуктов куриного происхождения.",
        noChickenSubtitle:
          "Всегда монопротеин — наше фундаментальное обязательство",
        noChickenText:
          "GENOYA® никогда не использует курицу или куриные субпродукты ни в одной формуле. Мы придерживаемся строгой философии единственного белка: один чистый животный источник на продукт. Это гарантирует лучшую усвояемость, прозрачный контроль аллергий и беспрецедентную честность перед владельцами животных.",
        complianceTitle: "Декларация о соответствии нормам питания",
        complianceText:
          "Сформулировано в соответствии с уровнями питательности, установленными признанными международными стандартами, включая профили AAFCO и рекомендации FEDIAF для соответствующих этапов жизни.",
        complianceBold:
          "Наши продукты являются полнорационными и сбалансированными для всех этапов жизни.",
      },
      products: {
        heroTitle: "Передовые монопротеиновые формулы",
        heroSubtext:
          "Точное питание с единственным источником животного белка, адаптированное по виду, этапу жизни и функциональным целям.",
        selectSpecies: "Выберите вид вашего животного",
        backToSpecies: "Назад к выбору вида",
        noProductsAvailable: "Продуктов в этой категории не найдено.",
        filter: "Фильтр",
        clearFilters: "Очистить фильтры",
        resetFilters: "Сбросить всё",
        format: "Формат продукта",
        allFormats: "Все форматы",
        formats: {
          dry: "Сухой корм",
          wet: "Влажный корм",
        },
        dryKibble: "Сухие крокеты",
        wetFood: "Влажный корм / Паштет",
        ingredient: "Основной протеин",
        allIngredients: "Все протеины",
        lifeStage: "Этап жизни",
        allStages: "Все этапы",
        healthGoal: "Функциональная цель",
        allGoals: "Все цели",
        healthBenefits: "Преимущества для здоровья",
        noResults: "Формул по вашему запросу не найдено.",
        details: "Детали формулы",
        showLess: "Показать меньше",
        collapseAll: "Свернуть всё",
        size: "Вес нетто",
        ingredients: "Ингредиенты",
        fullIngredients: "Полный состав",
        standard: "Стандарт производства",
        packaging: "Тип упаковки",
        aboutProduct: "ХАРАКТЕРИСТИКИ",
        ingredientsLabel: "СОСТАВ (ИНГРЕДИЕНТЫ)",
        analysisLabel: "ГАРАНТИРОВАННЫЙ АНАЛИЗ (если доступно)",
        nutritionalAdditives: {
          sectionHeader: "Nutritional Additives (per kg)",
          vitamins: "Vitamins",
          traceElements: "Trace Elements",
          functionalAdditives: "Functional Additives",
          prebioticProbioticComplex: "Pre- & Probiotic Complex",
          botanicalExtracts: "Botanical Extracts",

          // Vitamins
          vitaminA: "Vitamin A",
          vitaminD3: "Vitamin D₃",
          vitaminE: "Vitamin E",
          vitaminC: "Vitamin C",
          vitaminB1: "Vitamin B₁",
          vitaminB2: "Vitamin B₂",
          vitaminB6: "Vitamin B₆",
          vitaminB12: "Vitamin B₁₂",
          niacin: "Niacin",
          pantothenicAcid: "Pantothenic Acid",
          folicAcid: "Folic Acid",
          biotin: "Biotin",
          cholineChloride: "Choline Chloride",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Methionine",

          // Trace Elements
          iron: "Iron",
          ferrousSulphate: "Ferrous Sulphate",
          zinc: "Zinc",
          zincSulphate: "Zinc Sulphate",
          manganese: "Manganese",
          manganeseSulphate: "Manganese Sulphate",
          copper: "Copper",
          copperSulphate: "Copper Sulphate",
          iodine: "Iodine",
          calciumIodate: "Calcium Iodate",
          selenium: "Selenium",
          sodiumSelenite: "Sodium Selenite",

          // Functional Additives
          glucosamine: "Glucosamine",
          chondroitinSulphate: "Chondroitin Sulphate",
          yuccaSchidigeraExtract: "Yucca Schidigera Extract",
          cranberryExtract: "Cranberry Extract",

          // Pre- & Probiotic Complex
          inulinFOS: "Inulin (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucans",
          probiotics: "Probiotics",
          cfu: "CFU",

          // Botanical Extracts
          rosemary: "Rosemary",
          greenTea: "Green Tea",
          turmeric: "Turmeric",
          ginger: "Ginger",
          kelp: "Kelp",
          blueberry: "Blueberry",

          // Units / labels
          iu: "IU",
          mg: "mg",
          perKg: "per kg",
          asLabel: "as",
        },
        categories: {
          cat: "Питание для кошек",
          cats: "Питание для кошек",
          dog: "Питание для собак",
          dogs: "Питание для собак",
        },
        stages: {
          adult: "Взрослый",
          adult_small_breed: "Взрослый малой породы",
          sterilised: "Стерилизованный",
          dog: {
            junior: "Щенок",
          },
          cat: {
            junior: "Котенок",
          },
        },
        sizeCategory: "Размер / Порода",
        allSizes: "Все размеры",
        sizes: {
          allBreeds: "Все породы",
          smallBreed: "Малые породы",
          "all-breeds": "Все породы",
          "small-breed": "Малые породы",
          mediumBreed: "Средние породы",
          largeBreed: "Крупные породы",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Здоровье пищеварения",
          skin: "Питание кожи и шерсти",
          immune: "Поддержка иммунитета",
          antioxidant: "Антиоксидантная защита",
          muscle: "Поддержка мышц",
          joint: "Поддержка суставов",
          weight: "Контроль веса",
          urinary: "Здоровье мочевыделительной системы",
          brain: "Здоровье мозга и когнитивные функции",
          bone: "Развитие костей и суставов",
        },
        goals: {
          digestion: "Пищеварение",
          skin: "Кожа и шерсть",
          weight: "Контроль веса",
          urinary: "Мочевыделительная система",
          immune: "Иммунитет",
          antioxidant: "Антиоксиданты",
          muscle: "Мышцы",
          joint: "Поддержка суставов",
        },
        flavors: {
          beef: "Говядина",
          duck: "Утка",
          lamb: "Ягненок",
          rabbit: "Кролик",
          turkey: "Индейка",
          whitefish: "Белая рыба",
        },
        textures: {
          kibble: "Сухой корм",
          "chunks in jelly": "Кусочки в желе",
        },
        linekey: {
          dailyCare: "Ежедневный уход",
          superfoodPlus: "Суперфуд+",
        },
        animals: {
          dog: "Собака",
          cat: "Кошка",
        },
        description:
          "Премиальная монопротеиновая рецептура с {{flavor}} в формате {{texture}}, разработанная для {{animal}} (этап жизни: {{stage}}).",
        types: {
          dry: "Сухой",
          wet: "Влажный",
        },
        singleProtein: "монопротеиновый",
        grainFree: "беззерновой",
        premiumCompleteFood: "Премиальный полнорационный сбалансированный корм",
        frontView: "Вид спереди",
        backView: "Вид сзади",
        feedingGuideNotAvailable:
          "Рекомендации по кормлению для этого продукта отсутствуют.",
        technicalSpecs: "Технические характеристики",
        keyBenefits: "Ключевые функциональные преимущества",
        analyticalConstituents: "Аналитические компоненты",
        feedingGuide: "Рекомендации по кормлению",
        functionalIngredients: "Функциональные ингредиенты и добавки",
        petWeight: "Вес животного",
        gramsPerDay: "Грамм в день",
        viewBack: "Смотреть заднюю этикетку",
        viewFront: "Смотреть переднюю этикетку",
        clickToZoom: "Нажмите на изображение для увеличения",
        analysis: {
          protein: "Сырой белок",
          fat: "Сырой жир",
          fiber: "Сырая клетчатка",
          ash: "Сырая зола",
          omega3: "Омега-3 жирные кислоты",
          omega6: "Омега-6 жирные кислоты",
        },
        netContentLabel: "Вес нетто",
        packagingTypeLabel: "Упаковка",
        standardLabel: "Стандарт",
        pillarNoChicken:
          "Строго без курицы. Без курячьих субпродуктов. Всегда монопротеин.",
        noChickenTitle: "Наше основное обещание",
        noChickenText:
          "GENOYA® никогда не использует курицу или её субпродукты. Каждая формула основана на чистом источнике животного белка — полноценном и сбалансированном для конкретного этапа жизни.",
        filterReinforce:
          "Все формулы полнорационные и сбалансированные — Без курицы / Всегда монопротеин",
        complianceTitle: "Нутриентное соответствие",
        complianceText:
          "Сформулировано в соответствии с международными стандартами, включая профили AAFCO и рекомендации FEDIAF для соответствующих этапов жизни.",
        completeBalanced: "Полнорационный и сбалансированный",
        nutritionalAdequacyTitle: "Декларация о пищевой адекватности",
        nutritionalAdequacyText:
          "Разработано в соответствии с признанными рекомендациями AAFCO и FEDIAF. Пищевая адекватность основана на анализе формуляции.",
        regulatoryDisclaimer:
          "AAFCO и FEDIAF являются организациями, устанавливающими нормативные рекомендации. Продукция GENOYA™ не одобряется и не сертифицируется этими организациями.",
        tabs: {
          ingredients: "Ингредиенты",
          feeding: "Рекомендации по кормлению",
          nutrition: "Питательная ценность",
          aminoAcids: "Аминокислоты",
        },
        analytical: {
          guaranteedAnalysis: "Гарантированный анализ",
          analyticalValues: "Аналитические показатели",
          metabolisable_energy: "Метаболизируемая энергия",
          digestibility: "Усвояемость",
          estimated: "Ориентировочно",
          crude_protein_min: "Сырой белок (мин)",
          crude_fat_min: "Сырой жир (мин)",
          crude_fibre_max: "Сырая клетчатка (макс)",
          crude_ash_max: "Сырая зола (макс)",
          moisture_max: "Влажность (макс)",
          taurine: "Таурин",
          omega3: "Омега-3 жирные кислоты",
          omega6: "Омега-6 жирные кислоты",
          calcium_min: "Кальций (мин)",
          calcium_max: "Кальций (макс)",
          phosphorus_min: "Фосфор (мин)",
          phosphorus_max: "Фосфор (макс)",
          l_carnitine: "L-Карнитин",
          metabolisable_energy_kcal: "Обменная энергия (ккал/кг)",
          metabolisable_energy_mj: "Обменная энергия (МДж/кг)",
          omega3_fatty_acids: "Омега-3 жирные кислоты",
          omega6_fatty_acids: "Омега-6 жирные кислоты",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Глюкозамин",
          chondroitin_sulphate: "Хондроитина сульфат",
          dl_methionine_ga: "DL-Метионин",
          sodium: "Натрий",
          magnesium: "Магний",
          potassium: "Калий",
          ca_p_ratio: "Соотношение кальция и фосфора",
        },
        fullIngredientList: "Полный список ингредиентов",
        functionalHighlights: "Функциональные особенности",
        storageShelfLife: "Хранение и срок годности",
        storageText:
          "СРОК ГОДНОСТИ: 18 месяцев с даты производства.\nХРАНЕНИЕ И БЕЗОПАСНОСТЬ\nХранить в прохладном, сухом месте.\nПосле вскрытия плотно закрыть.\nНе замораживать.",
        storageTextWet:
          "СРОК ГОДНОСТИ: 3 года (невскрытый с даты производства).\nХРАНЕНИЕ И БЕЗОПАСНОСТЬ\nХранить в прохладном, сухом месте, вдали от прямых солнечных лучей.\nПосле вскрытия охладить и употребить в течение 5 дней.\nНе замораживать.",
        functionalIngredientsText:
          "ФУНКЦИОНАЛЬНЫЕ ИНГРЕДИЕНТЫ\n- Инулин (ФОС): Поддерживает баланс микробиома\n- МОС: Помогает блокировать вредные кишечные бактерии\n- β-Глюканы: Поддерживает иммунную функцию\nЛососевое масло: EPA и DHA поддерживают развитие мозга и зрения\nDL-Метионин: Поддерживает здоровье мочевыводящих путей\nТаурин: Необходим для сердечной функции, зрения и неврологической поддержки",
        complianceTemplates: {
          kitten_cat:
            "{{name}} сформулирован для соответствия уровням питательных веществ, установленным Профилями питательных веществ кошачьего корма AAFCO для Роста и Размножения, и соответствует руководящим принципам питания FEDIAF для полноценного и сбалансированного корма для котят.",
          adult_cat:
            "{{name}} сформулирован для соответствия уровням питательных веществ, установленным Профилями питательных веществ кошачьего корма AAFCO для Поддержания взрослых, и соответствует руководящим принципам питания FEDIAF для полноценного и сбалансированного корма для взрослых кошек.",
          sterilised_cat:
            "{{name}} сформулирован для соответствия уровням питательных веществ, установленным Профилями питательных веществ кошачьего корма AAFCO для Поддержания взрослых, и соответствует руководящим принципам питания FEDIAF для полноценного и сбалансированного корма для стерилизованных взрослых кошек.",
          smallbreed_puppy:
            "{{name}} сформулирован для соответствия уровням питательных веществ, установленным Профилями питательных веществ собачьего корма AAFCO для Роста, и соответствует руководящим принципам питания FEDIAF для полноценного и сбалансированного корма для щенков малых пород.",
          medlarge_puppy:
            "{{name}} сформулирован для соответствия уровням питательных веществ, установленным Профилями питательных веществ собачьего корма AAFCO для Роста, и соответствует руководящим принципам питания FEDIAF для полноценного и сбалансированного корма для щенков средних и крупных пород.",
          adult_small_dog:
            "{{name}} — это функциональный корм без зерна с единственным животным белком, сформулированный для удовлетворения питательных потребностей взрослых собак малых пород. Изготовленный исключительно с {{protein}} в качестве единственного источника животного белка, он поддерживает поддержание мышечной массы, здоровье кожи и шерсти, пищеварение, иммунную функцию и общую жизненную силу. Без птицы, зерна, сои и искусственных консервантов. Полноценный и сбалансированный корм для взрослых собак малых пород.",
          adult_allbreed_dog:
            "{{name}} — это функциональный корм без зерна с единственным животным белком, сформулированный для удовлетворения питательных потребностей взрослых собак всех пород. Изготовленный исключительно с {{protein}} в качестве единственного источника животного белка, он поддерживает поддержание мышечной массы, здоровье кожи и шерсти, пищеварение, иммунную функцию и общую жизненную силу. Без птицы, зерна, сои и искусственных консервантов. Полноценный и сбалансированный корм для взрослых собак.",
        },
        complianceStatement: "Заявление о соответствии",
        nutritionalAdditivesPerKg: "Пищевые добавки (на кг)",
        vitamins: "Витамины",
        traceElements: "Микроэлементы",
        functionalAdditives: "Функциональные добавки",
        prebioticProbioticComplex: "Пре- и Пробиотический комплекс",
        botanicalExtracts: "Растительные экстракты",
        aminoAcids: {
          lysine: "Лизин",
          methionine: "Метионин",
          threonine: "Треонин",
          tryptophan: "Триптофан",
          leucine: "Лейцин",
          isoleucine: "Изолейцин",
          valine: "Валин",
          histidine: "Гистидин",
          phenylalanine: "Фенилаланин",
          arginine: "Аргинин",
        },
        aminoAcidProfile: "Профиль незаменимых аминокислот",
        aminoNote:
          "† Приблизительные значения. Таурин добавлен в качестве пищевой добавки на заявленном минимальном уровне.",
        feeding: {
          day: "день",
          can: "банка",
          cans: "банки",
          dryNote:
            "Указанные количества являются ежедневными нормами. Разделите на 2–3 кормления. Всегда обеспечивайте свежей водой.",
          kitten__2_4months: "Котёнок (2–4 мес.)",
          kitten__4_6months: "Котёнок (4–6 мес.)",
          junior_7_12months: "Юниор (7–12 мес.)",
          puppy___2_4_months: "Щенок (2–4 мес.)",
          puppy___4_9_months: "Щенок (4–9 мес.)",
          junior__7_9_months: "Юниор (7–9 мес.)",
          junior__9_12_months: "Юниор (9–12 мес.)",
          junior___9_12_months: "Юниор (9–12 мес.)",
          junior___12_15_months: "Юниор (12–15 мес.)",
          junior__15_20_months: "Юниор (15–20 мес.)",
          adult_cat__1_3_yrs: "Взрослая кошка (1–3 г.)",
          adult_cat__3_7_yrs: "Взрослая кошка (3–7 г.)",
          adult_cat__7__yrs: "Взрослая кошка (7+ г.)",
          adult_dog__1_3_yrs: "Взрослая собака (1–3 г.)",
          adult_dog___3_7_yrs: "Взрослая собака (3–7 г.)",
          adult_dog__7__yrs: "Взрослая собака (7+ г.)",
          "1_3_yrs": "1–3 г.",
          "3_7_yrs": "3–7 г.",
          "7__yrs": "7+ г.",
          stage_label: "Жизненный этап",
        },
      },
      distributors: {
        emailLabel: "Эл. почта",
        websiteLabel: "Сайт",
        heroTitle: "Международное партнерство и дистрибуция",
        heroSubtext:
          "GENOYA® — это структурированный глобальный бренд премиум-класса, ориентированный исключительно на долгосрочную дистрибуцию и OEM-партнерство.",
        contactUs: "Связаться с отделом экспорта",
        exportTitle: "Возможности глобального экспорта и загрузки контейнеров",
        fcl: "Доступна полная загрузка контейнера (FCL)",
        fclDesc:
          "Поддержка контейнеров 20DC / 40HC / 45FT с координацией доставки по всему миру.",
        mixedSku: "Загрузка смешанных артикулов (SKU)",
        mixedSkuDesc:
          "Гибкая конфигурация паллет для нескольких вариантов продукции.",
        compliance: "Нормативное соответствие и контроль качества",
        complianceDesc:
          "Полный надзор для обеспечения соответствия требованиям целевых рынков.",
        palletStandards: "Поддерживаемые стандарты паллет",
        eurPallets: "Европаллеты / EPAL (1200 × 800 мм)",
        ukPallets: "Стандартные паллеты Великобритании (1200 × 1000 мм)",
        usPallets: "Паллеты США GMA (48” × 40”)",
        whyPartnerTitle: "Почему стоит стать партнером GENOYA®",
        benefitScience: "Научно обоснованные формулы",
        benefitScienceDesc:
          "Полноценное монопротеиновое питание согласно AAFCO/FEDIAF.",
        benefitSingleProtein: "Строгая философия единственного белка",
        benefitSingleProteinDesc:
          "Без курицы, без субпродуктов; чистый прослеживаемый животный белок.",
        benefitProduction: "Масштабируемое производство для экспорта",
        benefitProductionDesc:
          "Полная загрузка контейнеров с возможностью смешивания артикулов.",
        benefitLongTerm: "Стратегическое долгосрочное партнерство",
        benefitLongTermDesc:
          "Целостность бренда и преданная поддержка дистрибьюторов.",
        officialOversight: "Официальный надзор за экспортом и производством",
        oversightText:
          "Международная торговая деятельность и надзор за OEM-производством GENOYA® управляются нашим экспортным подразделением для обеспечения:",
        oversight1:
          "Соответствия нормативным требованиям на международных рынках",
        oversight2: "Координации экспорта FCL (20DC / 40HC / 45FT)",
        oversight3: "Надзора за производством и контроля качества",
        oversight4: "Целостности бренда и соответствия формул",
        oversight5: "Управления глобальным дистрибьюторским партнерством",
        exportContact: "Департамент экспорта и международной торговли",
        exportEntity: "Официальное экспортное подразделение",
        founder: "Основатель и глобальный управляющий директор",
        registeredAddress: "Юридический адрес",
        inquiryTitle: "Подать заявку на партнерство",
        inquiryDesc:
          "Мы приветствуем запросы от национальных импортеров, региональных дистрибьюторов и стратегических партнеров.",
        finalCtaTitle: "Готовы к партнерству с GENOYA®?",
        finalCtaDesc:
          "Присоединяйтесь к нашей глобальной сети премиальных дистрибьюторов.",
        contactExport: "Связаться с отделом экспорта",
        becomePartner: "Отправить запрос",
        form: {
          companyName: "Название компании / Юридическое лицо",
          country: "Основной рынок / Страна",
          businessType: "Тип бизнеса",
          select: "Выберите тип",
          nationalImporter: "Национальный импортер",
          regionalDistributor: "Региональный дистрибьютор",
          premiumRetail: "Премиальная розничная сеть",
          vetChannel: "Ветеринарный / Профессиональный канал",
          oem: "OEM партнер / Собственная торговая марка",
          volume: "Ориентировочный годовой объем",
          volumePlaceholder: "напр., 10–50 контейнеров / год",
          containerInterest:
            "Предпочтительный размер контейнера (если известно)",
          email: "Рабочая эл. почта",
          phone: "Телефон (с кодом страны)",
          submit: "Отправить заявку на партнерство",
        },
      },
      contact: {
        phone: "Телефон",
  country: "Страна",
  optional: "необязательно",
  selectCountry: "Выберите вашу страну",
  messagePlaceholder: "Чем мы можем вам помочь?",
  sending: "Отправка...",
  sendAnother: "Отправить ещё одно сообщение",
  operatedBy: "Операционная компания",
  searchCountries: "Поиск стран...",
  noResults: "Нет результатов",
        title: "Свяжитесь с GENOYA™",
        generalTitle: "Общие вопросы",
        generalDesc: "Для получения информации о продукции и бренде:",
        partnershipTitle: "Вопросы дистрибуции",
        partnershipDesc:
          "Для делового партнерства и возможностей распространения:",
        formName: "Полное имя",
        formEmail: "Эл. почта",
        formMessage: "Сообщение",
        sendButton: "Отправить сообщение",
        name: "Имя",
        email: "Эл. почта",
        message: "Сообщение",
        send: "Отправить",
        successTitle: "Сообщение успешно отправлено",
        successDesc:
          "Благодарим за обращение. Наша команда свяжется с вами в ближайшее время.",
      },
      nav: {
        home: "Главная",
        about: "О нас",
        products: "Формулы",
        distributors: "Дистрибьюторам",
        contact: "Контакты",
        toggleMenu: "Переключить навигацию",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Все права защищены.",
        tagline: "Научная формула. Чистый протеїн.",
        quickLinks: "Навигация",
        global: "Глобальная деятельность",
        languages: "Выбор языка",
        distributorInfo: "Экспортные спецификации",
        email: "Контактная эл. почта",
        legal: "Соответствие нормам",
        privacy: "Политика конфиденциальности",
        terms: "Условия использования",
      },
      privacy: {
        label: "Правовая информация",
        title: "Политика конфиденциальности",
        lastUpdated: "Последнее обновление: март 2026 г.",
        intro:
          "GENOYA™ стремится защищать вашу персональную информацию. Настоящая Политика конфиденциальности разъясняет, какие данные мы собираем при посещении genoyapetfood.com, как мы их используем и какие права вы имеете в отношении этих данных.",
        informationCollectedTitle: "Собираемая информация",
        info1: "Контактные формы: имя, адрес электронной почты, название компании, страна и содержание сообщения.",
        info2: "Данные об использовании: посещённые страницы, время на сайте, тип браузера и сведения об устройстве, собираемые с помощью аналитических инструментов.",
        info3: "Файлы cookie и аналогичные технологии, используемые для обеспечения производительности сайта и аналитики.",
        howWeUseTitle: "Использование вашей информации",
        use1: "Для ответа на запросы дистрибьюторов и обращения через контактные формы.",
        use2: "Для анализа производительности сайта и улучшения пользовательского опыта.",
        use3: "Для выполнения юридических обязательств.",
        use4: "Мы не продаём, не сдаём в аренду и не передаём вашу персональную информацию третьим лицам.",
        dataRetentionTitle: "Хранение данных",
        dataRetentionText:
          "Мы храним данные контактных форм на протяжении времени, необходимого для ответа на ваш запрос, а также в течение разумного срока для целей документирования.",
        thirdPartyTitle: "Сторонние сервисы",
        thirdPartyText:
          "Наш сайт может использовать сторонние сервисы, такие как аналитические провайдеры. Эти сервисы могут собирать данные в соответствии со своей политикой конфиденциальности.",
        cookiesTitle: "Файлы cookie",
        cookie1: "Мы используем основные файлы cookie, необходимые для корректной работы сайта.",
        cookie2: "Аналитические файлы cookie могут использоваться для понимания того, как посетители взаимодействуют с сайтом. Вы можете отключить файлы cookie в настройках браузера.",
        yourRightsTitle: "Ваши права",
        right1: "Вы имеете право запросить доступ к персональным данным, которые мы о вас храним.",
        right2: "Вы можете в любое время потребовать исправления или удаления своих данных.",
        right3: "Для реализации этих прав свяжитесь с нами по адресу электронной почты, указанному ниже.",
        changesTitle: "Изменения в политике",
        changesText:
          "Мы можем периодически обновлять настоящую Политику конфиденциальности. Актуальная версия всегда будет доступна на этой странице с указанием даты обновления.",
        contactText: "По вопросам конфиденциальности обращайтесь к нам по адресу",
      },
      terms: {
        label: "Правовая информация",
        title: "Условия использования",
        lastUpdated: "Последнее обновление: март 2026 г.",
        intro:
          "Используя сайт GENOYA™ (genoyapetfood.com), вы соглашаетесь соблюдать настоящие Условия использования. Пожалуйста, внимательно ознакомьтесь с ними перед использованием сайта.",
        acceptanceTitle: "Принятие условий",
        acceptanceText:
          "Использование данного сайта означает согласие с настоящими Условиями использования. Если вы не согласны с какой-либо частью этих условий, пожалуйста, не используйте сайт.",
        useOfSiteTitle: "Использование сайта",
        use1: "Вы можете использовать этот сайт только в законных целях и в соответствии с настоящими условиями.",
        use2: "Запрещается использовать сайт любым способом, который может нанести ущерб, вывести его из строя или нарушить работу для других пользователей.",
        use3: "Запрещается пытаться получить несанкционированный доступ к любой части сайта или его системам.",
        use4: "Коммерческое использование содержимого сайта без предварительного письменного разрешения GENOYA™ запрещено.",
        intellectualPropertyTitle: "Интеллектуальная собственность",
        intellectualPropertyText:
          "Весь контент этого сайта — включая тексты, изображения, логотипы, наименования продуктов, формулы и дизайн — является собственностью GENOYA™ и защищён действующим законодательством об интеллектуальной собственности.",
        disclaimerTitle: "Отказ от гарантий",
        disclaimerText:
          "Данный сайт и его содержимое предоставляются «как есть» без каких-либо явных или подразумеваемых гарантий. GENOYA™ не гарантирует бесперебойную, безошибочную или безвредную работу сайта.",
        limitationTitle: "Ограничение ответственности",
        limitationText:
          "В максимальной степени, допустимой законом, GENOYA™ не несёт ответственности за любые косвенные, случайные, специальные или последовательные убытки, возникшие в результате использования или невозможности использования данного сайта.",
        thirdPartyLinksTitle: "Ссылки на сторонние ресурсы",
        thirdPartyLinksText:
          "Данный сайт может содержать ссылки на сторонние сайты. GENOYA™ не контролирует их содержимое и не несёт ответственности за их практики.",
        governingLawTitle: "Применимое право",
        governingLawText:
          "Настоящие Условия использования регулируются и толкуются в соответствии с применимым международным коммерческим правом. Любые споры будут урегулированы путём добросовестных переговоров.",
        changesTitle: "Изменения условий",
        changesText:
          "GENOYA™ оставляет за собой право изменять настоящие Условия использования в любое время. Продолжение использования сайта после публикации изменений означает согласие с обновлёнными условиями.",
        contactText: "По вопросам, связанным с настоящими Условиями использования, обращайтесь к нам по адресу",
      },
    },
  },
  it: {
    translation: {
      ingredientCategories: {
        protein: "Proteina",
        carb: "Carboidrato",
        oil: "Olio e Grasso",
        prebiotic: "Prebiotico",
        probiotic: "Probiotico",
        superfood: "Superfood",
        mineral: "Minerale",
        amino: "Amminoacido",
        botanical: "Botanico",
        premix: "Premiscela Vitamine e Minerali",
        other: "Altro",
        showLess: "− Meno",
        more: "altri",
      },
      ingredients: {
        beef: "Manzo",
        rabbit: "Coniglio",
        duck: "Anatra",
        lamb: "Agnello",
        turkey: "Tacchino",
        whitefish: "Pesce Bianco",
        freshly_prepared_beef: "Manzo Fresco",
        beef_meal: "Farina di Manzo",
        dehydrated_beef_protein: "Proteina di Manzo Disidratata",
        freshly_prepared_rabbit: "Coniglio Fresco",
        rabbit_meal: "Farina di Coniglio",
        dehydrated_rabbit_protein: "Proteina di Coniglio Disidratata",
        freshly_prepared_turkey: "Tacchino Fresco",
        turkey_meal: "Farina di Tacchino",
        dehydrated_turkey_protein: "Proteina di Tacchino Disidratata",
        freshly_prepared_duck: "Anatra Fresca",
        duck_meal: "Farina di Anatra",
        dehydrated_duck_protein: "Proteina di Anatra Disidratata",
        freshly_prepared_whitefish: "Pesce Bianco Fresco",
        whitefish_meal: "Farina di Pesce Bianco",
        dehydrated_whitefish_protein: "Proteina di Pesce Bianco Disidratata",
        freshly_prepared_lamb: "Agnello Fresco",
        lamb_meal: "Farina di Agnello",
        dehydrated_lamb_protein: "Proteina di Agnello Disidratata",
        beef_broth: "Brodo di Manzo",
        lamb_broth: "Brodo di Agnello",
        rabbit_broth: "Brodo di Coniglio",
        turkey_broth: "Brodo di Tacchino",
        whitefish_broth: "Brodo di Pesce Bianco",
        potato_flour: "Farina di Patate",
        tapioca: "Tapioca",
        pumpkin: "Zucca",
        dried_cellulose_fibre: "Fibra di Cellulosa Essiccata",
        salmon_oil: "Olio di Salmone",
        flaxseed: "Semi di Lino",
        dried_brewers_yeast: "Lievito di Birra Essiccato",
        probiotics: "Probiotici",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Spinaci",
        blueberry: "Mirtillo",
        kelp_powder: "Polvere di Kelp",
        chicory_root: "Radice di Cicoria",
        inulin: "Inulina",
        fos: "FOS (Fruttooligosaccaridi)",
        mos: "MOS (Mannanoligosaccaridi)",
        yeast_β_glucans: "β-Glucani di Lievito",
        dicalcium_phosphate: "Fosfato Dicalcico",
        potassium_chloride: "Cloruro di Potassio",
        sodium_phosphate: "Fosfato di Sodio",
        dl_methionine: "DL-Metionina",
        taurine: "Taurina",
        l_carnitine: "L-Carnitina",
        yucca_schidigera_extract: "Estratto di Yucca Schidigera",
        cranberry_extract: "Estratto di Mirtillo Rosso",
        "turmeric_&_ginger_extracts": "Estratti di Curcuma e Zenzero",
        "rosemary_&_green_tea_extracts": "Estratti di Rosmarino e Tè Verde",
        "vitamin_&_mineral_premix": "Premiscela Vitamine e Minerali",
      },
      home: {
        heroTitle1: "Formulato Scientificamente.",
        heroTitle2: "Proteine Pure.",
        heroTitle3: "Salute Funzionale.",
        heroSubtext:
          "Nutrizione premium per animali domestici a base di proteine singole, progettata attraverso sistemi di formulazione strutturati per favorire la chiarezza digestiva, l'equilibrio metabolico e la vitalità a lungo termine.",
        viewProducts: "Esplora le Nostre Formule",
        becomeDistibutor: "Diventa Distributore",
        noChickenTitle:
          "Rigorosamente senza Pollo. Senza Sottoprodotti del Pollo.",
        noChickenSubtitle: "Sempre Monoproteico – La Nostra Promessa Centrale",
        noChickenText:
          "Ogni formula GENOYA utilizza solo una fonte di proteine animali pura e identificata. Niente proteine miste. Niente pollo. Niente sottoprodotti del pollo. Questa filosofia monoproteica offre nutrizione di precisione, migliore digeribilità e una gestione più chiara delle allergie per gli animali domestici in tutto il mondo.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ è un marchio di nutrizione premium per animali domestici formulato scientificamente secondo una rigorosa filosofia monoproteica.",
        introPoint1: "Precisione nutrizionale",
        introPoint2: "Chiarezza digestiva",
        introPoint3: "Ridotta complessità dietetica",
        introPoint4: "Ottimizzazione della salute funzionale",
        introFooter:
          "Progettiamo sistemi nutrizionali strutturati, non prodotti basati sulle tendenze.",
        diffTitle: "Differenziatori Chiave",
        diff1Title: "Architettura a Singola Proteina Animale",
        diff1Desc:
          "Ogni formula è costruita attorno a una singola fonte proteica animale primaria chiaramente definita.",
        diff2Title: "Formulazione Senza Cereali",
        diff2Desc:
          "Struttura bilanciata dei macronutrienti senza riempitivi non necessari.",
        diff3Title: "Politica Senza Pollo",
        diff3Desc:
          "Rigoroso standard di purezza proteica su tutti i prodotti. Senza pollo o sottoprodotti del pollo.",
        diff4Title: "Integrazione Funzionale",
        diff4Desc:
          "Prebiotici, probiotici, composti di supporto articolare ed equilibrio ottimizzato degli omega.",
        scienceTitle: "Basato sulla Ricerca. Strutturato per la Performance.",
        scienceLead: "Le formulazioni GENOYA™ sono progettate utilizzando:",
        sciencePoint1: "Rapporti controllati tra proteine e grassi",
        sciencePoint2: "Profili bilanciati di Omega 3 e 6",
        sciencePoint3: "Sistemi prebiotici FOS e MOS",
        sciencePoint4: "β-glucani per il supporto immunitario",
        sciencePoint5: "Glucosamina e Condroitina per l'integrità articolare",
        sciencePoint6: "Taurina e L-Carnitina secondo il fabbisogno funzionale",
        scienceFooter:
          "Ogni ingrediente serve a uno scopo definito. Ogni percentuale segue una logica di formulazione.",
        previewTitle: "Panoramica delle Formule",
        previewCats: "Gatti",
        previewDogs: "Cani",
        previewKitten: "Gattino",
        previewAdult: "Adulto",
        previewSterilised: "Adulto Sterilizzato",
        previewPuppy: "Cucciolo",
        previewSmallBreed: "Adulto Taglia Piccola",
        previewAllBreeds: "Adulto (Tutte le Razze)",
        distributorHeading: "Opportunità di Distribuzione Globale",
        distributorSubtext:
          "GENOYA™ si sta espandendo attraverso partnership internazionali strutturate. Supportiamo container 20DC, 40HC e 45ft con documentazione pronta per l'esportazione.",
        getStarted: "Diventa Partner di GENOYA™",
      },
      about: {
        heroTitle1: "Nutrizione di Precisione",
        heroTitle2: "Visione Globale",
        heroSubtext:
          "GENOYA™ è un marchio orientato alla scienza che progetta nutrizione premium per animali domestici utilizzando sistemi basati sulla chiarezza monoproteica e sulla performance della salute funzionale.",
        viewProducts: "Visualizza Tutte le Formule",
        missionTitle: "La Nostra Missione",
        missionText:
          "Progettare nutrizione premium per animali domestici attraverso sistemi di formulazione supportati dalla scienza, basati sulla purezza monoproteica e sulla performance funzionale.",
        valuesTitle: "I Nostri Principi",
        value1: "Purezza delle Proteine",
        value1subtext:
          "Architettura a singola proteina animale in tutti i prodotti.",
        value2: "Integrità Nutrizionale",
        value2subtext:
          "Formule strutturate in linea con i quadri nutrizionali riconosciuti.",
        value3: "Focus sulla Salute Funzionale",
        value3subtext:
          "Supporto digestivo, integrità articolare, equilibrio immunitario e ottimizzazione metabolica.",
        value4: "Niente Pollo. Niente Sottoprodotti del Pollo.",
        value4subtext: "Uno standard di marca GENOYA™ non negoziabile.",
        viewOurProducts: "Esplora i Prodotti",
        leadershipTitle: "Expertise & Posizionamento",
        leadershipHeadText:
          " è stata creata da professionisti con esperienza in:",
        leadershipValue1:
          "Commercio internazionale di alimenti per animali domestici",
        leadershipValue2: "Supervisione della produzione OEM",
        leadershipValue3: "Sviluppo dell'architettura del marchio",
        leadershipValue4: "Scalabilità della distribuzione",
        leadershipValue5: "Sistemi di etichettatura conformi alle normative",
        leadershipTextBelow:
          "opera attraverso strutture di produzione strutturate in Cina nell'ambito di sistemi di formulazione controllati e supervisione della qualità progettati per la distribuzione internazionale.",
        leadershipTextFinal:
          "Costruiamo marchi strutturati progettati per una crescita globale a lungo termine.",
        noChickenTitle:
          "Rigorosamente senza Pollo. Senza Sottoprodotti del Pollo.",
        noChickenSubtitle:
          "Sempre Monoproteico – Il Nostro Impegno Fondamentale",
        noChickenText:
          "GENOYA® non utilizza mai pollo o sottoprodotti del pollo in nessuna formula. Ci basiamo su una rigorosa filosofia monoproteica: una fonte animale pura e identificata per prodotto. Ciò garantisce una migliore digeribilità, una gestione più chiara delle allergie e una trasparenza ineguagliabile per i proprietari di animali domestici in tutto il mondo.",
        complianceTitle: "Dichiarazione di Conformità Nutrizionale",
        complianceText:
          "Formulato per soddisfare i livelli nutrizionali stabiliti dagli standard internazionali riconosciuti per gli alimenti per animali domestici, inclusi i profili nutrizionali AAFCO e le linee guida FEDIAF per la rispettiva fase di vita.",
        complianceBold:
          "I nostri prodotti sono completi e bilanciati per tutte le fasi della vita.",
      },
      products: {
        heroTitle: "Formule Monoproteiche Avanzate",
        heroSubtext:
          "Nutrizione di precisione con fonti proteiche animali singole, adattata per specie, fase di vita e obiettivi di salute funzionale.",
        selectSpecies: "Seleziona la Specie del tuo Animale",
        backToSpecies: "Torna alla Selezione della Specie",
        noProductsAvailable: "Nessun prodotto trovato per questa categoria.",
        filter: "Filtra",
        clearFilters: "Cancella Filtri",
        resetFilters: "Reset Tutto",
        format: "Formato Prodotto",
        allFormats: "Tutti i Formati",
        formats: {
          dry: "Cibo Secco",
          wet: "Cibo Umido",
        },
        dryKibble: "Crocchette Secche",
        wetFood: "Cibo Umido / Paté",
        ingredient: "Proteina Primaria",
        allIngredients: "Tutte le Proteine",
        lifeStage: "Fase di Vita",
        allStages: "Tutte le Fasi",
        healthGoal: "Obiettivo Funzionale",
        allGoals: "Tutti gli Obiettivi",
        healthBenefits: "Benefici per la Salute",
        noResults: "Nessuna formula trovata che soddisfi i tuoi criteri.",
        details: "Dettagli Formula",
        showLess: "Mostra Meno",
        collapseAll: "Comprimi Tutto",
        size: "Contenuto Netto",
        ingredients: "Ingredienti",
        fullIngredients: "Composizione Completa",
        standard: "Standard di Produzione",
        packaging: "Tipo di Confezione",
        aboutProduct: "CARATTERISTICHE",
        ingredientsLabel: "INGREDIENTI (COMPOSIZIONE)",
        analysisLabel: "ANALISI GARANTITA (dove disponibile)",
        nutritionalAdditives: {
          sectionHeader: "Nutritional Additives (per kg)",
          vitamins: "Vitamins",
          traceElements: "Trace Elements",
          functionalAdditives: "Functional Additives",
          prebioticProbioticComplex: "Pre- & Probiotic Complex",
          botanicalExtracts: "Botanical Extracts",

          // Vitamins
          vitaminA: "Vitamin A",
          vitaminD3: "Vitamin D₃",
          vitaminE: "Vitamin E",
          vitaminC: "Vitamin C",
          vitaminB1: "Vitamin B₁",
          vitaminB2: "Vitamin B₂",
          vitaminB6: "Vitamin B₆",
          vitaminB12: "Vitamin B₁₂",
          niacin: "Niacin",
          pantothenicAcid: "Pantothenic Acid",
          folicAcid: "Folic Acid",
          biotin: "Biotin",
          cholineChloride: "Choline Chloride",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Methionine",

          // Trace Elements
          iron: "Iron",
          ferrousSulphate: "Ferrous Sulphate",
          zinc: "Zinc",
          zincSulphate: "Zinc Sulphate",
          manganese: "Manganese",
          manganeseSulphate: "Manganese Sulphate",
          copper: "Copper",
          copperSulphate: "Copper Sulphate",
          iodine: "Iodine",
          calciumIodate: "Calcium Iodate",
          selenium: "Selenium",
          sodiumSelenite: "Sodium Selenite",

          // Functional Additives
          glucosamine: "Glucosamine",
          chondroitinSulphate: "Chondroitin Sulphate",
          yuccaSchidigeraExtract: "Yucca Schidigera Extract",
          cranberryExtract: "Cranberry Extract",

          // Pre- & Probiotic Complex
          inulinFOS: "Inulin (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucans",
          probiotics: "Probiotics",
          cfu: "CFU",

          // Botanical Extracts
          rosemary: "Rosemary",
          greenTea: "Green Tea",
          turmeric: "Turmeric",
          ginger: "Ginger",
          kelp: "Kelp",
          blueberry: "Blueberry",

          // Units / labels
          iu: "IU",
          mg: "mg",
          perKg: "per kg",
          asLabel: "as",
        },
        categories: {
          cat: "Nutrizione Felina",
          cats: "Nutrizione Felina",
          dog: "Nutrizione Canina",
          dogs: "Nutrizione Canina",
        },
        stages: {
          adult: "Adulto",
          adult_small_breed: "Adulto Piccola Razza",
          sterilised: "Sterilizzato",
          dog: {
            junior: "Cucciolo",
          },
          cat: {
            junior: "Gattino",
          },
        },
        sizeCategory: "Taglia / Razza",
        allSizes: "Tutte le Taglie",
        sizes: {
          allBreeds: "Tutte le Razze",
          smallBreed: "Taglia Piccola",
          "all-breeds": "Tutte le Razze",
          "small-breed": "Taglia Piccola",
          mediumBreed: "Taglia Media",
          largeBreed: "Taglia Grande",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Salute Digestiva",
          skin: "Nutrizione di Pelle e Mantello",
          immune: "Supporto del Sistema Immunitario",
          antioxidant: "Difesa Antiossidante",
          muscle: "Mantenimento Muscolare",
          joint: "Supporto Articolare",
          weight: "Controllo del Peso",
          urinary: "Salute del Tratto Urinario",
          brain: "Salute Cerebrale e Cognitiva",
          bone: "Sviluppo Osseo e Articolare",
        },
        goals: {
          digestion: "Salute Digestiva",
          skin: "Nutrizione di Pelle e Mantello",
          weight: "Controllo del Peso",
          urinary: "Salute Urinaria",
          immune: "Supporto Immunitario",
          antioxidant: "Protezione Antiossidante",
          muscle: "Mantenimento Muscolare",
          joint: "Supporto Articolare",
        },
        flavors: {
          beef: "Manzo",
          duck: "Anatra",
          lamb: "Agnello",
          rabbit: "Coniglio",
          turkey: "Tacchino",
          whitefish: "Pesce Bianco",
        },
        textures: {
          kibble: "Crocchetta Secca",
          "chunks in jelly": "Bocconcini in Gelatina",
        },
        linekey: {
          dailyCare: "Cura Quotidiana",
          superfoodPlus: "Supercibo+",
        },
        animals: {
          dog: "Cane",
          cat: "Gatto",
        },
        description:
          "Una ricetta premium monoproteica al {{flavor}} in formato {{texture}}, progettata per {{animal}} nella fase di vita {{stage}}.",
        types: {
          dry: "Secco",
          wet: "Umido",
        },
        singleProtein: "monoproteico",
        grainFree: "senza cereali",
        premiumCompleteFood: "Alimento completo e bilanciato premium",
        frontView: "Vista Frontale",
        backView: "Vista Posteriore",
        feedingGuideNotAvailable:
          "Guida all'alimentazione non disponibile per questo prodotto.",
        technicalSpecs: "Specifiche Tecniche",
        keyBenefits: "Principali Benefici Funzionali",
        analyticalConstituents: "Costituenti Analitici",
        feedingGuide: "Guida all'Alimentazione",
        functionalIngredients: "Ingredienti Funzionali e Additivi",
        petWeight: "Peso dell'Animale",
        gramsPerDay: "Grammi al Giorno",
        viewBack: "Vedi Etichetta Posteriore",
        viewFront: "Vedi Etichetta Frontale",
        clickToZoom: "Clicca sull'immagine per ingrandire",
        analysis: {
          protein: "Proteina Grezza",
          fat: "Grassi Grezzi",
          fiber: "Fibra Grezza",
          ash: "Ceneri Grezze",
          omega3: "Omega-3",
          omega6: "Omega-6",
        },
        netContentLabel: "Contenuto Netto",
        packagingTypeLabel: "Confezione",
        standardLabel: "Standard",
        pillarNoChicken:
          "Rigorosamente senza Pollo. Senza Sottoprodotti del Pollo. Sempre Monoproteico.",
        noChickenTitle: "La Nostra Promessa Centrale",
        noChickenText:
          "GENOYA® non utilizza mai pollo o sottoprodotti del pollo. Ogni formula è costruita su una fonte pura di proteine animali: completa e bilanciata per la fase di vita.",
        filterReinforce:
          "Tutte le formule sono Complete e Bilanciate – Rigorosamente Senza Pollo / Sempre Monoproteico",
        complianceTitle: "Conformità Nutrizionale",
        complianceText:
          "Formulato per soddisfare i livelli nutrizionali stabiliti dagli standard internazionali, inclusi i profili AAFCO e le linee guida FEDIAF per la rispettiva fase di vita.",
        completeBalanced: "Completo e Bilanciato",
        nutritionalAdequacyTitle: "Dichiarazione di Adeguatezza Nutrizionale",
        nutritionalAdequacyText:
          "Formulato in linea con le linee guida dei profili nutrizionali AAFCO e FEDIAF per la fase di vita prevista. L'adeguatezza nutrizionale si basa sull'analisi della formulazione.",
        regulatoryDisclaimer:
          "AAFCO e FEDIAF sono organizzazioni di linee guida normative. I prodotti GENOYA™ non sono approvati o certificati da queste organizzazioni.",
        tabs: {
          ingredients: "Ingredienti",
          feeding: "Guida all'alimentazione",
          nutrition: "Valori Nutrizionali",
          aminoAcids: "Aminoacidi",
        },
        analytical: {
          guaranteedAnalysis: "Analisi Garantita",
          analyticalValues: "Valori Analitici",
          metabolisable_energy: "Energia Metabolizzabile",
          digestibility: "Digeribilità",
          estimated: "Stimato",
          crude_protein_min: "Proteina Grezza (min)",
          crude_fat_min: "Grassi Grezzi (min)",
          crude_fibre_max: "Fibra Grezza (max)",
          crude_ash_max: "Ceneri Grezze (max)",
          moisture_max: "Umidità (max)",
          taurine: "Taurina",
          omega3: "Omega-3",
          omega6: "Omega-6",
          calcium_min: "Calcio (min)",
          calcium_max: "Calcio (max)",
          phosphorus_min: "Fosforo (min)",
          phosphorus_max: "Fosforo (max)",
          l_carnitine: "L-Carnitina",
          metabolisable_energy_kcal: "Energia metabolizzabile (kcal/kg)",
          metabolisable_energy_mj: "Energia metabolizzabile (MJ/kg)",
          omega3_fatty_acids: "Omega-3",
          omega6_fatty_acids: "Omega-6",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Glucosamina",
          chondroitin_sulphate: "Solfato di Condroitina",
          dl_methionine_ga: "DL-Metionina",
          sodium: "Sodio",
          magnesium: "Magnesio",
          potassium: "Potassio",
          ca_p_ratio: "Rapporto Calcio : Fosforo",
        },
        fullIngredientList: "Elenco completo degli ingredienti",
        functionalHighlights: "Caratteristiche Funzionali",
        storageShelfLife: "Conservazione e Durata",
        storageText:
          "DURATA DI CONSERVAZIONE: 18 mesi dalla data di produzione.\nCONSERVAZIONE & SICUREZZA\nConservare in un luogo fresco e asciutto.\nRichiudere dopo l'apertura.\nNon congelare.",
        storageTextWet:
          "DURATA DI CONSERVAZIONE: 3 anni (non aperto dalla data di produzione).\nCONSERVAZIONE & SICUREZZA\nConservare in un luogo fresco e asciutto, lontano dalla luce solare diretta.\nRefrigerare dopo l'apertura e consumare entro 5 giorni.\nNon congelare.",
        functionalIngredientsText:
          "INGREDIENTI FUNZIONALI\n- Inulina (FOS): Supporta l'equilibrio del microbioma\n- MOS: Aiuta a bloccare i batteri intestinali dannosi\n- β-Glucani: Supporta la funzione immunitaria\nOlio di salmone: EPA e DHA supportano lo sviluppo cerebrale e visivo\nDL-Metionina: Supporta la salute urinaria\nTaurina: Essenziale per la crescita felina, il cuore e il supporto visivo",
        complianceTemplates: {
          kitten_cat:
            "{{name}} è formulato per soddisfare i livelli nutrizionali stabiliti dai Profili Nutrizionali per Alimenti per Gatti dell'AAFCO per la Crescita e Riproduzione, e rispetta le linee guida nutrizionali FEDIAF per alimenti completi ed equilibrati per gattini.",
          adult_cat:
            "{{name}} è formulato per soddisfare i livelli nutrizionali stabiliti dai Profili Nutrizionali per Alimenti per Gatti dell'AAFCO per il Mantenimento degli Adulti e rispetta le linee guida nutrizionali FEDIAF per alimenti completi ed equilibrati per gatti adulti.",
          sterilised_cat:
            "{{name}} è formulato per soddisfare i livelli nutrizionali stabiliti dai Profili Nutrizionali per Alimenti per Gatti dell'AAFCO per il Mantenimento degli Adulti e rispetta le linee guida nutrizionali FEDIAF per alimenti completi ed equilibrati per gatti adulti sterilizzati.",
          smallbreed_puppy:
            "{{name}} è formulato per soddisfare i livelli nutrizionali stabiliti dai Profili Nutrizionali per Alimenti per Cani dell'AAFCO per la Crescita e rispetta le linee guida nutrizionali FEDIAF per alimenti completi ed equilibrati per cuccioli di taglia piccola.",
          medlarge_puppy:
            "{{name}} è formulato per soddisfare i livelli nutrizionali stabiliti dai Profili Nutrizionali per Alimenti per Cani dell'AAFCO per la Crescita e rispetta le linee guida nutrizionali FEDIAF per alimenti completi ed equilibrati per cuccioli di taglia media e grande.",
          adult_small_dog:
            "{{name}} è una dieta funzionale senza cereali a proteina animale unica formulata per soddisfare le esigenze nutrizionali dei cani adulti di taglia piccola. Realizzato esclusivamente con {{protein}} come unica fonte di proteina animale, supporta il mantenimento muscolare, pelle e pelo sani, salute digestiva, funzione immunitaria e vitalità generale nei cani di taglia piccola. Privo di pollame, cereali, soia e conservanti artificiali. Alimento completo ed equilibrato per cani adulti di taglia piccola.",
          adult_allbreed_dog:
            "{{name}} è una dieta funzionale senza cereali a proteina animale unica formulata per soddisfare le esigenze nutrizionali dei cani adulti di tutte le razze. Realizzato esclusivamente con {{protein}} come unica fonte di proteina animale, supporta il mantenimento muscolare, pelle e pelo sani, salute digestiva, funzione immunitaria e vitalità generale. Privo di pollame, cereali, soia e conservanti artificiali. Alimento completo ed equilibrato per cani adulti.",
        },
        complianceStatement: "Dichiarazione di Conformità",
        nutritionalAdditivesPerKg: "Additivi Nutrizionali (per kg)",
        vitamins: "Vitamine",
        traceElements: "Oligoelementi",
        functionalAdditives: "Additivi Funzionali",
        prebioticProbioticComplex: "Complesso Pre- e Probiotico",
        botanicalExtracts: "Estratti Botanici",
        aminoAcids: {
          lysine: "Lisina",
          methionine: "Metionina",
          threonine: "Treonina",
          tryptophan: "Triptofano",
          leucine: "Leucina",
          isoleucine: "Isoleucina",
          valine: "Valina",
          histidine: "Istidina",
          phenylalanine: "Fenilalanina",
          arginine: "Arginina",
        },
        aminoAcidProfile: "Profilo degli Aminoacidi Essenziali",
        aminoNote:
          "† Valori approssimativi. La taurina viene aggiunta come additivo nutrizionale al livello minimo dichiarato.",
        feeding: {
          day: "giorno",
          can: "lattina",
          cans: "lattine",
          dryNote:
            "Le quantità sono indicazioni giornaliere. Dividere in 2–3 pasti. Fornire sempre acqua fresca.",
          kitten__2_4months: "Gattino (2–4 mesi)",
          kitten__4_6months: "Gattino (4–6 mesi)",
          junior_7_12months: "Junior (7–12 mesi)",
          puppy___2_4_months: "Cucciolo (2–4 mesi)",
          puppy___4_9_months: "Cucciolo (4–9 mesi)",
          junior__7_9_months: "Junior (7–9 mesi)",
          junior__9_12_months: "Junior (9–12 mesi)",
          junior___9_12_months: "Junior (9–12 mesi)",
          junior___12_15_months: "Junior (12–15 mesi)",
          junior__15_20_months: "Junior (15–20 mesi)",
          adult_cat__1_3_yrs: "Gatto adulto (1–3 anni)",
          adult_cat__3_7_yrs: "Gatto adulto (3–7 anni)",
          adult_cat__7__yrs: "Gatto adulto (7+ anni)",
          adult_dog__1_3_yrs: "Cane adulto (1–3 anni)",
          adult_dog___3_7_yrs: "Cane adulto (3–7 anni)",
          adult_dog__7__yrs: "Cane adulto (7+ anni)",
          "1_3_yrs": "1–3 anni",
          "3_7_yrs": "3–7 anni",
          "7__yrs": "7+ anni",
          stage_label: "Fase della vita",
        },
      },
      distributors: {
        emailLabel: "E-mail",
        websiteLabel: "Sito web",
        heroTitle: "Partnership di Distribuzione Internazionale",
        heroSubtext:
          "GENOYA® è un marchio globale premium e strutturato focalizzato esclusivamente su partnership di distribuzione e OEM a lungo termine.",
        contactUs: "Contatta il Team Export",
        exportTitle: "Capacità Globale di Esportazione e Carico Container",
        fcl: "Disponibile Carico Container Completo (FCL)",
        fclDesc:
          "Supporto per container 20DC / 40HC / 45FT con coordinamento delle spedizioni in tutto il mondo.",
        mixedSku: "Carico SKU Misti",
        mixedSkuDesc:
          "Configurazioni flessibili dei pallet per più varianti di prodotto.",
        compliance: "Garanzia di Qualità e Normativa",
        complianceDesc:
          "Supervisione totale per garantire la conformità nei mercati di destinazione.",
        palletStandards: "Standard di Pallet Supportati",
        eurPallets: "Pallet EUR / EPAL (1200 × 800 mm)",
        ukPallets: "Pallet Standard UK (1200 × 1000 mm)",
        usPallets: "Pallet US GMA (48” × 40”)",
        whyPartnerTitle: "Perché collaborare con GENOYA®",
        benefitScience: "Formulazioni Orientate alla Scienza",
        benefitScienceDesc:
          "Nutrizione monoproteica completa e bilanciata conforme a AAFCO/FEDIAF.",
        benefitSingleProtein: "Rigorosa Filosofia Monoproteica",
        benefitSingleProteinDesc:
          "Niente pollo, niente sottoprodotti; proteine animali pure e tracciabili.",
        benefitProduction: "Produzione Scalabile Pronta per l'Esportazione",
        benefitProductionDesc:
          "Carichi di container completi con flessibilità di SKU misti.",
        benefitLongTerm: "Partnership Strategica a Lungo Termine",
        benefitLongTermDesc:
          "Integrità del marchio e supporto dedicato ai distributori.",
        officialOversight: "Supervisione Ufficiale Esportazione e Produzione",
        oversightText:
          "Le operazioni commerciali internazionali di GENOYA® e la supervisione della produzione OEM sono gestite tramite la nostra entità di esportazione designata per garantire:",
        oversight1: "Conformità normativa nei mercati internazionali",
        oversight2: "Coordinamento esportazione FCL (20DC / 40HC / 45FT)",
        oversight3: "Supervisione della produzione e garanzia di qualità",
        oversight4: "Integrità del marchio e conformità della formulazione",
        oversight5: "Gestione della partnership con i distributori globali",
        exportContact: "Dipartimento Esportazione e Commercio Internazionale",
        exportEntity: "Entità Ufficiale di Esportazione",
        founder: "Fondatore e Direttore Generale Globale",
        registeredAddress: "Sede Legale",
        inquiryTitle: "Invia la tua Richiesta di Partnership",
        inquiryDesc:
          "Accogliamo con favore richieste serie da parte di importatori nazionali, distributori regionali e partner strategici.",
        finalCtaTitle: "Pronto a collaborare con GENOYA®?",
        finalCtaDesc:
          "Unisciti alla nostra rete globale di partner di distribuzione premium.",
        contactExport: "Contatta il Team Export",
        becomePartner: "Richiedi Ora",
        form: {
          companyName: "Ragione Sociale / Entità Legale",
          country: "Mercato Principale / Paese",
          businessType: "Tipo di Business",
          select: "Seleziona tipo",
          nationalImporter: "Importatore Nazionale",
          regionalDistributor: "Distributore Regionale",
          premiumRetail: "Catena Retail Premium",
          vetChannel: "Canale Veterinario / Professionale",
          oem: "Partner OEM / Private Label",
          volume: "Volume Annuo Stimato",
          volumePlaceholder: "es. 10–50 container / anno",
          containerInterest: "Dimensione Container Preferita (se nota)",
          email: "E-mail Aziendale",
          phone: "Telefono (con prefisso internazionale)",
          submit: "Invia Richiesta di Partnership",
        },
      },
      contact: {
        phone: "Telefono",
  country: "Paese",
  optional: "opzionale",
  selectCountry: "Seleziona il tuo paese",
  messagePlaceholder: "Come possiamo aiutarti?",
  sending: "Invio in corso...",
  sendAnother: "Invia un altro messaggio",
  operatedBy: "Gestito da",
  searchCountries: "Cerca paesi...",
  noResults: "Nessun risultato",
        title: "Connettiti con GENOYA™",
        generalTitle: "Informazioni Generali",
        generalDesc:
          "Per informazioni sui prodotti e domande relative al marchio:",
        partnershipTitle: "Informazioni per Distributori",
        partnershipDesc:
          "Per partnership commerciali e opportunità di distribuzione:",
        formName: "Nome Completo",
        formEmail: "Indirizzo E-mail",
        formMessage: "Messaggio",
        sendButton: "Invia Messaggio",
        name: "Nome",
        email: "Indirizzo E-mail",
        message: "Messaggio",
        send: "Invia",
        successTitle: "Messaggio inviato con successo",
        successDesc:
          "Grazie per averci contattato. Il nostro team ti risponderà al più presto.",
      },
      nav: {
        home: "Casa",
        about: "Chi Siamo",
        products: "Formule",
        distributors: "Distributori",
        contact: "Contatti",
        toggleMenu: "Attiva/disattiva navigazione",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Tutti i diritti riservati.",
        tagline: "Formulato Scientificamente. Proteine Pure.",
        quickLinks: "Navigazione",
        global: "Operazioni Globali",
        languages: "Selezione Lingua",
        distributorInfo: "Specifiche Export",
        email: "E-mail di Contatto",
        legal: "Conformità",
        privacy: "Privacy Policy",
        terms: "Termini di Servizio",
      },
      privacy: {
        label: "Legale",
        title: "Informativa sulla Privacy",
        lastUpdated: "Ultimo aggiornamento: marzo 2026",
        intro:
          "GENOYA™ è impegnata a proteggere le tue informazioni personali. Questa Informativa sulla Privacy spiega quali dati raccogliamo quando visiti genoyapetfood.com, come li utilizziamo e i tuoi diritti in merito a tali dati.",
        informationCollectedTitle: "Informazioni raccolte",
        info1: "Moduli di contatto: nome, indirizzo e-mail, nome dell'azienda, paese e contenuto del messaggio.",
        info2: "Dati di utilizzo: pagine visitate, tempo trascorso sul sito, tipo di browser e informazioni sul dispositivo raccolte tramite strumenti di analisi.",
        info3: "Cookie e tecnologie simili utilizzati per le prestazioni del sito e l'analisi.",
        howWeUseTitle: "Come utilizziamo le tue informazioni",
        use1: "Per rispondere alle richieste dei distributori e ai moduli di contatto.",
        use2: "Per analizzare le prestazioni del sito web e migliorare l'esperienza utente.",
        use3: "Per adempiere agli obblighi legali.",
        use4: "Non vendiamo, affittiamo né cediamo le tue informazioni personali a terzi.",
        dataRetentionTitle: "Conservazione dei dati",
        dataRetentionText:
          "Conserviamo i dati dei moduli di contatto per il tempo necessario a rispondere alla tua richiesta e per un periodo ragionevole successivo a fini di archiviazione.",
        thirdPartyTitle: "Servizi di terze parti",
        thirdPartyText:
          "Il nostro sito web può utilizzare servizi di terze parti come fornitori di analisi. Questi servizi possono raccogliere dati in base alle proprie informative sulla privacy.",
        cookiesTitle: "Cookie",
        cookie1: "Utilizziamo cookie essenziali necessari per il corretto funzionamento del sito.",
        cookie2: "Possono essere utilizzati cookie analitici per comprendere come i visitatori interagiscono con il sito. Puoi disattivare i cookie nelle impostazioni del browser.",
        yourRightsTitle: "I tuoi diritti",
        right1: "Hai il diritto di richiedere l'accesso ai dati personali che conserviamo su di te.",
        right2: "Puoi richiedere la correzione o la cancellazione dei tuoi dati in qualsiasi momento.",
        right3: "Per esercitare questi diritti, contattaci all'indirizzo e-mail indicato di seguito.",
        changesTitle: "Modifiche a questa informativa",
        changesText:
          "Potremmo aggiornare periodicamente questa Informativa sulla Privacy. La versione più aggiornata sarà sempre disponibile in questa pagina con la data di aggiornamento.",
        contactText: "Per domande o richieste relative alla privacy, contattaci a",
      },
      terms: {
        label: "Legale",
        title: "Termini di Servizio",
        lastUpdated: "Ultimo aggiornamento: marzo 2026",
        intro:
          "Accedendo e utilizzando il sito web di GENOYA™ (genoyapetfood.com), accetti di essere vincolato dai presenti Termini di Servizio. Ti preghiamo di leggerli attentamente prima di utilizzare il sito.",
        acceptanceTitle: "Accettazione dei termini",
        acceptanceText:
          "L'utilizzo di questo sito web costituisce accettazione dei presenti Termini di Servizio. Se non sei d'accordo con qualsiasi parte di questi termini, ti preghiamo di non utilizzare il sito.",
        useOfSiteTitle: "Utilizzo del sito web",
        use1: "Puoi utilizzare questo sito solo per scopi leciti e in conformità con questi termini.",
        use2: "Non devi utilizzare il sito in alcun modo che possa danneggiarlo, disabilitarlo o recare danno ad altri utenti.",
        use3: "Non devi tentare di ottenere accesso non autorizzato a qualsiasi parte del sito o ai suoi sistemi correlati.",
        use4: "L'uso commerciale dei contenuti del sito senza previa autorizzazione scritta di GENOYA™ è vietato.",
        intellectualPropertyTitle: "Proprietà intellettuale",
        intellectualPropertyText:
          "Tutti i contenuti di questo sito web — inclusi testi, immagini, loghi, nomi di prodotti, formule e design — sono di proprietà di GENOYA™ e sono protetti dalle leggi applicabili sulla proprietà intellettuale.",
        disclaimerTitle: "Esclusione di garanzie",
        disclaimerText:
          "Questo sito web e i suoi contenuti sono forniti \"così come sono\", senza garanzie di alcun tipo, espresse o implicite. GENOYA™ non garantisce che il sito sarà privo di interruzioni, errori o componenti dannosi.",
        limitationTitle: "Limitazione di responsabilità",
        limitationText:
          "Nella misura massima consentita dalla legge, GENOYA™ non sarà responsabile per danni indiretti, accidentali, speciali o consequenziali derivanti dall'utilizzo o dall'impossibilità di utilizzo di questo sito.",
        thirdPartyLinksTitle: "Link a terze parti",
        thirdPartyLinksText:
          "Questo sito web può contenere link a siti web di terze parti. GENOYA™ non ha alcun controllo sul contenuto o sulle pratiche di tali siti e non si assume alcuna responsabilità al riguardo.",
        governingLawTitle: "Legge applicabile",
        governingLawText:
          "I presenti Termini di Servizio sono regolati e interpretati in conformità con il diritto commerciale internazionale applicabile. Qualsiasi controversia sarà risolta mediante negoziazione in buona fede tra le parti.",
        changesTitle: "Modifiche ai termini",
        changesText:
          "GENOYA™ si riserva il diritto di modificare i presenti Termini di Servizio in qualsiasi momento. L'utilizzo continuato del sito web dopo la pubblicazione delle modifiche costituisce accettazione dei termini aggiornati.",
        contactText: "Per domande riguardanti questi Termini di Servizio, contattaci a",
      },
    },
  },
  uk: {
    translation: {
      ingredientCategories: {
        protein: "Білок",
        carb: "Вуглевод",
        oil: "Олія та Жир",
        prebiotic: "Пребіотик",
        probiotic: "Пробіотик",
        superfood: "Суперфуд",
        mineral: "Мінерал",
        amino: "Амінокислота",
        botanical: "Рослинний екстракт",
        premix: "Вітамінно-Мінеральний Премікс",
        other: "Інше",
        showLess: "− Менше",
        more: "ще",
      },
      ingredients: {
        beef: "Яловичина",
        rabbit: "Кролик",
        duck: "Качка",
        lamb: "Ягня",
        turkey: "Індичка",
        whitefish: "Біла Риба",
        freshly_prepared_beef: "Свіжоприготована Яловичина",
        beef_meal: "Борошно з Яловичини",
        dehydrated_beef_protein: "Дегідратований Протеїн Яловичини",
        freshly_prepared_rabbit: "Свіжоприготований Кролик",
        rabbit_meal: "Борошно з Кролика",
        dehydrated_rabbit_protein: "Дегідратований Протеїн Кролика",
        freshly_prepared_turkey: "Свіжоприготована Індичка",
        turkey_meal: "Борошно з Індички",
        dehydrated_turkey_protein: "Дегідратований Протеїн Індички",
        freshly_prepared_duck: "Свіжоприготована Качка",
        duck_meal: "Борошно з Качки",
        dehydrated_duck_protein: "Дегідратований Протеїн Качки",
        freshly_prepared_whitefish: "Свіжоприготована Біла Риба",
        whitefish_meal: "Борошно з Білої Риби",
        dehydrated_whitefish_protein: "Дегідратований Протеїн Білої Риби",
        freshly_prepared_lamb: "Свіжоприготоване Ягня",
        lamb_meal: "Борошно з Ягняти",
        dehydrated_lamb_protein: "Дегідратований Протеїн Ягняти",
        beef_broth: "Яловичий Бульйон",
        lamb_broth: "Бульйон з Ягняти",
        rabbit_broth: "Бульйон з Кролика",
        turkey_broth: "Бульйон з Індички",
        whitefish_broth: "Бульйон з Білої Риби",
        potato_flour: "Картопляне Борошно",
        tapioca: "Тапіока",
        pumpkin: "Гарбуз",
        dried_cellulose_fibre: "Суха Целюлозна Клітковина",
        salmon_oil: "Олія Лосося",
        flaxseed: "Насіння Льону",
        dried_brewers_yeast: "Сухі Пивні Дріжджі",
        probiotics: "Пробіотики",
        "bacillus/lactobacillus": "Bacillus / Lactobacillus",
        spinach: "Шпинат",
        blueberry: "Чорниця",
        kelp_powder: "Порошок Ламінарії",
        chicory_root: "Корінь Цикорію",
        inulin: "Інулін",
        fos: "ФОС (Фруктоолігосахариди)",
        mos: "МОС (Манноолігосахариди)",
        yeast_β_glucans: "β-Глюкани Дріжджів",
        dicalcium_phosphate: "Дикальційфосфат",
        potassium_chloride: "Хлорид Калію",
        sodium_phosphate: "Фосфат Натрію",
        dl_methionine: "DL-Метіонін",
        taurine: "Таурин",
        l_carnitine: "L-Карнітин",
        yucca_schidigera_extract: "Екстракт Юки Шидигера",
        cranberry_extract: "Екстракт Журавлини",
        "turmeric_&_ginger_extracts": "Екстракти Куркуми та Імбиру",
        "rosemary_&_green_tea_extracts": "Екстракти Розмарину та Зеленого Чаю",
        "vitamin_&_mineral_premix": "Вітамінно-Мінеральний Премікс",
      },
      home: {
        heroTitle1: "Наукова формула.",
        heroTitle2: "Чистий протеїн.",
        heroTitle3: "Функціональне здоров'я.",
        heroSubtext:
          "Преміальне харчування для домашніх тварин на основі монопротеїну, розроблене за допомогою структурованих систем формуляції для підтримки травлення, метаболічного балансу та довготривалої життєвої енергії.",
        viewProducts: "Ознайомитися з формулами",
        becomeDistibutor: "Стати дистриб'ютором",
        noChickenTitle:
          "Суворо без курки. Без субпродуктів курячого походження.",
        noChickenSubtitle: "Завжди монопротеїн – наша головна обіцянка",
        noChickenText:
          "Кожна формула GENOYA використовує лише одне чисте та чітко визначене джерело тваринного білка. Жодних змішаних протеїнів. Жодної курки. Жодних курячих субпродуктів. Ця філософія єдиного білка забезпечує точне харчування, кращу засвоюваність і чіткий контроль алергій для тварин по всьому світу.",
        introTitle: "GENOYA™",
        introLead:
          "GENOYA™ — це бренд преміального харчування для тварин, науково сформульований на основі суворої філософії монопротеїну.",
        introPoint1: "Точність нутрієнтів",
        introPoint2: "Прозорість травлення",
        introPoint3: "Зменшена дієтична складність",
        introPoint4: "Оптимізація функціонального здоров'я",
        introFooter:
          "Ми розробляємо структуровані системи харчування, а не продукти, засновані на трендах.",
        diffTitle: "Ключові відмінності",
        diff1Title: "Архітектура єдиного тваринного білка",
        diff1Desc:
          "Кожна формула побудована навколо одного чітко визначеного первинного джерела тваринного білка.",
        diff2Title: "Беззернова формула",
        diff2Desc:
          "Збалансована структура макронутрієнтів без непотрібних наповнювачів.",
        diff3Title: "Політика «Без курки»",
        diff3Desc:
          "Суворий стандарт чистоти протеїну в усіх продуктах. Без курки та курячих субпродуктів.",
        diff4Title: "Функціональна інтеграція",
        diff4Desc:
          "Пребіотики, пробіотики, комплекси для підтримки суглобів та оптимізований баланс Омега.",
        scienceTitle: "На основі досліджень. Створено для результату.",
        scienceLead: "Формули GENOYA™ розроблені з використанням:",
        sciencePoint1: "Контрольованого співвідношення білків та жирів",
        sciencePoint2: "Збалансованих профілів Омега 3 та 6",
        sciencePoint3: "Пребіотичних систем FOS та MOS",
        sciencePoint4: "β-глюканів для підтримки імунітету",
        sciencePoint5: "Глюкозаміну та хондроїтину для здоров'я суглобів",
        sciencePoint6: "Таурину та L-карнітину за функціональної потреби",
        scienceFooter:
          "Кожен інгредієнт має визначену мету. Кожен відсоток відповідає логіці формуляції.",
        previewTitle: "Огляд формул",
        previewCats: "Кішки",
        previewDogs: "Собаки",
        previewKitten: "Кошеня",
        previewAdult: "Доросла особина",
        previewSterilised: "Стерилізована доросла особина",
        previewPuppy: "Цуценя",
        previewSmallBreed: "Доросла особина малих порід",
        previewAllBreeds: "Доросла особина (всі породи)",
        distributorHeading: "Можливості глобальної дистрибуції",
        distributorSubtext:
          "GENOYA™ розширюється через структуровані міжнародні партнерства. Ми забезпечуємо відправку контейнерів 20DC, 40HC та 45ft з повною експортною документацією.",
        getStarted: "Стати партнером GENOYA™",
      },
      about: {
        heroTitle1: "Точне харчування",
        heroTitle2: "Глобальне бачення",
        heroSubtext:
          "GENOYA™ — це науково орієнтований бренд, що створює преміальне харчування, базуючись на чистоті монопротеїну та функціональній ефективності.",
        viewProducts: "Переглянути всі формули",
        missionTitle: "Наша місія",
        missionText:
          "Створювати преміальне харчування для тварин за допомогою науково обґрунтованих систем, що базуються на чистоті єдиного білка та функціональних результатах.",
        valuesTitle: "Наші принципи",
        value1: "Чистота протеїну",
        value1subtext: "Архітектура єдиного тваринного білка у всіх продуктах.",
        value2: "Цілісність харчування",
        value2subtext:
          "Структуровані формули, що відповідають визнаним міжнародним стандартам.",
        value3: "Фокус на функціональному здоров'ї",
        value3subtext:
          "Підтримка травлення, здоров'я суглобів, імунний баланс та метаболічна оптимізація.",
        value4: "Без курки. Без курячих субпродуктів.",
        value4subtext: "Непорушний стандарт бренду GENOYA™.",
        viewOurProducts: "Ознайомитися з продукцією",
        leadershipTitle: "Експертиза та позиціонування",
        leadershipHeadText: " створено професіоналами з досвідом у сферах:",
        leadershipValue1: "Міжнародна торгівля кормами для тварин",
        leadershipValue2: "Нагляд за OEM-виробництвом",
        leadershipValue3: "Розробка архітектури бренду",
        leadershipValue4: "Масштабування дистрибуції",
        leadershipValue5: "Системи маркування згідно з нормативами",
        leadershipTextBelow:
          "працює через структуровані виробничі потужності в Китаї під контролем систем формуляції та якості, розроблених для міжнародної дистрибуції.",
        leadershipTextFinal:
          "Ми будуємо структуровані бренди, розраховані на довгострокове глобальне зростання.",
        noChickenTitle:
          "Суворо без курки. Без субпродуктів курячого походження.",
        noChickenSubtitle:
          "Завжди монопротеїн – наше фундаментальне зобов'язання",
        noChickenText:
          "GENOYA® ніколи не використовує курку або курячі субпродукти в жодній формулі. Ми дотримуємося суворої філософії єдиного білка: одне чисте тваринне джерело на продукт. Це гарантує кращу засвоюваність, прозорий контроль алергій та безпрецедентну чесність перед власниками тварин.",
        complianceTitle: "Декларація про відповідність нормам харчування",
        complianceText:
          "Сформульовано відповідно до рівнів поживності, встановлених визнаними міжнародними стандартами, включаючи профілі AAFCO та настанови FEDIAF для відповідних етапів життя.",
        complianceBold:
          "Наші продукти є повнораціонними та збалансованими для всіх етапів життя.",
      },
      products: {
        heroTitle: "Передові монопротеїнові формули",
        heroSubtext:
          "Точне харчування з єдиним джерелом тваринного білка, адаптоване за видом, етапом життя та функціональними цілями.",
        selectSpecies: "Оберіть вид вашої тварини",
        backToSpecies: "Назад до вибору виду",
        noProductsAvailable: "Продуктів у цій категорії не знайдено.",
        filter: "Фільтр",
        clearFilters: "Очистити фільтри",
        resetFilters: "Скинути все",
        format: "Формат продукту",
        allFormats: "Усі формати",
        formats: {
          dry: "Сухий корм",
          wet: "Вологий корм",
        },
        dryKibble: "Сухі крокети",
        wetFood: "Вологий корм / Паштет",
        ingredient: "Основний протеїн",
        allIngredients: "Усі протеїни",
        lifeStage: "Етап життя",
        allStages: "Усі етапи",
        healthGoal: "Функціональна ціль",
        allGoals: "Усі цілі",
        healthBenefits: "Переваги для здоров'я",
        noResults: "Формул за вашим запитом не знайдено.",
        details: "Деталі формули",
        showLess: "Показати менше",
        collapseAll: "Згорнути все",
        size: "Вага нетто",
        ingredients: "Інгредієнти",
        fullIngredients: "Повний склад",
        standard: "Стандарт виробництва",
        packaging: "Тип упаковки",
        aboutProduct: "ХАРАКТЕРИСТИКИ",
        ingredientsLabel: "СКЛАД (ІНГРЕДІЄНТИ)",
        analysisLabel: "ГАРАНТОВАНИЙ АНАЛІЗ (якщо доступно)",
        nutritionalAdditives: {
          sectionHeader: "Nutritional Additives (per kg)",
          vitamins: "Vitamins",
          traceElements: "Trace Elements",
          functionalAdditives: "Functional Additives",
          prebioticProbioticComplex: "Pre- & Probiotic Complex",
          botanicalExtracts: "Botanical Extracts",

          // Vitamins
          vitaminA: "Vitamin A",
          vitaminD3: "Vitamin D₃",
          vitaminE: "Vitamin E",
          vitaminC: "Vitamin C",
          vitaminB1: "Vitamin B₁",
          vitaminB2: "Vitamin B₂",
          vitaminB6: "Vitamin B₆",
          vitaminB12: "Vitamin B₁₂",
          niacin: "Niacin",
          pantothenicAcid: "Pantothenic Acid",
          folicAcid: "Folic Acid",
          biotin: "Biotin",
          cholineChloride: "Choline Chloride",
          taurine: "Taurine",
          lCarnitine: "L-Carnitine",
          dlMethionine: "DL-Methionine",

          // Trace Elements
          iron: "Iron",
          ferrousSulphate: "Ferrous Sulphate",
          zinc: "Zinc",
          zincSulphate: "Zinc Sulphate",
          manganese: "Manganese",
          manganeseSulphate: "Manganese Sulphate",
          copper: "Copper",
          copperSulphate: "Copper Sulphate",
          iodine: "Iodine",
          calciumIodate: "Calcium Iodate",
          selenium: "Selenium",
          sodiumSelenite: "Sodium Selenite",

          // Functional Additives
          glucosamine: "Glucosamine",
          chondroitinSulphate: "Chondroitin Sulphate",
          yuccaSchidigeraExtract: "Yucca Schidigera Extract",
          cranberryExtract: "Cranberry Extract",

          // Pre- & Probiotic Complex
          inulinFOS: "Inulin (FOS)",
          mos: "MOS",
          betaGlucans: "β-Glucans",
          probiotics: "Probiotics",
          cfu: "CFU",

          // Botanical Extracts
          rosemary: "Rosemary",
          greenTea: "Green Tea",
          turmeric: "Turmeric",
          ginger: "Ginger",
          kelp: "Kelp",
          blueberry: "Blueberry",

          // Units / labels
          iu: "IU",
          mg: "mg",
          perKg: "per kg",
          asLabel: "as",
        },
        categories: {
          cat: "Харчування для котів",
          cats: "Харчування для котів",
          dog: "Харчування для собак",
          dogs: "Харчування для собак",
        },
        stages: {
          adult: "Дорослий",
          adult_small_breed: "Дорослий малої породи",
          sterilised: "Стерилізований",
          dog: {
            junior: "Цуценя",
          },
          cat: {
            junior: "Кошеня",
          },
        },
        sizeCategory: "Розмір / Порода",
        allSizes: "Усі розміри",
        sizes: {
          allBreeds: "Усі породи",
          smallBreed: "Малі породи",
          "all-breeds": "Усі породи",
          "small-breed": "Малі породи",
          mediumBreed: "Середні породи",
          largeBreed: "Великі породи",
          "1kg": "1 kg",
          "3kg": "3 kg",
          "5kg": "5 kg",
          "6kg": "6 kg",
          "9kg": "9 kg",
        },
        healthGoals: {
          digestion: "Здоров'я травлення",
          skin: "Харчування шкіри та шерсті",
          immune: "Підтримка імунітету",
          antioxidant: "Антиоксидантний захист",
          muscle: "Підтримка м'язів",
          joint: "Підтримка суглобів",
          weight: "Контроль ваги",
          urinary: "Здоров'я сечовивідної системи",
          brain: "Здоров'я мозку та когнітивні функції",
          bone: "Розвиток кісток та суглобів",
        },
        goals: {
          digestion: "Травлення",
          skin: "Шкіра та шерсть",
          weight: "Контроль ваги",
          urinary: "Сечовивідна система",
          immune: "Імунітет",
          antioxidant: "Антиоксиданти",
          muscle: "М'язи",
          joint: "Підтримка суглобів",
        },
        flavors: {
          beef: "Яловичина",
          duck: "Качка",
          lamb: "Ягня",
          rabbit: "Кролик",
          turkey: "Індичка",
          whitefish: "Біла риба",
        },
        textures: {
          kibble: "Сухий корм",
          "chunks in jelly": "Шматочки в желе",
        },
        linekey: {
          dailyCare: "Щоденний догляд",
          superfoodPlus: "Суперфуд+",
        },
        animals: {
          dog: "Собака",
          cat: "Кішка",
        },
        description:
          "Преміальна монопротеїнова рецептура з {{flavor}} у форматі {{texture}}, розроблена для {{animal}} (етап життя: {{stage}}).",
        types: {
          dry: "Сухий",
          wet: "Вологий",
        },
        singleProtein: "монопротеїновий",
        grainFree: "беззерновий",
        premiumCompleteFood: "Преміальний повнораціонний збалансований корм",
        frontView: "Вигляд спереду",
        backView: "Вигляд ззаду",
        feedingGuideNotAvailable:
          "Рекомендації з годівлі для цього продукту відсутні.",
        technicalSpecs: "Технічні характеристики",
        keyBenefits: "Ключові функціональні переваги",
        analyticalConstituents: "Аналітичні компоненти",
        feedingGuide: "Рекомендації з годівлі",
        functionalIngredients: "Функціональні інгредієнти та добавки",
        petWeight: "Вага тварини",
        gramsPerDay: "Грамів на день",
        viewBack: "Дивитися задню етикетку",
        viewFront: "Дивитися передню етикетку",
        clickToZoom: "Натисніть на зображення для збільшення",
        analysis: {
          protein: "Сирий білок",
          fat: "Сирий жир",
          fiber: "Сира клітковина",
          ash: "Сира зола",
          omega3: "Омега-3 жирні кислоти",
          omega6: "Омега-6 жирні кислоти",
        },
        netContentLabel: "Вага нетто",
        packagingTypeLabel: "Упаковка",
        standardLabel: "Стандарт",
        pillarNoChicken:
          "Суворо без курки. Без курячих субпродуктів. Завжди монопротеїн.",
        noChickenTitle: "Наша основна обіцянка",
        noChickenText:
          "GENOYA® ніколи не використовує курку чи її субпродукти. Кожна формула базується на чистому джерелі тваринного білка — повноцінному та збалансованому для конкретного етапу життя.",
        filterReinforce:
          "Усі формули повнораціонні та збалансовані — Без курки / Завжди монопротеїн",
        complianceTitle: "Нутрієнтна відповідність",
        complianceText:
          "Сформульовано відповідно до міжнародних стандартів, включаючи профілі AAFCO та настанови FEDIAF для відповідних етапів життя.",
        completeBalanced: "Повнораціонний та збалансований",
        nutritionalAdequacyTitle: "Декларація про харчову адекватність",
        nutritionalAdequacyText:
          "Розроблено відповідно до визнаних настанов AAFCO та FEDIAF. Харчова адекватність базується на аналізі формуляції.",
        regulatoryDisclaimer:
          "AAFCO та FEDIAF є організаціями, що встановлюють нормативні настанови. Продукція GENOYA™ не схвалюється та не сертифікується цими організаціями.",
        tabs: {
          ingredients: "Інгредієнти",
          feeding: "Рекомендації з годівлі",
          nutrition: "Поживна цінність",
          aminoAcids: "Амінокислоти",
        },
        analytical: {
          guaranteedAnalysis: "Гарантований аналіз",
          analyticalValues: "Аналітичні показники",
          metabolisable_energy: "Метаболізована енергія",
          digestibility: "Засвоюваність",
          estimated: "Приблизно",
          crude_protein_min: "Сирий білок (мін)",
          crude_fat_min: "Сирий жир (мін)",
          crude_fibre_max: "Сира клітковина (макс)",
          crude_ash_max: "Сира зола (макс)",
          moisture_max: "Вологість (макс)",
          taurine: "Таурин",
          omega3: "Омега-3 жирні кислоти",
          omega6: "Омега-6 жирні кислоти",
          calcium_min: "Кальцій (мін)",
          calcium_max: "Кальцій (макс)",
          phosphorus_min: "Фосфор (мін)",
          phosphorus_max: "Фосфор (макс)",
          l_carnitine: "L-Карнітин",
          metabolisable_energy_kcal: "Обмінна енергія (ккал/кг)",
          metabolisable_energy_mj: "Обмінна енергія (МДж/кг)",
          omega3_fatty_acids: "Омега-3 жирні кислоти",
          omega6_fatty_acids: "Омега-6 жирні кислоти",
          epa: "EPA",
          dha: "DHA",
          glucosamine: "Глюкозамін",
          chondroitin_sulphate: "Хондроїтину сульфат",
          dl_methionine_ga: "DL-Метіонін",
          sodium: "Натрій",
          magnesium: "Магній",
          potassium: "Калій",
          ca_p_ratio: "Співвідношення кальцію і фосфору",
        },
        fullIngredientList: "Повний список інгредієнтів",
        functionalHighlights: "Функціональні особливості",
        storageShelfLife: "Зберігання та термін придатності",
        storageText:
          "ТЕРМІН ПРИДАТНОСТІ: 18 місяців з дати виробництва.\nЗБЕРІГАННЯ ТА БЕЗПЕКА\nЗберігати в прохолодному, сухому місці.\nЩільно закрити після відкриття.\nНе заморожувати.",
        storageTextWet:
          "ТЕРМІН ПРИДАТНОСТІ: 3 роки (не відкритий з дати виробництва).\nЗБЕРІГАННЯ ТА БЕЗПЕКА\nЗберігати в прохолодному, сухому місці, подалі від прямих сонячних променів.\nПісля відкриття зберігати в холодильнику та вжити протягом 5 днів.\nНе заморожувати.",
        functionalIngredientsText:
          "ФУНКЦІОНАЛЬНІ ІНГРЕДІЄНТИ\n- Інулін (ФОС): Підтримує баланс мікробіому\n- МОС: Допомагає блокувати шкідливі кишкові бактерії\n- β-Глюкани: Підтримує імунну функцію\nЛососяча олія: EPA і DHA підтримують розвиток мозку та зору\nDL-Метіонін: Підтримує здоров'я сечовивідних шляхів\nТаурин: Необхідний для росту кішок, підтримки серця та зору",
        complianceTemplates: {
          kitten_cat:
            "{{name}} сформульовано для відповідності рівням поживних речовин, встановленим Профілями поживних речовин котячого корму AAFCO для Росту та Розмноження, і відповідає керівним принципам харчування FEDIAF щодо повноцінного та збалансованого корму для кошенят.",
          adult_cat:
            "{{name}} сформульовано для відповідності рівням поживних речовин, встановленим Профілями поживних речовин котячого корму AAFCO для Підтримання дорослих, і відповідає керівним принципам харчування FEDIAF щодо повноцінного та збалансованого корму для дорослих кішок.",
          sterilised_cat:
            "{{name}} сформульовано для відповідності рівням поживних речовин, встановленим Профілями поживних речовин котячого корму AAFCO для Підтримання дорослих, і відповідає керівним принципам харчування FEDIAF щодо повноцінного та збалансованого корму для стерилізованих дорослих кішок.",
          smallbreed_puppy:
            "{{name}} сформульовано для відповідності рівням поживних речовин, встановленим Профілями поживних речовин собачого корму AAFCO для Росту, і відповідає керівним принципам харчування FEDIAF щодо повноцінного та збалансованого корму для цуценят малих порід.",
          medlarge_puppy:
            "{{name}} сформульовано для відповідності рівням поживних речовин, встановленим Профілями поживних речовин собачого корму AAFCO для Росту, і відповідає керівним принципам харчування FEDIAF щодо повноцінного та збалансованого корму для цуценят середніх та великих порід.",
          adult_small_dog:
            "{{name}} — це функціональний корм без зерна з єдиним тваринним білком, сформульований для задоволення поживних потреб дорослих собак малих порід. Виготовлений виключно з {{protein}} як єдиним джерелом тваринного білка, він підтримує збереження м'язової маси, здоров'я шкіри та шерсті, травлення, імунну функцію та загальну життєвість. Без птиці, зерна, сої та штучних консервантів. Повноцінний та збалансований корм для дорослих собак малих порід.",
          adult_allbreed_dog:
            "{{name}} — це функціональний корм без зерна з єдиним тваринним білком, сформульований для задоволення поживних потреб дорослих собак усіх порід. Виготовлений виключно з {{protein}} як єдиним джерелом тваринного білка, він підтримує збереження м'язової маси, здоров'я шкіри та шерсті, травлення, імунну функцію та загальну життєвість. Без птиці, зерна, сої та штучних консервантів. Повноцінний та збалансований корм для дорослих собак.",
        },
        complianceStatement: "Заява про відповідність",
        nutritionalAdditivesPerKg: "Харчові добавки (на кг)",
        vitamins: "Вітаміни",
        traceElements: "Мікроелементи",
        functionalAdditives: "Функціональні добавки",
        prebioticProbioticComplex: "Пре- і Пробіотичний комплекс",
        botanicalExtracts: "Рослинні екстракти",
        aminoAcids: {
          lysine: "Лізин",
          methionine: "Метіонін",
          threonine: "Треонін",
          tryptophan: "Триптофан",
          leucine: "Лейцин",
          isoleucine: "Ізолейцин",
          valine: "Валін",
          histidine: "Гістидін",
          phenylalanine: "Фенілаланін",
          arginine: "Аргінін",
        },
        aminoAcidProfile: "Профіль незамінних амінокислот",
        aminoNote:
          "† Приблизні значення. Таурин доданий як харчова добавка на заявленому мінімальному рівні.",
        feeding: {
          day: "день",
          can: "банка",
          cans: "банки",
          dryNote:
            "Зазначені кількості є щоденними нормами. Розділіть на 2–3 годування. Завжди забезпечуйте свіжою водою.",
          kitten__2_4months: "Кошеня (2–4 міс.)",
          kitten__4_6months: "Кошеня (4–6 міс.)",
          junior_7_12months: "Юніор (7–12 міс.)",
          puppy___2_4_months: "Цуценя (2–4 міс.)",
          puppy___4_9_months: "Цуценя (4–9 міс.)",
          junior__7_9_months: "Юніор (7–9 міс.)",
          junior__9_12_months: "Юніор (9–12 міс.)",
          junior___9_12_months: "Юніор (9–12 міс.)",
          junior___12_15_months: "Юніор (12–15 міс.)",
          junior__15_20_months: "Юніор (15–20 міс.)",
          adult_cat__1_3_yrs: "Доросла кішка (1–3 р.)",
          adult_cat__3_7_yrs: "Доросла кішка (3–7 р.)",
          adult_cat__7__yrs: "Доросла кішка (7+ р.)",
          adult_dog__1_3_yrs: "Доросла собака (1–3 р.)",
          adult_dog___3_7_yrs: "Доросла собака (3–7 р.)",
          adult_dog__7__yrs: "Доросла собака (7+ р.)",
          "1_3_yrs": "1–3 р.",
          "3_7_yrs": "3–7 р.",
          "7__yrs": "7+ р.",
          stage_label: "Стадія життя",
        },
      },
      distributors: {
        emailLabel: "Ел. пошта",
        websiteLabel: "Вебсайт",
        heroTitle: "Міжнародне партнерство та дистрибуція",
        heroSubtext:
          "GENOYA® — це структурований глобальний бренд преміум-класу, орієнтований виключно на довгострокову дистрибуцію та OEM-партнерство.",
        contactUs: "Зв'язатися з відділом експорту",
        exportTitle:
          "Можливості глобального експорту та завантаження контейнерів",
        fcl: "Доступне повне завантаження контейнера (FCL)",
        fclDesc:
          "Підтримка контейнерів 20DC / 40HC / 45FT з координацією доставки по всьому світу.",
        mixedSku: "Завантаження змішаних артикулів (SKU)",
        mixedSkuDesc:
          "Гнучка конфігурація палет для декількох варіантів продукції.",
        compliance: "Нормативна відповідність та контроль якості",
        complianceDesc:
          "Повний нагляд для забезпечення відповідності вимогам цільових ринків.",
        palletStandards: "Стандарти палет, що підтримуються",
        eurPallets: "Європалети / EPAL (1200 × 800 мм)",
        ukPallets: "Стандартні палети Великобританії (1200 × 1000 мм)",
        usPallets: "Палети США GMA (48” × 40”)",
        whyPartnerTitle: "Чому варто стати партнером GENOYA®",
        benefitScience: "Науково обґрунтовані формули",
        benefitScienceDesc:
          "Повноцінне монопротеїнове харчування згідно з AAFCO/FEDIAF.",
        benefitSingleProtein: "Сувора філософія єдиного білка",
        benefitSingleProteinDesc:
          "Без курки, без субпродуктів; чистий тваринний білок, що відстежується.",
        benefitProduction: "Масштабоване виробництво для експорту",
        benefitProductionDesc:
          "Повне завантаження контейнерів з можливістю змішування артикулів.",
        benefitLongTerm: "Стратегічне довгострокове партнерство",
        benefitLongTermDesc:
          "Цілісність бренду та віддана підтримка дистриб'юторів.",
        officialOversight: "Офіційний нагляд за експортом та виробництвом",
        oversightText:
          "Міжнародна торговельна діяльність та нагляд за OEM-виробництвом GENOYA® керуються нашим експортним підрозділом для забезпечення:",
        oversight1: "Відповідності нормативним вимогам на міжнародних ринках",
        oversight2: "Координації експорту FCL (20DC / 40HC / 45FT)",
        oversight3: "Нагляду за виробництвом та контролю якості",
        oversight4: "Цілісності бренду та відповідності формул",
        oversight5: "Управління глобальним дистриб'юторським партнерством",
        exportContact: "Департамент експорту та міжнародної торгівлі",
        exportEntity: "Офіційний експортний підрозділ",
        founder: "Засновник та глобальний керуючий директор",
        registeredAddress: "Юридична адреса",
        inquiryTitle: "Подати заявку на партнерство",
        inquiryDesc:
          "Ми вітаємо запити від національних імпортерів, регіональних дистриб'юторів та стратегічних партнерів.",
        finalCtaTitle: "Готові до партнерства з GENOYA®?",
        finalCtaDesc:
          "Приєднуйтесь до нашої глобальної мережі преміальних дистриб'юторів.",
        contactExport: "Зв'язатися з відділом експорту",
        becomePartner: "Надіслати запит",
        form: {
          companyName: "Назва компанії / Юридична особа",
          country: "Основний ринок / Країна",
          businessType: "Тип бізнесу",
          select: "Оберіть тип",
          nationalImporter: "Національний імпортер",
          regionalDistributor: "Регіональний дистриб'ютор",
          premiumRetail: "Преміальна роздрібна мережа",
          vetChannel: "Ветеринарний / Професійний канал",
          oem: "OEM партнер / Власна торгова марка",
          volume: "Орієнтовний річний обсяг",
          volumePlaceholder: "напр., 10–50 контейнерів / рік",
          containerInterest: "Бажаний розмір контейнера (якщо відомо)",
          email: "Робоча ел. пошта",
          phone: "Телефон (з кодом країни)",
          submit: "Надіслати заявку на партнерство",
        },
      },
      contact: {
        phone: "Телефон",
  country: "Країна",
  optional: "необов'язково",
  selectCountry: "Оберіть вашу країну",
  messagePlaceholder: "Чим ми можемо вам допомогти?",
  sending: "Надсилання...",
  sendAnother: "Надіслати ще одне повідомлення",
  operatedBy: "Операційна компанія",
  searchCountries: "Пошук країн...",
  noResults: "Немає результатів",
        title: "Зв'яжіться з GENOYA™",
        generalTitle: "Загальні запити",
        generalDesc: "Для отримання інформації про продукцію та бренд:",
        partnershipTitle: "Запити на дистрибуцію",
        partnershipDesc:
          "Для ділового партнерства та можливостей розповсюдження:",
        formName: "Повне ім'я",
        formEmail: "Ел. адреса",
        formMessage: "Повідомлення",
        sendButton: "Надіслати повідомлення",
        name: "Ім'я",
        email: "Ел. пошта",
        message: "Повідомлення",
        send: "Надіслати",
        successTitle: "Повідомлення успішно надіслано",
        successDesc:
          "Дякуємо за звернення. Наша команда зв'яжеться з вами найближчим часом.",
      },
      nav: {
        home: "Головна",
        about: "Про нас",
        products: "Формули",
        distributors: "Дистриб'юторам",
        contact: "Контакти",
        toggleMenu: "Перемкнути навігацію",
      },
      footer: {
        brandName: "Genoya",
        contactEmail: "info@genoya.com",
        linkedin: "LinkedIn",
        rights: "© 2026 GENOYA™. Усі права захищені.",
        tagline: "Наукова формула. Чистий протеїн.",
        quickLinks: "Навігація",
        global: "Глобальна діяльність",
        languages: "Вибір мови",
        distributorInfo: "Експортні специфікації",
        email: "Контактна ел. пошта",
        legal: "Відповідність нормам",
        privacy: "Політика конфіденційності",
        terms: "Умови використання",
      },
      privacy: {
        label: "Правова інформація",
        title: "Політика конфіденційності",
        lastUpdated: "Останнє оновлення: березень 2026 р.",
        intro:
          "GENOYA™ прагне захистити вашу особисту інформацію. Ця Політика конфіденційності пояснює, які дані ми збираємо під час відвідування genoyapetfood.com, як ми їх використовуємо та які права ви маєте щодо цих даних.",
        informationCollectedTitle: "Інформація, яку ми збираємо",
        info1: "Контактні форми: ім'я, адреса електронної пошти, назва компанії, країна та зміст повідомлення.",
        info2: "Дані використання: відвідані сторінки, час на сайті, тип браузера та інформація про пристрій, зібрані за допомогою аналітичних інструментів.",
        info3: "Файли cookie та аналогічні технології для забезпечення продуктивності сайту та аналітики.",
        howWeUseTitle: "Як ми використовуємо вашу інформацію",
        use1: "Для відповіді на запити дистриб'юторів і подання контактних форм.",
        use2: "Для аналізу продуктивності веб-сайту та покращення досвіду користувача.",
        use3: "Для виконання юридичних зобов'язань.",
        use4: "Ми не продаємо, не здаємо в оренду та не передаємо вашу особисту інформацію третім сторонам.",
        dataRetentionTitle: "Зберігання даних",
        dataRetentionText:
          "Ми зберігаємо дані контактних форм протягом часу, необхідного для відповіді на ваш запит, а також протягом розумного терміну для цілей ведення записів.",
        thirdPartyTitle: "Сторонні сервіси",
        thirdPartyText:
          "Наш веб-сайт може використовувати сторонні сервіси, такі як аналітичні провайдери. Ці сервіси можуть збирати дані відповідно до власної політики конфіденційності.",
        cookiesTitle: "Файли cookie",
        cookie1: "Ми використовуємо основні файлы cookie, необхідні для коректної роботи сайту.",
        cookie2: "Аналітичні файли cookie можуть використовуватися для розуміння того, як відвідувачі взаємодіють із сайтом. Ви можете вимкнути файли cookie в налаштуваннях браузера.",
        yourRightsTitle: "Ваші права",
        right1: "Ви маєте право запросити доступ до персональних даних, які ми про вас зберігаємо.",
        right2: "Ви можете в будь-який час вимагати виправлення або видалення своїх даних.",
        right3: "Для реалізації цих прав зв'яжіться з нами за електронною адресою, вказаною нижче.",
        changesTitle: "Зміни в політиці",
        changesText:
          "Ми можемо час від часу оновлювати цю Політику конфіденційності. Актуальна версія завжди буде доступна на цій сторінці із зазначенням дати оновлення.",
        contactText: "З питань конфіденційності звертайтеся до нас за адресою",
      },
      terms: {
        label: "Правова інформація",
        title: "Умови використання",
        lastUpdated: "Останнє оновлення: березень 2026 р.",
        intro:
          "Використовуючи веб-сайт GENOYA™ (genoyapetfood.com), ви погоджуєтесь дотримуватися цих Умов використання. Будь ласка, уважно прочитайте їх перед використанням сайту.",
        acceptanceTitle: "Прийняття умов",
        acceptanceText:
          "Використання цього веб-сайту означає прийняття цих Умов використання. Якщо ви не погоджуєтесь із будь-якою частиною цих умов, будь ласка, не використовуйте сайт.",
        useOfSiteTitle: "Використання веб-сайту",
        use1: "Ви можете використовувати цей сайт лише в законних цілях і відповідно до цих умов.",
        use2: "Забороняється використовувати сайт будь-яким способом, що може пошкодити його, вивести з ладу або заважати іншим користувачам.",
        use3: "Забороняється намагатися отримати несанкціонований доступ до будь-якої частини сайту або його систем.",
        use4: "Комерційне використання вмісту сайту без попереднього письмового дозволу GENOYA™ заборонено.",
        intellectualPropertyTitle: "Інтелектуальна власність",
        intellectualPropertyText:
          "Весь вміст цього веб-сайту — включаючи тексти, зображення, логотипи, назви продуктів, формули та дизайн — є власністю GENOYA™ і захищений чинним законодавством про інтелектуальну власність.",
        disclaimerTitle: "Відмова від гарантій",
        disclaimerText:
          "Цей веб-сайт та його вміст надаються «як є» без будь-яких явних або неявних гарантій. GENOYA™ не гарантує безперебійну, безпомилкову або безпечну роботу сайту.",
        limitationTitle: "Обмеження відповідальності",
        limitationText:
          "У максимальній мірі, дозволеній законом, GENOYA™ не несе відповідальності за будь-які непрямі, випадкові, спеціальні або послідовні збитки, що виникли внаслідок використання або неможливості використання цього сайту.",
        thirdPartyLinksTitle: "Посилання на третіх осіб",
        thirdPartyLinksText:
          "Цей веб-сайт може містити посилання на сторонні сайти. GENOYA™ не контролює їх вміст або практики і не несе за них відповідальності.",
        governingLawTitle: "Застосовне право",
        governingLawText:
          "Ці Умови використання регулюються та тлумачаться відповідно до чинного міжнародного комерційного права. Будь-які суперечки вирішуватимуться шляхом сумлінних переговорів між сторонами.",
        changesTitle: "Зміни умов",
        changesText:
          "GENOYA™ залишає за собою право змінювати ці Умови використання в будь-який час. Продовження використання сайту після публікації змін означає прийняття оновлених умов.",
        contactText: "З питань, пов'язаних із цими Умовами використання, звертайтеся до нас за адресою",
      },
    },
  },
};

export default resources;
